import * as React from "react"
import styled from "styled-components"

const Svg = styled.svg`

width: 100%;
height: fit-content;
`
function SvgComponent(props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={577}

      viewBox="0 0 577 382"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF8F8"
        d="M155.41 54.909c1.981.383 3.668.169 5.584-.952 9.998-5.848 20.566-10.329 31.825-13.307 4.876-1.29 9.66-2.957 14.642-3.882 1.587-1.948 4.144-.859 6.015-1.918l-.005.005c4.099-2.229 8.672-1.378 13.018-2.001 9.808-.015 19.619.126 29.422-.079 15.653-.327 30.978 1.691 46.085 5.7 1.726.458 3.622.273 5.438.386 2.197 2.514 5.489.627 7.978 1.978.619.311 1.122.747 1.433 1.375.007 1.806.888 3.07 2.464 3.897.915.685 1.648 1.495 1.876 2.662.22 1.043-1.187 3.39 1.783 2.191.599-.318 1.194-.628 1.823-.877a7.274 7.274 0 011.346-.34c1.635-.179 3.273-.157 4.913-.155 1.872.407 3.692-.525 5.56-.225.468.036.921.14 1.355.318 2.887 1.466 6.248 1.877 8.849 3.978 1.556 1.259-.454 6.876 4.657 3.793 1.499-.259 2.859.217 4.211.756 6.94 4.039 13.231 8.943 18.88 14.631 1.566 1.576 3.674 3.063 3.303 5.81 2.295 1.921 5.627.876 7.975 2.904 1.48 1.279 3.193 2.088.936 4.072-5.9.965-11.971.562-17.76 2.342-13.927.601-27.861.097-41.791.289-2.122.029-4.341-.408-6.282.918-1.287 1.285-2.853 2.037-4.621 2.4a4.554 4.554 0 01-2.561-.396c-1.734-1.421-3.693-1.887-5.96-1.917-7.778-.104-15.557.097-23.33-.129-4.117-1.335.716 3.175-1.852 2.85a3.071 3.071 0 01-1.612.437c-3.374-.568-6.915.364-10.191-1.12-1.454-1.015-3.121-1.044-4.795-1.046-17.812-.019-35.625-.03-53.437.009-1.333.003-2.671.013-3.881.682-1.282.9-2.937.94-4.221 1.826-2.221 1.44-1.371 4.248-2.693 6.088-2.801 1.437-3.9-.997-5.247-2.471-8.197-8.967-16.118-18.191-25.109-26.405-1.597-1.459-3.045-3.083-4.884-4.263a16.854 16.854 0 01-2.52-2.299c-.577-.644-1.021-1.38-1.454-2.119-.498-.992-1.447-1.326-2.42-1.631a5.684 5.684 0 01-1.145-.582c-1.19-1.403-3.903-1.502-3.6-4.183zM445.315 78.981c6.266 2.789 13.135 3.419 19.645 5.5 13.213 4.226 26.135 8.846 38.043 16.038.402.243.957.237 1.439.347.932.774 2.234.984 3.018 1.985 1.029 1.254 2.404 1.828 3.973 2.021 1.697 1.3 3.256 2.775 5.035 3.969 3.656 2.672 7.314 5.343 10.971 8.014 1.561 1.11 3.207 2.13 4.029 3.985 3.711 4.28 7.457 8.524 11.941 12.036 2.064 2.628 4.244 5.17 6.033 8.006.006.319.014.64.025.96.77.931.979 2.233 1.994 3.001 2.344 3.827 5.398 7.296 6.018 11.987 0-.002-.008.01-.002-.001 1.674 2.498 3.939 4.703 3.98 8.013-2.945 2.409-5.635.521-8.379-.489-.822-.082-1.645-.101-2.473-.082-18.025-2.286-36.109-.058-54.158-.697-3.928-.14-7.865 1.377-11.834.213-2.633-1.943-.656-2.458.98-2.942 5.588-1.653 5.828-2.005 3.23-7.428-3.934-8.213-10.035-14.218-18.57-17.62a6.412 6.412 0 01-1.258-.691c-1.797-1.979-4.912-2.114-6.387-4.55-2.148-5.242-2.131-10.931-3.35-16.37-1.592-7.103-4.955-13.583-6.842-20.563-.246-1.541-.17-3.222-1.805-4.174-2.193-3.274-5.995-5.735-5.296-10.468z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A4EFEC"
        d="M491.454 306.665c-7.654 1.809-14.783 5.247-22.473 7.027-8.988 2.081-17.955 4.099-27.133 5.225-8.703 1.067-17.369 2.347-26.172 2.011-2.395-1.356-2.535-3.945-3.379-6.154-.654-2.617-1.404-5.229-.775-7.97.949-9.269 1.369-18.494-2.17-27.403-.383-.635-.541-1.322-.438-2.06.209-.882.902-1.535 1.15-2.402.182-.893.17-1.796.154-2.704-.037-1.021-.043-2.033.074-3.051.174-1.143.564-2.166 1.541-2.877 4.141-1.692 8.475-.677 12.713-.93 7.424.652 14.684-.661 21.941-1.932 2.209-.91 3.449-4.688 6.994-1.889 1.162.919 1.877-1.413 2.246-2.558.729-2.251-.354-3.823-2.322-4.892a3.094 3.094 0 01-.688-1.213 3.936 3.936 0 01.188-2.106c.953-1.647 1.889-3.314 3.559-4.38a4.17 4.17 0 011.344-.354c3.381.793 6.641-.768 9.996-.558 3.17-.33 3.355-2.521 3.15-4.988-.352-4.213.168-8.407.285-12.615 1.396-1.218 2.805-.458 4.213-.039 1.453.718 3.295.748 4.275 2.333.225 1.093.963 1.855 2.006 1.786 3.922-.263 5.047 2.076 5.277 5.365.07.453.072.91.031 1.366a14.83 14.83 0 01-.959 3.184c-.727 1.437-1.893 2.812-.594 4.519.459.518.961.981 1.461 1.46 2.154 2.059 1.754 4.76 1.877 7.333-.004 2.705.025 5.409-.025 8.112-.029 1.065-.186 2.104-.682 3.062a1.65 1.65 0 01-1.172.782c-.41-.078-.621-.267-.547-.544.176-.643.025-.983.088-.333.465 4.862.041 9.748.424 14.61.01.122.174.256.297.341.309.215.455.054.424-.456.951-.611 1.754-.454 2.434.436.867 1.707.754 3.545.76 5.368.172 2.555-.646 5.229.963 7.609.297.484.51.994.674 1.534.355 3.714 1.421 7.493-1.01 10.945zM82.345 288.895c-7.388-4.095-13.126-10.142-18.984-16.047a9.155 9.155 0 01-3.903-3.891l-1.977-2.12c-2.01-1.522-3.473-3.419-4.045-5.923-8.071-11.44-14.243-23.865-17.388-37.481-1.466-6.35-3.345-12.851-2.564-19.584.567-.815 1.111-1.656 2.176-1.911a7.65 7.65 0 011.506-.298c.784-.09 1.57-.116 2.358-.158 2.943.064 5.93-.436 8.786.665 3.514 2.53 1.791 6.199 2.047 9.393.437-5.844-.565-11.613-.264-17.406.103-1.982-.012-3.983.895-5.847 1.45-2.098.979-4.493 1.08-6.795.32-7.302-.659-14.637.556-21.915.398-.802 1.046-1.24 1.938-1.309 2.487 1.517 4.805.565 7.119-.529 4.455-.527 8.92-.18 13.377-.261 2.816-.051 5.198.793 6.917 3.144.32.54.538 1.117.672 1.729.516 16.768.088 33.54.233 50.294.018.522.031 1.061.055 1.584.161 2.355 2.632 3.383 3.218 5.506.348 2.104-.976 3.59-1.921 5.218-1.021 1.473-2.174 2.878-2.421 4.749-.857 3.152-.388 6.297.055 9.438.32 1.799 1.267 3.373 1.841 5.078 1.229 3.352 4.664 5.384 5.417 9.013.125 1.034.579 1.78 1.736 1.912a3.9 3.9 0 011.19.545c.559.477.927 1.059 1.084 1.776-.004 2.514-.348 4.974-1.104 7.377-.192.48-.436.932-.71 1.367-1.133 5.449-.089 10.975-.6 16.437-.048.496-.17.98-.343 1.448-.982 1.938-2.83 3.114-4.202 4.717a3.575 3.575 0 01-1.201.693c-.964.179-1.822-.103-2.629-.608z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#76F2DA"
        d="M91.556 74.641l-.192-1.785c-1.433-1.049-1.198-2.808-1.795-4.213-1.329-3.254-.183-6.534-.105-9.803-.173-5.275 2.625-8.518 7.204-10.543.478.07.89.284 1.244.609 2.786 4.551 4.477 9.813 8.688 13.449 1.523 1.396 2.971 2.849 3.488 4.955 4.447 9.203 11.766 16.008 19.058 22.831 6.781 6.023 14.086 11.307 22.068 15.637 5.439 2.859 11 5.498 16.14 8.891 2.062 1.36 4.339 2.527 5.393 4.992-.678 3.566-4.438 3.437-6.474 5.383-1.344 1.284-4.342 1.387-3.978 3.72.312 1.999 2.976 2.235 4.682 3.113.725.373 1.535.564 2.313.841.487.135.953.308 1.421.489 5.339.54 10.678.241 16.016.156 1.118-.17 2.188-.599 3.339-.59 7.884 1.983 11.809 6.76 11.747 14.626-.053 6.912.406 13.835-.283 20.736-1.201 3.169-3.692 2.174-5.737 1.483-3.693-1.246-7.36-2.584-11.058-3.814-5.369-2.49-11.05-4.267-16.315-7.006-3.118-1.303-6.213-2.659-9.229-4.195-1.325-1.192-4.187-1.083-3.452-4.035 1.056-.847 2.321-.948 3.595-1.021 3.164.304 6.116-.502 8.971-1.75 1.47-.509 1.924-1.228.473-2.346-2.141-1.145-3.953-2.831-6.28-3.644-14.559-7.088-30.062-11.754-45.085-17.641-6.665-2.612-13.425-5.045-19.333-9.188-4.565-3.203-4.383-6.669.289-9.788 1.818-1.214 3.899-1.876 5.904-2.677 3.135-1.251 3.303-2.918.865-5.07-5.562-6.983-11.142-13.958-13.582-22.802z"
      />
      <path
        className="plantas"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#76F3DB"
        d="M453.411 92.901c5.111 12.172 8.496 24.8 10.012 37.922-.533.567-1.211.708-1.951.675-1.58-.299-3.188-.436-4.781-.649-1.484-.328-2.965-.763-4.488-.172-1.516.374-3.115.369-4.551 1.077-2.16.68-3.746 3.163-6.469 2.08-.625-.755-.805-1.664-.908-2.593-.07-1.947-.801-2.51-2.455-1.148-4.246 2.22-2.955-1.337-3.324-3.17-.004-1.552.697-2.919 1.133-4.354 1.926-6.864 4.795-13.322 8.404-19.457 1.709-1.916 2.873-4.31 5.021-5.848-1.859 1.251-3.32 2.861-4.32 4.887-4.125 6.108-6.912 12.818-8.977 19.861-2.092 2.659.256 7.265-3.953 8.99-1.836-1.249-1.172-3.143-1.262-4.846.975-10.902.193-21.824.426-32.729-1.389-5.181-1.139-10.411-.777-15.646-.324 5.209-.678 10.419.734 15.586.258 13.74-.139 27.477-.158 41.214-.004 3.856-.096 7.919-2.512 11.343-2.301-.406-2.117-2.317-1.971-3.81.291-2.978-.395-5.853-.506-8.771-1.201-2.076-1.113-4.436-1.572-6.679.629 2.22.191 4.671 1.619 6.722.1 2.099.289 4.186.418 6.279-.25.816-.738 1.396-1.596 1.604-1.303.002-1.5-.94-1.738-1.938-1.449-6.049-3.838-11.784-5.904-17.621-1.373-2.905-2.678-5.847-3.787-8.873 1.053 3.104 2.414 6.078 3.773 9.061 3.121 8.215 6.105 16.484 8.318 24.972 2.805 10.752 1.625 21.453-1.459 32.003-1.064 6.06-3.48 11.808-4.135 17.965a7.518 7.518 0 01-.744 2.34c-.916 1.178-1.408 2.57-2.008 3.913-.496 1.114-.57 3.005-2.268 2.609-1.387-.323-1.439-2.054-1.494-3.356-.172-4.069.277-8.211-1.557-12.063-1.176-4.54-3.842-8.462-5.359-12.87-.385-25.685-.348-51.364-.043-77.039.307-1.982 1.43-3.666 2.055-5.531 1.213-2.186 1.803-4.612 2.598-6.96 2.537-3.465 4.004-7.47 5.709-11.357 2.324-2.107 1.398-6.206 4.719-7.702 1.303-2.416 3.008-4.706 3.809-7.278 1.043-3.344 2.295-2.44 3.967-.758 4.041 4.065 8.072 8.142 12.105 12.214 1.508.439 1.77 1.764 2.137 3.013.113 1.352.898 2.258 1.975 2.969 1.455 3.654 3.799 6.764 6.07 9.918 1.404.964.972 2.858 2.025 4.001z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A4EFEC"
        d="M547.393 264.794a9312.13 9312.13 0 01-4.92 6.065c-1.705 4.489-5.367 7.173-9.068 9.817-6.689 4.249-12.311 9.974-19.215 13.936-.863.495-1.582 1.222-2.67 1.166-1.352-1.189-1.213-2.688-.891-4.226a5.71 5.71 0 01.615-1.303c1.385-2.08 1.283-4.24.322-6.444a3.807 3.807 0 01-.48-1.29c.045-.47.24-.863.604-1.169 5.898-1.349 2.082-5.06 1.898-7.885-.076-4.535-1.643-8.78-2.564-13.145a21.49 21.49 0 01-.428-1.285c-.408-1.264-.982-2.459-1.572-3.648a7.73 7.73 0 01-.469-1.249c-.486-2.178-.902-4.38-2.322-6.215-2.016-3.216-3.396-6.729-4.869-10.207-.357-5.682-.609-11.358.125-17.027 3.389-3.68 6.576-3.745 12.164-.259 1.434 1.801.719 4.421 2.344 6.154a9.82 9.82 0 01.854 1.99c3.621 6.446 9.813 5.132 15.4 4.723 4.613-.339 5.713-4.352 6.516-8.188 1.762-1.931.584-3.689-.328-5.461-1.139-2.217-2.141-4.507-3.482-6.619-.309-.609-.494-1.258-.611-1.92-.195-1.752-1.348-1.845-2.43-1.059-2.389 1.735-4.646.917-6.971.022-3.354.056-5.799-1.861-8.248-3.794-.385-.779-.523-1.613-.639-2.464-.236-2.825-.172-5.648-.131-8.468.109-7.365 1.5-8.8 8.73-8.886 6.307-.074 12.613-.028 18.912-.02a7.402 7.402 0 011.746.089c4.836 1.09 4.578 4.979 4.525 8.586-.051 3.372.262 6.308 4.354 7.007.307.128.631.244.885.448 2.072 1.663 5.836-.03 6.965 3.001 1.207 3.235 1.393 6.79 1.178 10.264-.094 1.509-.426 2.955.57 4.283.277.476.457.982.559 1.521.209 2.472.178 4.916-.826 7.249l.02.01c-1.967 2.32-.748 5.47-2.072 7.957.402 2.911-2.355 4.999-2.057 7.884-.82 2.949-2.629 5.406-4.014 8.074l.01-.024c-1.576 4.738-5.058 8.2-8.019 12.009z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF8F8"
        d="M105.623 96.719c1.797.873 3.731 1.892 3.572 4.143-.15 2.112-2.479 1.846-3.895 2.521-2.238 1.068-4.692 1.771-6.764 3.087-4.015 2.55-3.919 4.803.111 7.448 7.47 4.901 15.891 7.721 24.148 10.888 12.248 4.696 24.507 9.362 36.746 14.082 1.352.521 2.6 1.313 3.896 1.979 3.662 5.898 2.494 8.785-4.012 9.915l-3.938.018c-.229.037-.457.074-.685.115-.666.033.171-.01-.482.095-2.007.321-4.75-.904-5.824 1.415-1.227 2.652 1.209 4.448 2.723 6.319.368.315.705.654 1.04 1.002 2.695 2.592 5.649 4.927 8.002 7.841 1.022 1.266 2.817 2.838-.021 4.23-6.171 1.358-12.198-1.263-18.357-.627-2.466.254-4.996-.134-7.414.704-7.331-.082-14.446 2.375-21.812 1.871-2.512-1.629-3.81-4.59-6.934-5.731-1.798-.657-1.6-2.945-.934-4.742 1.292-1.919 3.348-1.711 5.232-1.711 2.279-.001 4.136-.52 5.084-2.813 3.965-2.899 4.114-4.208.781-6.982-2.297-.839-3.641-2.74-5.163-4.484-2.693-3.086-6.134-4.826-10.151-3.479-8.395 2.815-15.901-.194-23.505-2.977-.685-.984-.784-2.137-.938-3.279-.202-1.501-.377-3.083-2.457-3.019-1.838.058-2.32 1.419-2.835 2.907-1.708 4.937-2.24 5.127-6.181 2.65-4.121-2.767-4.547-6.927-4.274-11.35 8.927-9.786 19.637-17.276 30.963-23.956.881-.521 1.685-.988 2.137-1.922.957-1.407 2.756-1.163 3.987-2.034l.001.001c2.439-1.925 4.877-3.853 8.153-4.125z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#28A0E9"
        d="M409.624 278.466c.58.175 1.615.251 1.676.537 1.988 9.223 3.387 18.486 1.191 27.892-.244-.036-.494-.577-.484-.388.242 4.183-2.777 8.313-.215 12.515.213.395.377.811.514 1.237.463 2.101.541 4.297 1.543 6.262 2.184 1.51 3.092 3.493 2.268 6.121a5.574 5.574 0 01-.709 1.17c-1.875 2.137-2.516 4.362-1.436 7.236 1.172 3.115 1.365 6.465-.213 9.56-.543 1.065-.4 1.685.09 2.647.959 1.884.535 3.499-1.473 4.51-1.363.373-2.482 1.504-4.033 1.314-.953-.485-1.498-1.3-1.859-2.271-.539-2.236-1.375-4.383-2.016-6.593-1.596-8.913-3.084-17.845-5.031-26.687-.639-4.213-2.084-8.183-3.695-12.099-.857-2.168-1.811-4.292-3.105-6.238-.537-.578-1.127-1.561-1.941-.972-1.516 1.096-1.473 2.682-.9 4.38 1.213 3.596.107 5.954-3.814 6.645-.473-.256-.652-.738-.891-1.177.021.628.609.903.871 1.401.611 1.528.008 2.691-1.061 3.724-4.549 2.882.281 2.982 1.264 4.226.809 1.959.689 3.973.383 5.995a4.759 4.759 0 01-.592 1.343c-1.105.976-2.232 1.148-3.514.115 1.393 1.71 2.463 3.552 2.162 5.862a5.856 5.856 0 01-.527 1.995c-1.014 1.261-1.412 2.756-1.617 4.325-.125.701-.426 1.307-.949 1.794-.777 1.33-1.557 2.66-2.336 3.99-4.273-.685-1.881 2.382-2.197 3.915-.016.45-.143.871-.383 1.254-2.355.499-2.641 2.256-2.553 4.246-.387.967-1.086 1.608-2.032 2.009-2.994.182-5.268-.757-6.121-3.916.037-3.234-.025-6.484 1.412-9.512 1.082-6.221 1.779-12.544 3.383-18.628 1.135-4.306-.439-4.613-3.961-4.603-29.479.092-58.958.064-88.438.041-8.823-.007-17.646-.113-26.47-.174.03-.696.36-1.194.99-1.498 8.103-1.211 16.269-.582 24.395-.66 19.311-.188 38.627-.26 57.938.102 5.303.035 10.607.021 15.907.01 4.919.046 9.841.009 14.75.035.492-.013 1-.004 1.492.008 1.324.015 2.709.145 3.225-1.563.148-.464.326-.903.506-1.353 3.981-11.666 4.975-24.036 8.563-35.787.896-2.933 1.482-6.043 5.717-5.321 1.84.076 3.639.373 5.361 1.041.488.134.965.309 1.434.493 4.139.803 8.268 1.021 12.375-.197.424-.303.881-.53 1.367-.709 1.32-.434 2.583-.29 3.789.396z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#76F2DA"
        d="M139.586 66.731c-.778-3.947-3.08-7.622-2.114-11.879.306-.327.678-.472 1.124-.418 2.469-.422 4.538-3.726 7.447-1.053 3.134 2.794 4.672 6.745 7.24 9.952.739 1.894 1.892 3.55 3.049 5.203a650.424 650.424 0 006.975 10.327c5.603 10.013 11.841 19.664 16.936 29.961.945 1.91 2.378 3.692 1.67 6.065-1.549 2.195-3.667 3.498-6.29 4.014-5.071-.078-8.057-4.293-12.167-6.312-3.989-1.959-8-3.983-11.881-6.199-8.665-4.214-15.862-10.523-23.365-16.396-4.38-5.438-10.043-9.719-14.03-15.512-1.279-1.857-3.153-3.449-2.832-6.063 1.612-1.892 2.733-4.116 4.149-6.139.751-1.073 1.801-2.172 3.288-1.719 1.782.543 1.541 2.241 1.799 3.698.366 2.06-2.854 3.94-.603 5.824 3.707 3.1 7.308 6.883 12.993 5.118 6.838-2.437 6.958-2.592 6.612-8.472z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A4EFEC"
        d="M212.642 324.821c-.563-2.626-2.672-1.998-4.385-2.001-10.931-.023-21.861.004-32.792.015-1.428 1.312-3.097.819-4.705.584-5.054-.741-10.142-1.184-15.206-1.783a6.666 6.666 0 01-1.45-.156 3.75 3.75 0 01-1.234-.665c-.682-.596-1.382-1.18-2.043-1.809-1.219-2.608-2.782-5.231.145-7.773.772-.526 1.597-.902 2.555-.897 1.789.252 3.564.273 5.298-.354 1.325-.316 2.673-.366 4.022-.379 1.036-.022 2.076-.035 3.061-.425.938-.373 1.65-1.101 2.496-1.62 1.008-.313 2.048-.01 3.065-.182a20.196 20.196 0 003.655-1.173c.759-.346 1.523-.684 2.285-1.021 1.163-.412 2.13-1.147 3.091-1.898 2.19-.893 3.856-2.546 5.702-3.936 1.292-.659 2.718-1.131 3.486-2.516.362-.509.75-.997 1.13-1.489.612-.824 1.108-1.718 1.553-2.643.461-.927.904-1.862 1.374-2.788.187-.385.405-.749.628-1.11.762-1.091.933-2.341.978-3.623.009-.63.059-1.256.144-1.878a6.74 6.74 0 01.286-1.198c.203-.576.433-1.146.63-1.729.111-.407.269-.793.451-1.174a2.18 2.18 0 01.936-.85 3.142 3.142 0 011.295-.051c2.708 1.1 4.213 3.806 6.795 5.077 2.655 2.173 5.431 4.182 8.248 6.146 1.02.833 1.85 1.801 2.269 3.075.663 2.706.312 5.465.444 8.199.079 1.665.052 3.331.042 4.996a152.65 152.65 0 00-.027 5.821c.026 1.654-.083 3.297-.422 4.92-1.333 2.73-.28 6.563-3.8 8.288z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A5EEEB"
        d="M125.476 312.7c-.833.067-1.583-.073-2.073-.847-1.074-1.208-2.917.458-3.911-1.047l-.002.009c-2.121-1.171-4.991-.759-6.56-3.104-.715-1.439-.689-2.918-.233-4.417.164-.456.384-.891.639-1.302 1.415-2.093.598-4.535 1.03-6.781.188-4.345 1.019-8.68.173-13.043-.416-3.228 1.411-6.462-.068-9.683-.436-2.101-.377-4.234-.463-6.358-.557-3.654-.762-7.352-1.405-10.994a13.17 13.17 0 01-.392-2.382c-.114-1.34-.119-2.682-.094-4.025.072-1.854-.159-3.749.725-5.495 3.626-2.613 4.613 1.498 6.768 2.645 1.157 1.146 2.669 1.738 4.048 2.538 1.392 1.449 3.338 2.065 4.918 3.235 1.146 1.743 1.636 4.126 4.306 4.387 1.185.528 2.049 1.394 2.695 2.501 1.003 1.971 1.748 4.001 1.464 6.273-.231 10.685-.476 21.365.151 32.036a8.31 8.31 0 01.402 1.622c.181 1.33.21 2.673.187 4.014.001 1.233-.029 2.471-.055 3.704.011.67-.012 1.345.013 2.01-.133 1.548 1.179 1.995 2.107 2.742.227.392.367.809.434 1.255.053 1.414-.448 2.716-.784 4.054-.379.858-.66 1.845-1.945 1.599-1.087-4.349-6.219-1.913-8.144-4.856-1.793-2.629-.561-4.368 1.703-5.797 2.158-2.424 1.8-4.613-.709-6.564.388 1.948 3.2 3.369 1.425 5.835-3.131 1.042-4.097 4.293-6.35 6.236z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FC9494"
        d="M511.377 282.1c.021.211.076.413.162.606 1.354 2.732 1.334 5.471.037 8.216l-.059 4.856c-.799 1.503-1.463 3.047-.043 4.528 3.961 4.138 5.395 9.654 7.996 14.533.768.788.977 1.771.984 2.821.059 2.913 1.486 5.913-.533 8.693-.303.27-.516.648-.91.828.412-.016.449-.498.811-.642 3.809-.304 1.883 3.874 3.926 4.944.137.464.117.929-.033 1.387-2.273.911-3.609 3.296-6.086 3.896a1.092 1.092 0 01-.229-.784c-.648-1.044-.75-2.426-1.941-3.135v-.005c-.764-1.286-.598-3.055-2.064-3.977-3.658-4.945-5.207-10.987-8.701-16.278-.902 9.482-2.219 18.839-3.48 28.202.219 1.242-.395 2.258-.959 3.257-.723 1.284-1.861 1.819-3.334 1.572-1.537-.258-2.129-1.316-2.457-2.722-.789-3.372-.119-6.866-.922-10.23.121-8.732-.869-17.376-2.088-26.003-.039-3.883-.078-7.764-.115-11.645-1.533-2.167-.484-4.712-1.031-7.021a5.091 5.091 0 00-.721-1.226l-.232-5.489c.037-.961.752-1.008 1.449-1.085 1.641.197 2.988 1.103 4.416 1.827.402.232.775.506 1.137.8.955.978 2.67 1.334 2.598 3.156-.111 2.979.223 5.969-.127 8.524.443-2.556.016-5.555.154-8.531-.068-1.138.609-1.844 1.424-2.471.365-.31.762-.584 1.166-.843.395-.258.818-.47 1.254-.652 1.785-.516 3.422-1.448 5.229-1.935 1.569-.08 2.987.088 3.322 2.028z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#126BC4"
        d="M243.665 324.881l-.303 2.747c-.235.364-.455.738-.659 1.122a33.955 33.955 0 00-.061 5.279c-.023.93-.188 1.829-.573 2.682-.564.997-1.306 1.923-1.243 3.172-.106 2.006.021 4.008-.067 6.013-.061 1.1-.44 2.079-1.105 2.95l-1.124 4.146c-.385-2.336-3-2.098-4.137-3.57a4.297 4.297 0 01-.74-1.189c-.098-2.815-2.006-6.051 2.45-7.75.637-.243.318-4.085-.488-6.157-2.262-5.812-1.627-11.681-.672-17.641.507-3.168.437-6.369-.465-9.623-1.47-5.307.275-10.456 1.521-15.612.367-1.521 2.309-4.147-1.596-4.289a2.906 2.906 0 01-1.228-.117c-1.774 1.727-.385 3.671-.167 5.391.35 2.752.943 5.442.312 8.215-.602 2.319-1.339 4.65.732 6.687.585 4.598-4.125 4.749-6.325 6.642-1.304 1.122-3.336 4.305-5.878 2.935-2.598-1.399-1.301-4.525-1.482-6.869-.265-3.421-.775-6.952.956-10.231.079-.149.673-.53-.113-.743-2.949-.803-2.941-.828-2.443-4.821 1.903-3.116 6.476-3.676 7.127-7.353-.857 1.609-1.749 3.882-4.633 3.841-3.882-.992-1.532-4.154-1.738-6.109-.238-2.257 2.621-2.313 4.411-2.898 3.617-.724 7.474.719 10.945-1.242.424-.238.875-.42 1.339-.559 2.012-1.017 4.564.877 6.391-1.195 1.491-1.28 3.061-1.132 4.672-.284 2.316 2.909 1.451 6.255 1.11 9.446-.243 2.28-1.699 2.511-3.486 1.19.707 1.877 2.771 2.67 3.451 4.527 1.213 5.487.278 10.856-.844 16.215-.233.747-.618 1.407-1.188 1.947-4.828 2.187-1.948 5.745-1.556 8.855.286 1.113.001 2.166-.354 3.214a3.315 3.315 0 01-.749 1.036z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FC9494"
        d="M113.607 302.878l-.2 4.783c.476 3.307-.093 6.378-2.06 9.135-2.11 8.539-5.166 16.938-3.869 25.983-.509.669-1.22.927-2.024 1.001-.808.011-1.555-.19-2.231-.644-.789-.723-1.288-1.635-1.7-2.604-2.468-9.502-2.663-19.179-2.209-28.368-4.643 7.938-9.139 16.553-15.906 23.679-1.332.873-2.557 2.31-4.345.855-.841-1.373-.63-2.689.214-3.971l.272-2.686c1.416-7.724 3.488-15.261 6.447-22.542.74-1.821 1.302-3.784 3.325-4.706.171-.241.252-.51.244-.805.435-2.353 2.027-4.165 2.929-6.307.354-.703.838-1.274 1.564-1.618 1.805-.714 3.702-.526 5.573-.597 3.246.024 6.492-.017 9.736.042 1.055.022 2.104.101 3.116.427.487.17.908.45 1.263.825.357.659.421 1.357.242 2.076-.491 1.404-2.015 2.788-.1 4.269.223.645.136 1.236-.281 1.773z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#116AC2"
        d="M223.461 282.841c-4.657 1.2-2.447 4.35-1.988 7.001 1.026 2.182-2.644 2.006-2.004 3.993 0 1.162-.029 2.325.004 3.486.11 3.9 1.683.407 2.952.542-1.028 4.939-1.278 9.919-.617 14.932.158 1.195-1.089 2.854.584 3.479 1.453.544 1.967-2.002 2.085-1.979 3.53.676 4.001-3.69 6.888-4.063 1.801-.231 2.264-1.722 2.101-3.394-1.62-1.788-.761-3.99-1.001-6.008.291-4.513-.82-8.853-1.606-13.234-.184-1.025-1.19-2.473.471-2.904 1.282-.334 2.045.795 2.136 2.146-.771.806-.42 1.824-.523 2.756.144-.925-.181-1.938.524-2.756 1.046-1.128 2.389-2.244 3.757-1.123 1.101.902 1.411 2.462.791 4.116-1.632 4.355-2.691 8.822-2.714 13.551-.008 1.646.584 2.644 1.123 3.99 1.073 2.683.916 6.27.145 9.188-1.502 5.69-1.833 11.111.215 16.719 1.307 3.577.908 7.308.242 10.938-2.021.02-1.051-2.071-2.56-2.462v7.083c-.005.34-.02.634-.045.881.536-.069.685-.598 1.043-.879 1.543.998 3.799 1.47 3.065 4.15l-.505 6.811c-1.154 3.7-3.93 3.686-6.98 3.045-1.502-1.359-2.893-2.781-2.898-5.009-.167-8.145-.039-16.289-.089-24.429.021-2.484.032-4.975.043-7.454-.118-1.556.434-3.194-.54-4.645-5.239 1.406-9.197-.641-12.459-4.572l.286-4.878c1.936-1.991 2.59-3.993.053-6.024l.068-4.999c2.418-4.626.061-9.684 1.316-14.515.558-2.146 1.177-3.994 2.498-5.687 1.222-.696 2.343-.349 3.434.329.589.494 1.058 1.033.705 1.878z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C9F5F6"
        d="M36.455 202.821l-.495.008-.494-.002c-2.502-7.136-1.36-13.424 3.998-16.323-3.907 1.309-4.992.28-4.356-2.514.998-2.187 3.839-1.554 5.187-3.324-.86-2.274-3.646-1.156-4.791-2.803 2.539-12.223 5.665-24.206 13.931-34.087 1.798 1.714 1.413 3.974 1.421 6.079.064 16.22.155 32.442-.443 48.655-.058 1.589.851 3.876-1.95 4.343l-9.992-.022c-1.877-2.172-.485-4.798-1.032-6.7-.378 1.912.851 4.52-.984 6.69z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#74F4DB"
        d="M152.458 63.797a60281.83 60281.83 0 01-6.992-9.955c-1.007-1.307-.427-2.277.663-3.143.471-.27.915-.229 1.33.119 1.685 1.824 4.683 1.563 6.086 3.834 1.449 2.177 3.856 2.971 5.994 4.152.309.014.618.026.928.036.883.833 2.245.979 2.954 2.062l1.113 1.876c2.508 4.002 5.357 7.777 7.851 11.792 4.238 6.498 8.215 13.151 12.011 19.916 2.321 4.83 6.568 8.764 6.796 14.571-1.576 3.07-4.23 4.227-7.529 4.238-1.973-1.185-2.782-3.263-3.761-5.15-5.342-10.293-11.397-20.164-17.541-29.982-2.334-3.332-4.267-6.946-6.964-10.028-.675-1.651-1.989-2.87-2.939-4.338z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF8F8"
        d="M554.459 202.832c-5.363 1.084-6.268-1.608-6.178-6.327.057-2.924 2.445-7.271-2.83-8.693 1.174-2.716 5.4-1.949 6.02-5.289 1.797-3.59 2.758-7.338 1.637-11.313-.809-2.867-1.695-5.658.359-8.368 2.447 1.53 5.031 2.511 7.99 2.001.779 2.617 2.768 4.921 2.053 7.926 1.623 5.279 1.217 11.056 3.934 16.067v14.022c-.66.543-1.365.995-2.227 1.15-3.074.158-6.131-.121-9.182-.482a1.81 1.81 0 01-1.004-1.244c-.092-3.354-.059-6.704-.023-9.432-.232 2.661.078 5.984-.117 9.278l-.432.704z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#74F4DB"
        d="M133.55 75.807c-4.957 2.115-9.079 1.146-12.148-3.394-.401-.592-.643-1.183-1.425-.877-4.183 1.631-1.933-1.838-2.336-3.073-.136-.418.492-1.157.884-1.662 1.255-1.617 1.645-4.218.361-4.895-1.816-.957-2.831 1.288-3.434 3.009-.686 1.957-1.863 3.427-3.989 3.926-1.134.589-1.545-.251-1.997-1.011l-3.002-4.992c-2.511-2.86-4.128-6.318-6.301-9.402-1.264-1.795-1.086-3.027 1.175-3.631 3.262.332 5.964-.859 8.286-3.08 3.184-.128 3.691 4.184 6.836 4.122 4.941 3.39 7.185 8.529 9.033 13.926.892 2.293 1.93 4.493 3.881 6.114.737.636 1.549 1.201 1.975 2.126.091.749.143 1.522 1.094 1.726.949-.245 1.21.222 1.107 1.068z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#126BC4"
        d="M215.101 316.739c1.472-.047 2.407 1.001 3.313 1.855 3.075 2.901 6.705 1.056 10.078 1.354.303 1.143-.154 2.275-.043 3.417.064 1.896-.599 3.665-.949 5.49-.376 1.348-.752 2.695-.848 4.104a14.252 14.252 0 01-.392 2.1c-.603 2.543-1.134 5.101-1.54 7.683-.085.707-.235 1.4-.423 2.085-.632 2.224-1.273 4.445-1.614 6.739a5.919 5.919 0 01-.618 1.936 2.084 2.084 0 01-1.026.789c-2.45.932-2.06 3.823-3.669 5.346-2.498 1.493-4.609 1.055-6.345-1.263-.094-2.064-.016-4.127-.055-6.192-1.139-6.945-.196-13.848.391-20.757l1.278-6.602c1.685-2.434 1.101-5.555 2.462-8.084z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#0B0F14"
        d="M404.499 361.932c1.881-.334 3.51-.994 4.006-3.11.789-.856 1.154-2.333 2.811-1.922 1.51 1.742 4.518 1.067 5.615 3.479.084 1.596 1.02 3.24-.285 4.752-4.523 2.039-9.096 3.744-14.158 2.031-.727-1.086-.639-2.201-.107-3.328.705-.635 1.411-1.268 2.118-1.902z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A5EEE7"
        d="M565.44 202.891l2.004-.034-.029 2.012c-.756 1.965-.67 3.939-.063 5.919-.625 4.394-1.309 8.779-1.846 13.184-.227 1.855-.51 3.603-1.982 4.916-.02-2.683-.039-5.364.074-8.153.549-3.723 1.191-7.138.908-9.553.109 2.553-.27 6.125-.908 9.553-2.598-.228-2.408-2.143-1.938-3.633.629-1.991.031-3.81.033-5.696.006-4.259-.398-7.492-5.912-6.757-.846.112-1.182-.976-1.322-1.816l-.004-.016c.346-.422.688-.441 1.025.008l-.014.012c3.322.89 6.646.779 9.974.054z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#0B151B"
        d="M372.236 359.389c1.467 4.365-.191 6.205-4.697 6.4-3.113.137-6.199.975-9.072-.916-.301-.197-.418-.414-.352-.65.07-.248.148-.371.238-.371.232-3.186 2.113-4.336 5.094-4.132.775.036 1.699.355 1.775-.934l.281-1.902.289-.36.441.135c1.585 1.823 3.732 2.418 6.003 2.73z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#111215"
        d="M231.604 362.654c2.157-.912 4.996-.289 6.421-2.85 1.717 3.426 6.797 3.329 8.085 7.903-5.051-.012-9.855.588-14.594-.887-.882-1.408-.917-2.797.088-4.166z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C1FAF9"
        d="M48.462 202.853c1.521-1.305.98-3.083.982-4.679.024-18.133.001-36.265-.01-54.398 0-1.428.053-2.822 1.957-3.013.139.249.277.499.419.748.128 2.878-.075 5.758.057 8.644.017 10.143.501 20.308-.121 30.404-.674 10.938-.715 21.858-.824 32.793-.01.99.552 2.54-1.444 2.458-.432-4.311.967-8.767-1.016-12.957z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#121218"
        d="M211.542 358.591c1.977.041 3.897 1.965 5.93.182 2.193-.044 1.869 1.836 2.364 3.088.14.396.329.768.567 1.113.62 1.461 2.41 2.367 2.015 4.609-4.127-.135-7.939-1.57-11.626-3.105-3.644-1.518-.709-3.752-.167-5.683.224-.437.53-.504.917-.204z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF8F8"
        d="M417.458 76.835c-1.506 3.944-2.158 8.349-5.953 11.06-1.52-.287-2.242-1.419-2.85-2.675-.596-1.933-1.666-3.614-2.824-5.259a6.71 6.71 0 01-.568-1.348c-.283-1.115-.135-2.052 1.051-2.563 2.455-.455 4.836-.213 7.141.746l2.008-.018c.678-.525 1.346-.562 1.995.057z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CAF6F5"
        d="M35.473 183.833c.311 1.088-.621 3.713 2.154 1.766 1.129-.792 1.636-1.009 2.497.646 1.2 2.307-.776 1.755-1.448 1.915-2.882.686-3.42 2.545-3.256 5.188.196 3.149.046 6.319.046 9.479-.661.341-1.322.682-1.983 1.021.127-8.396-.786-16.872 1.926-25.069 1.59 1.665 1.319 3.353.064 5.054z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4C97E2"
        d="M165.494 343.847c1.466-1.153 1.095-2.714.934-4.228 2.351 2.055 6.882 1.653 7.01 6.216-1.35 2.426-3.398 3.768-6.07 2.712-1.892-.748-2.866-2.488-1.874-4.7z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7DF2DC"
        d="M97.382 48.737l.216-1.597c4.02.166 7.868-4.587 12.025-.415-.201 6.361-5.038 3.533-8.156 4.114-1.224-.833-3.046-.434-3.952-1.92l-.133-.182z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#186CC6"
        d="M316.472 42.878l-.889-1.072c-1.391-1.887.076-3.354 1.234-4.052 1.494-.899 3.479-.952 4.664 1.04.89 1.871 1.986 3.668 2.085 5.821 1.2 1.855 1.214 3.598-.49 5.178-1.312.769-2 .008-2.567-1.051l-1.934-1.939c-.357-.262-.529-.608-.492-1.055.168-.838.047-1.568-.76-2.046a8.072 8.072 0 01-.851-.824z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F99697"
        d="M517.629 336.769c1.514-1.932 2.408-4.78 5.805-3.932 2.805 1.397.68 4.334 1.941 6.213-3.234 5.466-3.306 5.445-7.746-2.281z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF8F8"
        d="M51.391 140.763c1.908-3.945 3.831-7.879 8.026-9.985 2.299 3.434 1.864 6.568-1.026 9.444-2.125 2.13-4.415 2.524-6.915.651l-.085-.11z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4493E2"
        d="M135.464 339.919c.196 1.081-.098 2.567 1.833 2.206 2.634 3.882.563 5.603-3.041 6.619l-3.527-2.045c-1.534-1.182-1.073-2.491-.246-3.825l.022-.031c.346-.999 1.041-1.636 2.036-1.961.702.005 1.289-.18 1.534-.929.453-.462.915-.473 1.389-.034z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ADEDEB"
        d="M35.473 183.833l-.063-5.054c.027-.307.059-.612.093-.918 1.16-.001 2.319-.01 3.478-.001 1.869.014 3.287.646 3.385 2.77.102 2.215-1.556 2.071-3.06 2.27-1.296.172-2.557.611-3.833.933z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CFF4F4"
        d="M567.444 188.834c-4.947-4.465-3.811-10.42-3.934-16.066 3.123 4.911 3.801 10.422 3.934 16.066z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2266A9"
        d="M211.362 331.424l.068 21.438c-.321.43-.665.448-1.032.058-1.01-7.224-1.139-14.41.964-21.496z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#28A0E9"
        d="M413.483 314.855l2.193 6.072.197 3.254c.115 1.86.254 3.745-2.623 2.719-.68-2.331-1.006-4.753-1.785-7.061h.002c-.693-2.214-2.621-4.927 2.016-4.984z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF8F8"
        d="M133.55 75.807l-1.106-1.068 1.043-1.872c1.689-1.755 3.835-2.849 5.895-4.066l.204-2.069c2.37 6.54 1.45 7.924-6.036 9.075z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ADEBE8"
        d="M57.507 138.839c3.925-1.908 1.842-5.239 1.91-8.062.054-.802.193-1.563.966-2.021.632.123 1.587.228 1.415.996-.882 3.924.344 6.911 3.676 9.089-1.991 1.62-4.229 1.513-6.537.943a6.483 6.483 0 01-1.43-.945z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#81EDD5"
        d="M82.303 340.598c.154 1.316-.223 2.263-1.731 2.285-1.214.019-2.399-.406-2.735-1.593-.385-1.365-.355-2.848-.505-4.279-.783-1.099-.529-2.182.052-3.259.018-.302.055-.603.113-.899l1.781-.124.421 3.996c1.092 1.14 2.28 2.216 2.604 3.873z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5F98BA"
        d="M416.34 364.836c-.566 3.414-4.527 1.705-5.896 3.906l-6.902-.123c-.857-.242-1.52-.604-1.018-1.672 4.844.862 9.111-2.056 13.816-2.111z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#28A0E9"
        d="M417.625 333.836v14.008l-.275 4.783a3.11 3.11 0 01-.813.368c-2.549-6.601-2.258-13.354-1.072-20.153l.004-.005c1.174-1.188-.174-3.03 1.09-4.195 1.258 1.547.514 3.504 1.066 5.194z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A4EFEC"
        d="M87.473 293.827l-2.115-2.744c-.49-.772-.493-1.521.107-2.241l.001-.002c1.068-.968 2.274-1.157 3.608-.65 1.659.946 2.186 2.729 3.119 4.218.523 1.212.995 2.419-.747 3.083-1.701.349-2.715-.949-3.973-1.664z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F99697"
        d="M519.557 317.645c2.373 3.359 1.805 7.734 3.863 11.202l.105 1.006c.482.71.566 1.386-.17 1.992-2.693-.582-.74-4.776-3.889-5.005.031-3.065.062-6.131.091-9.195z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A3EFE6"
        d="M125.476 312.7c1.089-2.881 1.284-6.676 5.99-5.86l.001.001c-.631 2.066-2.718 3.646-2.058 6.146l-3.933-.287z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C2F8FB"
        d="M325.537 50.819l-1.051.011c-1.229-1.91-.438-3.887-.195-5.845l1.209.817c.523.604 1.037 1.229 1.98 1.011 1.909.062 3.979-.269 4.976 2.029.354 1.018-.264 1.313-1.083 1.46-1.933.3-3.968-.537-5.836.517z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#76F0D4"
        d="M146.464 51.035l-.998 2.808c-1.833-.601-3.412-1.327-4.449 1.478-.695 1.878-2.175 1.785-2.582-.575-.456-2.52 1.692-2.902 3.157-3.846.305.018.601-.029.885-.142 1.387-.723 2.744-1.038 3.987.277z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3B3859"
        d="M496.459 352.077c-2.002-.051-4.002-.102-6.002-.151.061-.692.121-1.386.18-2.078 2.166-.195 3.994-1.36 5.979-2.075 2.484-.053 2.018 1.645 1.867 3.152-.674.383-1.35.767-2.024 1.152z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#85EED4"
        d="M103.613 342.554l1.854.31c.812.991 2.169 1.034 3.113 1.795.282.068.565.134.848.197 1.25 2.224.634 3.419-1.949 3.455-2.068.029-3.867-.575-5.073-2.399l.197-.258c-.339-1.254-.217-2.357 1.01-3.1z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2C9EE1"
        d="M379.37 349.667c-.844 1.11-1.689 2.221-2.531 3.331-2.607-2.365-1.121-4.914-.889-7.41 2.857-.081 1.02 3.232 3.223 3.252.072.274.136.549.197.827z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3E3A69"
        d="M523.553 349.915c-1.527 1.074-3.889 2.043-4.773.626-1.18-1.896 1.729-2.469 2.746-3.712 2.201.025 2.424 1.352 2.027 3.086z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#289EE6"
        d="M416.559 328.642c-.285 1.419.404 3.091-1.09 4.195.156-2.361.289-4.708-3.002-4.998.395-.274.391-.948 1.006-1.001 1.961.158 1.779-1.613 2.4-2.659.852 1.394.774 2.928.686 4.463z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#81F1DB"
        d="M159.54 58.805c-3.155.287-5.284-.907-5.995-4.151l1.865.254c.515 2.213 3.949 1.331 4.13 3.897z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A5EEE7"
        d="M561.471 236.854c.908-2.596-2.129-6.219 2.072-7.958.059 2.849-.212 5.61-2.072 7.958z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2A1C3F"
        d="M523.553 349.915l-2.027-3.086c1.154-1.904 3.168-1.479 3.904-.36.695 1.055.848 3.433-1.877 3.446z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5479A3"
        d="M135.464 339.919l-1.386.034c.157-1.684.316-3.368.476-5.052.313-.362.649-.402 1.01-.068-.771 3.338.956 4.319 3.909 4.146.323.154.431.311.326.469s-.211.238-.32.238l-4.015.233z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B7CC5"
        d="M324.291 44.985l.195 5.845c-.341.337-.682.675-1.021 1.013-1.887.009-1.615-.973-.975-2.124 1.037-1.558.914-3.359 1.077-5.102.238.129.479.251.724.368z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#82A3C4"
        d="M139.604 316.964c-.966 1.866-.562 4.211-2.06 5.891-.329.467-.661.469-.996.007l1.003-5.018.974-2.024c.373-.315.758-.316 1.154-.046.241.414.203.809-.075 1.19z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5F5E5F"
        d="M365.223 358.786c1.043.422 2.764 1.08 1.766 2.185-1.283 1.424-2.543-.205-3.541-1.251l1.775-.934z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6A89AF"
        d="M136.548 322.862c.332-.018.664-.021.996-.007.302 2.434-.667 4.669-1.087 6.99-2.295-2.357.69-4.647.091-6.983z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#403B65"
        d="M496.616 347.772c-1.525 2.035-3.672 2.289-5.979 2.075.242-.95 1.17-.882 1.82-1.226 1.731 1.395 2.251-3.129 4.159-.849z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#AED6E1"
        d="M337.457 48.945c.009.27.016.539.021.808-2.006.353-4.011.705-6.016 1.059-.326-.21-.434-.42-.328-.632.107-.211.215-.317.324-.317l.997-1.02c1.668.033 3.334.068 5.002.102z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CFF3EB"
        d="M327.48 46.813c-.202.692-.128 1.865-1.252 1.468-1.072-.379-.66-1.587-.729-2.479.801.063 1.557.212 1.981 1.011z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#293063"
        d="M247.462 323.741l-1.852-.25c-.195-.609-.004-1.054.571-1.337 1.937-.625 3.824-.959 5.323.926.048.172.15.304.307.394l-1.354.307c-.67.677-1.336.66-1.997-.014-.332-.01-.665-.018-.998-.026z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F99697"
        d="M513.395 328.869c2.766.247 1.887 2.386 2.064 3.977-1.279-1.019-1.869-2.395-2.064-3.977zM515.459 332.85c3.869-.951 1.281 2.098 1.941 3.134-1.081-.776-1.894-1.717-1.941-3.134z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A4EFEC"
        d="M567.352 210.788c-1.359-1.988-1.42-3.962.063-5.92-.022 1.973-.041 3.947-.063 5.92z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D0B2B7"
        d="M108.58 344.659c-1.477.162-3.049.492-3.113-1.795l2.011-.083 1.102 1.878z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9DB6C5"
        d="M135.564 334.833l-1.011.068c-.273-1.624-.131-2.995 1.944-3.189-.073 1.111.217 2.331-.933 3.121z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2D6599"
        d="M210.399 352.92l1.032-.058.111 5.729a1.656 1.656 0 01-.917.205l-.226-5.876z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E2F7F6"
        d="M551.461 144.842c-2.016-.102-2.014-1.546-1.994-3.001 1.323.563 2.004 1.554 1.994 3.001z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A7F0E8"
        d="M85.466 288.841l-.106 2.239c-1.366-.231-2.38-.946-3.013-2.187 1.038-.016 2.078-.034 3.119-.052z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7433EF"
        d="M183.499 113.281l7.173-4.215c.522-1.109 1.604-1.565 2.541-2.196 3.246-2.138 6.925-3.835 8.053-8.082.708-2.321-1.126-5.456 2.219-6.935 4.515-1.154 9.096-1.484 13.756-1.46 15.645.083 31.292-.056 46.937.077 5.768.05 11.51.882 17.264 1.353l1.018-.006c1.337-1.211 2.99-1.371 4.673-1.358 8.48.063 16.963-.278 25.441.179 2.955 1.465 5.855-.14 8.781-.149 26.881-.095 53.763-.114 80.644.008 1.002.005 1.98.198 2.887.665.635.355.914.897.846 1.62-.146.815-.67 1.586-.621 2.396.563 9.648-2.307 18.997-2.162 28.676.369 24.57.127 49.149.117 73.726 0 2.156.164 4.336-.301 6.455-.393 1.789-.768 3.809-3.484 2.926-1.223-1.363-1.197-3.063-1.195-4.72.041-31.113-.225-62.228.115-93.325.262-2.442 3.17-4.479 1.15-7.295-1.271.577 1.234-2.866-1.166-1.071a8.737 8.737 0 01-1.184.632c-12.123 6.843-24.043 14.02-35.999 21.138-1.947 1.129-4.097 1.882-5.94 3.209a19.29 19.29 0 01-1.703 1.148c-3.869 1.492-6.148 5.768-10.67 6.12-2.686-.875-4.645.851-6.795 1.916a8.598 8.598 0 01-2.232.431c-3.504.094-7.004.064-10.503.044a9.72 9.72 0 01-3.137-.485c-2.353-2.286-6.667-3.433-4.808-8.2a3.32 3.32 0 011.485-.574c3.011-.133 6.021-.097 9.03-.032 4.674 1.129 9.254-.154 13.859-.536 1.338.063 2.697-.171 3.234-.027-.293.021-1.393-.013-2.5-.006-4.352.132-8.627 1.407-13.021.818-3.41-.819-6.947.256-10.345-.7-1.706-1.752-.097-2.827 1.019-3.53 13.781-8.692 27.311-17.79 41.499-25.83.313-.178.646-.15.77-.085-7.891.289-15.978.123-24.064.119-3.265-.002-6.188.786-8.988 2.486-15.213 9.23-30.74 17.929-46.006 27.087-.803.311-1.638.432-2.492.482-4.781.112-9.558.029-14.335.081-6.849-.541-13.803 1.091-20.57-.985-1.932-3.532 1.36-4.33 3.189-5.458 10.473-6.457 21.004-12.82 31.44-19.339 1.975-1.233 3.953-2.458 6.974-4.414-10.847.207-20.63-.375-30.382.396-3.863.306-6.833 3.318-10.062 5.304-12.603 7.749-25.464 15.081-37.796 23.271-.56.372-1.197.571-1.85.707a4.824 4.824 0 01-1.444-.047c-1.352-.327-1.771-1.394-2.043-2.574-1.537-1.833-3.562-1.196-5.466-1.051-.5.039-1.437-.291-1.238.834.054.308.195.673.415.873 1.109 1.011.933-.55 1.431-.798.58-.289 1.097-.668 1.77-.698 3.113.823 1.307 3.075 1.392 4.788-.188.929-.662 1.704-1.256 2.423a11.555 11.555 0 01-1.583 1.552c-2.448 2.596-5.701 2.302-8.831 2.471-6.64.609-13.277.405-19.915.041-3.079-1.311-7.991-1.563-8.358-4.871-.343-3.104 4.723-3.641 7.193-5.604 1.537-1.222 3.275-2.188 4.922-3.27.574-1.617 2.276-1.2 3.373-1.874l5.757-3.283c.653-.52.996-1.507 2.078-1.369z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FDFDFE"
        d="M191.433 62.807c1.175-3.296 4.401-4.946 6.948-4.401 3.972.851 5.926-.839 8.509-3.104 4.34-3.806 10.525-3.699 15.603-.354 1.157.763 1.8 1.875 3.789 1.48 8.566-1.701 17.516-5.974 25.132 2.444 1.101 1.582 2.107 3.257 4.028 4.016 2.197 3.005 3.396 6.21 1.996 9.938-1.365 1.341-3.114.988-4.738.991-18.817.031-37.634.026-56.452.009-1.65-.002-3.36.192-4.792-.952l.026-.07c-1.668-1.256-3.746-2.346-2.029-4.98 0-.326.01-.652.029-.979.843-1.253.655-3.005 1.951-4.038z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#75F3DB"
        d="M201.265 98.788c1.29 6.439-4.66 6.575-7.899 9.071-2.024.226-2.223-1.563-2.94-2.724-2.484-4.023-4.49-8.335-7.359-12.124-3.34-6.759-7.462-13.033-11.87-19.131-1.187-3.249-4.065-5.631-4.695-9.165 5.474 2.715 8.99 7.679 13.164 11.813 6.56 6.498 12.601 13.52 18.904 20.28.75.804 1.298 2.007 2.695 1.98z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF8F8"
        d="M377.52 78.818l7.951.053c6.74.488 9.115 7.049 13.98 10.173 1.01.648.48 2.112-1.152 2.294-25.489-.028-50.964.007-76.44-.036-1.795-.003-3.664.468-5.392-.467l3-1.995c1.413-1.188 3.124-.981 4.771-.985 19.795-.041 39.59.13 59.364-.424 1.141-.005 2.299.11 3.451.019 3.658-.292.852-1.646.414-2.61-3.242-4.938-8.643-3.613-13.607-4.364.748-2.293 2.486-1.333 3.66-1.658z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C8F5F7"
        d="M304.473 54.878c.329.646.657 1.294.985 1.941-3.008 1.654-4.774 4.791-8.299 6.045-5.763 2.049-11.451 3.853-17.651 3.32-1.635-.627-3.119-1.413-3.485-3.36.023-1.296.536-2.37 1.484-3.245l1.963-.741a5.94 5.94 0 011.152-.839c3.113-1.144 6.429-1.806 9.155-3.876 1.974-.709 4.042-1.006 6.081-1.45 3.122-.24 6.27-.572 8.615 2.205z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C3F1F6"
        d="M279.524 65.837c1-.646 1.408-2.184 3.265-1.413 3.853 1.6 7.39.306 10.598-1.931 2.154-1.503 5.652.268 6.987-2.69.861-1.908.975-4.213 3.701-1.709.039.035.904-.83 1.383-1.274l.021.041c1.466 1.661-.749 3.312-.016 4.971-3.429 4.862-8.654 6.583-14.04 8.021-1.485 1.16-3.481-.238-4.953.988-.065 1.374-.798 2.001-2.157 1.928-1.669-2.669-3.283-2.012-4.873.08-3.771-1.933-7.713-3.755-5.857-9.25 1.158-.477 2.037-.124 2.168 1.108.376 3.517 2.238 1.704 3.773 1.13z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF8F8"
        d="M191.457 72.875l65.982-.048c.839.303 2.446.561.899 1.659-.913.647-2.554.343-3.868.344-19.379.016-38.759.037-58.138-.034-1.751-.007-4.198 1.084-4.875-1.921zM385.469 88.838l-66.002.001c.629-3.039 3.086-1.944 4.832-1.954 15.056-.078 30.111-.045 45.167-.045 4.313-.743 8.657-1.182 13.032-.931 1.692.097 3.981-.063 2.971 2.929zM207.469 90.833c.356-2.466 2.283-1.977 3.86-1.979 18.759-.021 37.518-.021 56.276 0 1.578.002 3.503-.484 3.858 1.981-.879.644-1.901.483-2.883.484-19.41.008-38.819.008-58.229 0-.981 0-2.003.161-2.882-.486z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D2EDFE"
        d="M316.467 90.834l82.996-.001c2.545-2.527 4.59-2.488 5.934 1.155l-92.898-.181c-.246-.268-.331-.538-.258-.813.075-.275.151-.414.231-.414.707-.383 1.354-.28 1.949.238.683.006 1.365.012 2.046.016z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D3ECFE"
        d="M207.469 90.833l63.995.003c3.313.458 6.817-1.017 9.977.987l-77.957.03c1.031-1.5 2.612-.855 3.985-1.02z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C6F5F8"
        d="M295.533 53.819c-1.885 1.189-3.995 1.05-6.084 1.031-2.403 2.647-6.187 2.188-8.968 3.984l-1.01.004c.016-.825.194-1.569.999-2.002.667-1.282-.468-2.866.679-4.07 1.722-1.512 4.168-.958 6.015-2.121a3.03 3.03 0 011.328-.677c3.325-.207 6.649-.147 9.975-.043a4.088 4.088 0 011.489.432c1.706 1.408 2.982 2.709-.653 2.978-1.262.093-2.611-.418-3.77.484z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF8F8"
        d="M314.421 90.819l-1.934.035c-2.783.95-5.65.283-8.469.444-5.708-1.416-11.419-2.153-17.143.009-2.327.015-4.948.33-3.416-3.449 8.26-.006 16.52.044 24.779-.049 2.656-.03 4.957.285 6.183 3.01zM385.469 88.838c-.334-2.406-2.199-1.975-3.77-1.987-4.076-.031-8.154-.011-12.233-.011 5.801-2.459 11.932-1.96 18-2.002 1.602.224 4.338-.586 3.744 2.237-.67 3.194-3.774 1.22-5.741 1.763z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1D71C1"
        d="M347.544 50.872c.621-.008 1.244-.015 1.866-.021 1.431 2.103 1.751 4.53 2.041 6.968-.702 1.342-.819 3.451-3.162 2.813-1.942-.529-2.136-2.197-2.088-3.893.026-.966.082-1.93.124-2.896-.764-1.47-.26-2.421 1.219-2.971z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B4E3F3"
        d="M303.468 90.832l9.02.022c-.009.318-.006.637.01.954l-30.04.009c.855-1.188-1.932-3.298 1.002-3.96-.293 3.179 1.869 3.055 3.999 2.973 5.337-1.57 10.673-1.567 16.009.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5B9FD2"
        d="M274.366 58.749c-.067-2.111-3.967-3.698-.876-6.227 1.201-.981 2.483-.839 3.465.285 2.222 2.541-.687 3.997-1.364 5.928-.405.329-.814.319-1.225.014z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2878C0"
        d="M279.524 65.837c-.418 1.907-1.259 3.563-3.539 2.978-2.081-.533-1.953-2.22-1.389-3.928.269-.815-.385-1.084-1.013-1.288-.019-.26-.033-.52-.041-.779 1.057-.84 2.09-.847 3.094.092l2.888 2.925z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C5F5FC"
        d="M286.466 50.81c-.128-.722-.781-1.852.51-1.88 4.894-.108 9.793-.084 14.688.018 1.841.039 1.724 1.613 1.794 2.917-1.51.322-2.706-.57-4.011-1.038l.036.021c-4.008-.865-8.017-.858-12.026-.004l.013-.008c-.344.362-.678.353-1.004-.026z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#68EBD1"
        d="M166.502 64.715c1.833 2.937 4.478 5.429 4.967 9.099.302.23.402.459.3.688-.102.228-.204.342-.306.342-2.418-3.959-6.333-7.058-6.929-12.064l1.968 1.935z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2074C2"
        d="M276.637 62.912l-3.094-.092c-2-1.817-.939-3.015.823-4.071l1.225-.014 1.917.846c.005 1.187.492 2.501-.871 3.331z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1671BC"
        d="M279.441 72.848c-.148-1.879-.161-3.887 2.37-3.883 2.376.004 2.771 1.801 2.503 3.803l-4.873.08z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A8D6E0"
        d="M299.448 50.827c1.47-.168 2.762.354 4.011 1.038l1.015 3.013c-2.895-1.073-5.907-1.163-8.941-1.059 1.031-1.457 2.614-.695 3.931-1.009 2.567-.609-.286-1.31-.016-1.983z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EEFCFD"
        d="M189.453 67.824c-.629 2.192 1.882 3.105 2.029 4.981l-1.02.08c-1.015.76-2.011.781-2.983-.079-.021-1.93-.309-3.965 1.974-4.982z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF8F8"
        d="M255.442 62.889c-2.824.147-4.16-1.197-4.028-4.016 2.425.253 2.851 2.511 4.028 4.016z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C0EEF5"
        d="M322.49 49.718l.975 2.124c-1.212 1.634-2.672.944-3.686.023-1.279-1.162 1.234-1.876.73-3.123l1.981.976z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF8F8"
        d="M309.557 46.006c1.737-1.614 3.025-1.14 4.873-.525-1.624 1.687-2.94 1.613-4.873.525z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B7E8EE"
        d="M286.466 50.81l1.004.026c-1.733 1.466-4.028 1.263-6 2.017-.67.582-1.338.578-2.006-.003 2.036-1.705 4.467-2.049 7.002-2.04z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF8F8"
        d="M313.451 54.833l-1.988.024c-.874-.171-1.958.343-2.944-1.499 1.881 1.162 3.973-2.069 4.932 1.475z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CAF5EA"
        d="M279.464 52.85l2.006.003c-.141 1.376.452 2.937-1 3.983-.687-1.239-1.154-2.535-1.006-3.986z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C8F5F2"
        d="M187.479 72.806l2.983.078c-.139.807-.252 1.67-1.294 1.771-1.337.131-1.569-.825-1.689-1.849z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E7FAFB"
        d="M191.433 62.807c-.095 1.614-.665 2.999-1.951 4.038.161-1.583-.66-3.639 1.951-4.038z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A8D7E2"
        d="M305.464 61.832c-1.739-1.663.658-3.313.016-4.971 1.944 1.663.656 3.315-.016 4.971z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A4D8DB"
        d="M331.458 49.862c.006.316.007.633.004.949l-5.926.009c1.736-1.796 3.943-.673 5.922-.958z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C0EEF5"
        d="M318.55 45.819c-.107.331-.099.659.025.984-1.586-.834-3.359-1.567-2.104-3.925.191.05.386.081.583.096 1.376.487 1.873 1.437 1.496 2.845z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ADF9EE"
        d="M163.421 60.903c-1.411-.077-2.389-.774-2.954-2.062 1.479-.02 2.938-.013 2.954 2.062z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A8D8E2"
        d="M286.471 70.84c1.386-1.661 3.284-.754 4.954-.988-1.384 1.671-3.288.731-4.954.988z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3FB3DE"
        d="M441.522 133.972c2.076-.834 3.482-2.911 5.873-3.162 1.498-1.172 3.535.341 4.998-1.006 1.391-1.57 2.756-.516 4.127.038 1.488 1.224 3.484-.156 4.992.974l1.91.007c2.037 1.353 5.285.799 6.191 3.934-.234.779-1.49.434-1.551 1.405.344-.26.92 2.148 1.076-.088.035-.497.047-.963.412-1.341 8.607 1.42 13.482 7.763 18.24 14.095 1.971 2.623 3.135 5.738 3.979 9.017.83 3.221.006 4.258-3.199 4.081-1.758-.097-3.674-.54-5.242.831-.234 1.045-.904 1.904-1.221 2.916-.799 2.58-.135 5.278-.648 7.878a4.33 4.33 0 01-.512 1.228 3.346 3.346 0 01-1.016.802c-1.168.452-2.258 1.063-3.299 1.764a8.549 8.549 0 01-1.129.512c-.977.339-1.844.882-2.691 1.466-.35.238-.719.438-1.096.63-2.02.81-3.539 2.345-5.24 3.618-.365.265-.748.492-1.141.708-3.238 2.48-4.74 5.69-4.66 9.826.086 4.327-1.891 8.105-3.807 12.043 3.215.651 6.438-1.401 9.664-.192.455.178.854.439 1.193.791.75 1.698-.408 2.738-1.32 3.868a6.561 6.561 0 01-1.066.973c-4.412 1.687-8.361 4.378-12.824 5.971-.941.204-1.863.189-2.734-.284-.566-.41-.881-.99-1.084-1.634-.506-.929-1.025-1.712-1.867-.256a11.58 11.58 0 00-.184 1.843c.004.673-.039 1.338-.141 2.002-.125.697-.379 1.334-.84 1.877-2.242 1.081-4.348 2.373-6.146 4.123-1.861.824-3.615 1.873-5.494 2.668-1.381.316-2.523 1.124-3.725 1.817-1.342.569-2.891 1.411-3.949-.076-1.213-1.706.18-3.356.736-4.984.643-1.894 2.189-3.033 3.58-4.304 1.656-1.535 2.736-3.533 4.172-5.248 3.414-3.153 4.773-7.701 7.619-11.24 1.096-3.571 3.992-6.298 4.709-10.046 2.559-3.991 4.301-8.375 6.123-12.721 1.031-1.363.895-3.216 1.914-4.585 2.531-5.685 3.732-11.9 6.914-17.325 1.451-1.03.293-2.764 1.07-3.976 1.277-2.539 2.451-5.152 4.895-6.86 1.775-.445 3.104-2.028 5.064-2.019.891-.264 1.584-1.081 2.621-.934-1-.227-1.699.453-2.498.833-1.459-.092-2.521.94-3.809 1.345-1.615.281-2.215-.956-2.961-2.082.256 3.375-1.697 5.97-2.691 8.857-1.695 1.166-.365 3.313-1.508 4.664-.988.722-1.279 2.801-3.225 1.649-1.281-2.096-.752-4.656-1.762-6.819-.93-4.093-3.197-7.373-6.213-10.196a38.714 38.714 0 01-1.447-1.447c-.857-.455-1.834-2.213-1.988-1.769-.465 1.328-2.924 2.256-1.174 4.199 1.209 1.342 2.59 2.531 3.641 4.019 1.156 1.841 2.453 3.601 3.299 5.627 1.104 2.658 1.289 5.544 2.105 8.276.506 3.57.248 7.156.271 10.735.074 2.487-1.781 4.438-1.914 6.867-2.473 4.508-3.967 9.507-6.885 13.795-.459 3.641-3.623 6.061-4.334 9.589-2.803 2.824-3.43 7.172-6.748 9.638-.785-.043-1.326-.475-1.744-1.1a3.256 3.256 0 01-.219-1.398c.709-2.295.623-4.62.223-6.96-.125-2.838-.043-5.673-.117-8.507.104-2.562-1.305-5.017-.559-7.622 1.355-2.481 1.957-4.495-1.006-6.715-2.781-2.085-1.945-3.436 2.574-4.636 1.119.3 1.896 1.078 2.639 1.897.631.664 1.188 1.458 2.283 1.354a2.42 2.42 0 00.982-.51c.686-1.834 1.652-3.629.258-5.537a5.601 5.601 0 01-.584-1.21c-1.002-1.465 1.084-3.977-1.666-4.863-1.131-1.957-.832-4.109-.92-6.213.01-6.122-.025-12.24.008-18.354.014-2.246.221-4.458 1.271-6.504.51-.976 1.117-1.861 2.172-2.327z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FBFCFC"
        d="M481.438 164.792c.107-1.164.709-1.87 1.891-2.036 16.58-.301 33.164-.497 49.74-.955 6.166-.171 12.223.684 18.328 1.077 1.932 6.646 2.168 13.304.129 19.977 1.141 5.531-3.918 3.465-6.074 4.956-.328.011-.658.017-.986.02-9.525-.368-19.002-1.532-28.525.959-6.453 1.688-13.236.184-19.869.269-3.939.052-7.127.807-9.74 3.844-1.049 1.22-2.344 2.726-4.182 2.186-2.207-.648-2.102-2.861-2.115-4.609-.039-5.245-.549-10.509.352-15.733l-.023.049c1.578-3.205-.25-6.774 1.074-10.004z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CFF5F6"
        d="M551.526 182.855c-.041-6.659-.084-13.318-.127-19.977l2.068-.038c.303 3.03-.75 6.165 1.588 9.032 1.025 1.256.807 3.494-.664 5.051-1.045 1.106-1.172 2.418-.186 3.588.92 1.091 1.871 2.408.709 3.459-1.23 1.114-1.974-1.467-3.388-1.115z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C2F8EF"
        d="M557.477 156.829c-.27 1.139.588 2.593-.895 3.357-.148.077-.824-.415-.908-.734-.396-1.508.174-2.455 1.805-2.622l-.002-.001z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ADF6EE"
        d="M453.411 92.901c-1.717-.807-2.025-2.327-2.023-4.003 2.825.245 1.876 2.401 2.023 4.003z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#116BC4"
        d="M509.551 254.717c1.451.955 1.896 2.415 2.023 4.034-.869.639-1.117 1.725-1.789 2.503-.93.791-1.588 1.681-1.125 2.951.643.534.186-.065.154-.237-.027-.574.131-1.071.406-1.55 1.324-.893 1.135-2.732 2.334-3.691 1.592 4.896 3.707 9.687 3.014 15.04-.201.088-.404.177-.605.267-1.326-.408-1.295-1.703-1.754-2.68-.174-.369-.541-.5-.648-.259-.195.438.189.902.119 1.393-.906 1.475-2.268 1.406-3.697 1.13-1.154-.362-2.012-1.17-2.902-1.928-.811-.739-1.762-1.38-1.938-2.593.137-.801.143-1.597-.215-2.362-.168-.598-.156-1.187.084-1.758.109-.431.324-.88-.176-1.23-.15.459.066.96-.16 1.424-.441 1.646-1.594 2.604-3.066 3.268-1.275.535-2.604.927-3.904 1.393-.906.318-1.813.637-2.738.901-1.754.308-3.496.829-5.301.306-1.527-1.363-1.264-2.832-.258-4.345l.111-2.85c1.734-3.068.771-6.271.465-9.443.021-1.442-.068-2.884.076-4.323.498-1.325 1.498-1.955 2.857-2.09.486-.012.969.049 1.439.174 1.064.414 1.992.998 2.426 2.117-.199.705-.102.855.307.487.344-.311.691-.601 1.137-.777 2.451-.787 5.066-.042 7.498-.888 1.311-.426 2.516-1.21 3.961-1.189 1.029 2.171 1.938 4.377 1.904 6.845-.57.555-1.176 1.075-1.676 1.698.561-.565 1.083-1.168 1.637-1.738z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#40B3DD"
        d="M425.313 266.778l-13.59.021c-.213-.14-.426-.28-.641-.419-.729-1.199-.635-2.425-.119-3.665 1.125-1.345 1.266-3.301 2.729-4.444 5.924-1.854 12.232-1.243 18.188-2.853.445-.165.91-.286 1.375-.39 1.979-.322 3.977-.607 5.664-1.848.74-.483 1.51-.908 2.361-1.162 1.213-.324 2.516-.411 3.527-1.294a5.473 5.473 0 011.117-.625c1.248-.36 2.418-.86 3.309-1.871.557-.476 1.172-.803 1.928-.806 1.857.5 3.479 1.16 2.406 3.609l-.182 1.64c-.646 2.018-2.115 3.47-3.438 5.027-1.617 2.221-4.1 3.233-6.35 4.581-5.733 2.974-11.95 3.973-18.284 4.499z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#116CC1"
        d="M503.467 268.849l1.998 1.991c-.049 1.382 1.367 1.301 2 2 1.383-.141 2.949.463 4.002-.996 1.107-.303 1.627.372 1.373 1.238-1.049 3.562 1.127.382 1.564.78l.164-.096c1.83 1.42 1.82 3.953 1.998 5.597.377 3.494-3.307 1.945-5.189 2.736-1.143-.76-2.383-1.188-3.771-1.109-1.732.557-3.611.696-5.16 1.787l.014.167c-1.736.912-3.584 1.031-5.484.755a4.242 4.242 0 01-1.416-.746l-.023-.28a1.6 1.6 0 01-.455-1.257c.201-2.239-.082-4.219-2.826-5.199-1.154 1.829 3.318 3.103.441 4.809-.457.22-.895.198-1.311-.098l-2.029.357c-.773-.278-1.48-.232-2.076.4-2.002-.019-1.299-1.611-1.246-2.494.246-4.016-.803-8.095.561-12.052.277-.141.549-.289.814-.446.238 1.41-.434 3.056 1.063 4.145 1.637-.469 3.564.524 4.992-.996.432-.804 1.178-.982 2.002-1.002.48.35 1.113.516 1.377 1.13.268.91.422 1.874 1.139 2.584.523.476 1.047.937 1.818.511.898-1.61.076-3.085-.311-4.589-.01-.213-.016-.426-.021-.638 1.002-1.002 2.004-2.004 3.008-3.005.332-.308.662-.306.992.005 0 .668 0 1.336.002 2.004.688.67.041 1.338-.004 2.007z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E9D343"
        d="M457.471 246.834a1.654 1.654 0 00-.961.158l-.637-.049c-1.512.023-3.01.207-4.512.406-.473.004-.93.065-1.383.203-.723.229-1.451.337-2.209.225-.803-.159-1.498-.505-2.049-1.123-3.328-6.756-3.168-14.129-3.783-21.366.488-1.084 1.492-1.337 2.508-1.561.459-.092.934-.141 1.4-.176 2.168.207 3.564-1.606 5.463-2.117.936-.006 1.84.185 2.738.434.947.324 1.732.814 1.893 1.918 0 1.75-1.689 2.131-2.568 3.166-2.047 1.484-4.66 2.448-5.027 5.457 1.229 1.77 2.457 3.033 3.848.148a44.8 44.8 0 01.018-2.075c.047-1.271.199-2.504 1.104-3.495.373-.446.816-.532 1.33-.259 1.246 1.405 1.012 3.296 1.615 4.911.736 3.91 1.334 7.852 2.434 11.688.133.443.209.898.248 1.359.046 1.083-.743 1.594-1.47 2.148z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A5EFEA"
        d="M457.471 246.834l1.119-1.83c2.873-1.76 3.734-3.771 2.172-7.217-1.176-2.595-2.414-5.383-2.604-8.389-.105-1.747-.457-3.533.785-5.07 1.846-1.825 3.65-3.758 6.666-2.771 1.125 1.642 3.281 2.579 3.395 4.927-.076 4.92-.629 9.825-.184 14.757.178 1.954.113 3.967-1.33 5.59-3.341-1.065-6.679 2.605-10.019.003z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF8F8"
        d="M467.491 246.831c.156-5.645-.77-11.286-.049-16.936.18-1.401-.395-2.986 1.074-4.039.316-.326.689-.439 1.133-.31.977.547 1.744 1.247 1.801 2.466 2.318 5.4.154 11.022.721 16.544.265 2.591-2.737 2.204-4.68 2.275z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A6EEE9"
        d="M443.493 261.125c1.936-1.487 4.412-2.229 5.918-4.309 1.561-.71 2.984-1.607 4.064-2.975 2.953-.617 3.623 1.343 3.963 3.578.412 2.706-2.039 4.325-2.658 6.654-.018.069-.775.114-.873-.035-2.715-4.159-4.451-.659-6.443.8-.731-1.871-5.141.191-3.971-3.713z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F5F2AB"
        d="M411.209 269.62l.129 3.234c-1.482 1.447-3.543 1.346-5.322 2.006-3.592.55-7.199.347-10.805.236a9.168 9.168 0 01-1.613-.264c-2.057-.802-4.215-.649-6.359-.655-1.711-.031-3.436.024-4.982-.907-1.17-1.121-1.902-2.315-.611-3.83 6.744-.996 13.496.395 20.25-.045 1.975-.129 3.979.221 5.93-.362 1.2-.224 2.362-.224 3.383.587z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9FEEEF"
        d="M443.493 261.125c.045 2.605 4.178.838 3.971 3.714-7.363.863-14.654 2.553-22.148 1.938 6.13-1.648 12.464-2.651 18.177-5.652z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2696E0"
        d="M413.483 314.855c-3.234.624-1.58 3.228-2.016 4.984-3.133-1.628-2.723-5.469-1.98-7.006 1.428-2.955 2.053-5.813 2.016-9.136 1.52.944.693 2.212.988 3.197-.399 2.745.732 5.299.992 7.961z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1572C0"
        d="M479.76 230.668l-4.377-1.696c-.566-1.466-.813-2.934-.029-4.412 1.158-.883 2.564-1.005 3.922-1.29a5.38 5.38 0 011.434.027c1.168.288 2.334.583 3.094 1.634.262.85.188 2.082-.57 2.136-3.297.233-1.428 2.386-1.578 3.787-.687.475-1.323.471-1.896-.186z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B3E9EF"
        d="M479.76 230.668l1.693-.124c1.258-.868 2.648-1.038 4.121-.803 1.201.257 2.158.824 2.584 2.056.063 2.295.26 4.641-2.139 6.069.143-4.23-2.721-4.796-5.98-4.988-.842-.049-2.195.14-1.912-1.375.069-.367 1.065-.561 1.633-.835z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#13346C"
        d="M486.02 237.867l1.559-5.912c.555-.367 1.025-.28 1.414.26.305.48.512 1.001.633 1.557.33 3.917.23 7.838.1 11.763-.094.859-.363 1.652-.895 2.343-.727.592-1.516.504-2.322.213-1.449-3.084.623-6.266-.25-9.368a8.03 8.03 0 00-.239-.856z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B3360"
        d="M486.258 238.721c2.012 2.884 1.611 5.828.219 8.797-.115.726-.447.844-.996.354-.373-.354-.748-.707-1.123-1.061-1.049-1.848.24-3.318.791-4.907.369-1.061.738-2.122 1.109-3.183z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E3F1AD"
        d="M409.624 278.466l-4.045.537c-1.99 1.062-4.006 1.147-6.053.171-.668-.794-.688-1.64-.207-2.528 1.828-1.479 4.012-1.073 6.107-1.16 1.514.082 3.064.073 4.125 1.449.024.511.047 1.021.073 1.531z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A0ECFE"
        d="M486.594 267.14c.635 4.829-1.459 9.787.686 14.546-.555 2.259-1.547.521-1.563-.01-.15-5.216-.184-10.438-.043-15.653.008-.274.719.603.92 1.117z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1972C8"
        d="M475.459 224.854c.105 1.375.951 2.764-.076 4.118-1.313-.32-2.623-.641-3.936-.96-.824-.708-1.65-1.415-2.477-2.123-.018-.629.219-1.141.707-1.541 2.027-.964 3.986-1.156 5.782.506z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1873C5"
        d="M488.317 254.561c1.682 3.262 3.16 6.506-.797 9.282l.012-8.864c.135-.377.404-.505.785-.418z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4EB5D5"
        d="M450.518 247.022l.988-.344c1.643-.5 3.285-.479 4.93-.012 0 0 .072.327.074.326-.861 1.434-1.371 3.123-2.943 4.037-.033-1.935-1.627-2.416-2.943-3.158-.287-.156-.398-.333-.334-.533.066-.211.142-.316.228-.316z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FD8073"
        d="M411.209 269.62l-2.854.198c-1.656.812-3.266.751-5.369-.294 2.723-2.187 5.217-3.46 8.418-2.675l.318-.052-.513 2.823z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#97ECF3"
        d="M453.475 253.842c.273 3.216-1.896 3.094-4.064 2.975l3.975-4.145.089 1.17z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A9E0F2"
        d="M488.317 254.561c-.264.136-.525.274-.785.418-.207-2.506.625-5.313-2.051-7.107l.996-.354 1.916.459c.701.529.6 1.161.232 1.826l-.308 4.758z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EF9688"
        d="M406.432 273.824c1.406-1.479 3.24-.804 4.906-.969-.029.944-.059 1.889-.086 2.833-.418.736-1.064.613-1.719.456-.605-1.344-2.199-1.369-3.101-2.32z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8CBC7"
        d="M489.586 286.775c.273.061.549.103.828.125.893 2.601.814 5.209.053 7.82-1.884-2.471-.763-5.277-.881-7.945z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C7AAA6"
        d="M490.467 294.72c-.018-2.606-.033-5.214-.051-7.821 2.008 2.514.773 5.396.922 8.121-.293-.09-.584-.19-.871-.3z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A9E0F2"
        d="M485.149 241.904l-.791 4.907c-1.66-1.946-1.002-3.519.791-4.907z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FEE4B9"
        d="M409.502 275.642l1.75.046c-.066 1.101-.924 1.119-1.701 1.246l-4.217-.151c-.213-.563-.08-1.028.396-1.396 1.31-.67 2.567-.594 3.772.255z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#050603"
        d="M88.525 253.72l-5.581-8.975c-.432-3.929-1.525-7.858.01-11.783.881-3.537 3.214-6.124 5.661-8.633 2.292-2.858 3.08-6.511 5.008-9.56 1.078-2.389.028-4.921.479-7.35.092-1.173.169-2.347.392-3.505.774-3.158 2.967-5.454 4.947-7.834.832-1 2.06-2.553 3.501-.45.098.461.094.927-.001 1.389-.636 1.659-1.765 3.154-1.7 5.06-.062.47-.18.921-.338 1.366-.992 2.205-2.142 4.358-2.056 6.891.236 11.488.404 22.961-2.455 34.221-.456 1.795-.17 3.643-.079 5.468-.409 2.849-.849 5.687-4.364 6.429l-1.256-.727c-1.176-.179-1.841-.911-2.168-2.007z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#76F3DB"
        d="M115.549 282.769c1.415 4.027.174 8.034-.088 12.049a1.566 1.566 0 01-.992.593 1.66 1.66 0 01-1.023-.548l-.005.005c-4.479-2.126-9.235-.542-13.837-1.031-1.921-.099-3.871.248-5.757-.374-.731-.396-1.106-1.056-1.337-1.813.825-3.306-2.712-4.943-3.02-7.822-.006-4.772-.069-9.545.015-14.315.027-1.548-.655-3.353 1.064-4.538 2.207 2.954.828 6.397 1.317 9.583.038.781.307 1.521.444 2.284.258 1.217.258 2.461.335 3.691.135.832.255 1.759 1.35 1.761 6.95.011 13.876.813 20.832.611.233-.048.467-.092.702-.136z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF8F8"
        d="M81.485 214.83l-.002-52.984c2.148-.589 3.19.356 3.403 2.452.367-2.376 2.162-2.377 3.978-2.454 2.388-.102 4.617-.005 6.056 2.385.438.728 1.311 1.001 2.169.494.293-.173.418-.523.402-.862-.049-1.02-.787-1.358-1.624-1.536-2.438-.519-4.918-.458-7.393-.528-1.868-.053-3.87-.152-3.236-3.011a3.306 3.306 0 011.365-.939c5.728-.285 11.485-1.413 17.098.753 2.632 8.212.932 10.648-7.443 10.788-3.123.053-6.281-.351-9.341.593-.524.243-1.007.548-1.418.959-1.263 3.884-.534 7.864-.59 11.786-.129 9.069.085 18.143-.131 27.209-.049 2.036.956 5.413-3.293 4.895z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#74F3DB"
        d="M113.554 254.792c1.5 3.572.961 7.471 1.781 11.152-3.124.845-6.235.291-9.287-.3-4.451-.86-8.867-.037-13.299-.063a2.167 2.167 0 01-1.302-.948c-.146-2.578.101-5.104 1.034-7.534 4.554-2.678 9.551-1.404 14.37-1.516 2.284-.052 4.552.216 6.703-.791z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#070A08"
        d="M95.462 203.834l.002 4.01c-2.894 1.962 1.009 4.893-.995 6.981-1.242 3.55-2.314 7.184-4.992 10.017-1.685.384-2.301 2.846-4.471 2.303-.993-.556-2.249-.941-1.666-2.531l2.266-4.463c.331-1.354.593-2.731 1.311-3.959a38.177 38.177 0 003.492-9.024c.428-1.743 1.053-3.413 2.679-4.461 1.165-.412 1.884.118 2.374 1.127z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2DE3BF"
        d="M113.554 254.792c-.195 1.434-.001 3.333-2.363 2.762-6.215-1.502-12.473-.408-18.71-.455-.336-.128-.517-.348-.538-.651 2.32-1.149 2.271-3.817 3.597-5.604 2.857-2.331 5.674-3.168 8.884-.414 2.523 2.166 6.344.065 8.946 2.353l.184 2.009z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CAF5F6"
        d="M85.458 158.831c.348 2.445 2.251 1.969 3.836 1.998 2.481.047 4.964.022 7.447.029 1.484.004 2.651.438 2.657 2.188.005 1.427.498 3.23-1.574 3.621-1.384.261-3.545.789-3.946-.924-.94-4.021-3.891-2.688-6.302-2.856-1.116-.078-1.745.493-1.994 1.707-.151.739 2.735 1.936-.257 2.165-1.28.099-1.742-.657-1.358-1.921.677-2.228-1.424-2.187-2.485-2.993l-.044-1.006c-.62-.793-.547-1.566.067-2.326 1.391-.802 2.721-.842 3.953.318z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B1EAE9"
        d="M49.478 215.81c1.635-1.474.956-3.427.96-5.17.05-20.599.038-41.198.042-61.797 1.677-.106 1.828 1.209 2.188 2.337.353 2.123.316 4.252.091 6.387-.654 8.524-.107 17.059-.308 25.584-.046 1.934.4 3.976-.981 5.688-.001 8.103.058 16.206-.089 24.306-.017.915 1.529 3.844-1.903 2.665z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A0F2EB"
        d="M51.47 188.838l.005-31.994c.675-.597 1.392-.587 2.139-.149.438.747.448 1.465-.145 2.142-.001 8.563.031 17.127-.032 25.69-.012 1.648.785 3.841-1.967 4.311z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#45EBCC"
        d="M90.554 275.833l.013-10.861c.302-.089.595-.2.88-.335l.031.384c1.035 6.044 5.119 6.615 10.36 6.572 4.614-.038 9.569-.16 13.667 2.912.549.795.487 1.619.129 2.462-1.224 1.085-2.667 1.061-4.15.839-6.847-2.014-13.958-1.263-20.93-1.973z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#AAEBE7"
        d="M87.63 216.887c-.227 1.366-.926 2.438-2.024 3.264l-4.14-4.308c2.654-.545 2.541-2.536 2.534-4.607-.039-12.498-.038-24.996.003-37.494.005-1.632-.43-3.337.464-4.896.333-.006.667-.008 1-.007 1.95 2.025 1.529 4.61 1.555 7.036.134 12.539-.126 25.08.142 37.62.025 1.161-.019 2.306.466 3.392z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BAFAF6"
        d="M84.468 168.846c0 14.22.002 28.439-.003 42.659-.001 2.125.462 4.594-2.999 4.338l.019-1.014c3.061-.647 1.919-3.126 1.933-4.872.093-11.979.022-23.958.079-35.938.008-1.746-.672-3.702.971-5.173z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#171818"
        d="M83.34 224.614l2.119 2.238c.313 2.103-2.559 3.664-1.016 5.976-2.191 3.76.059 8.079-1.5 11.918l-2.212-4.969c.724-3.643.22-7.271-.122-10.902a10.218 10.218 0 012.731-4.261z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ACEBE8"
        d="M53.469 158.836l-.001-1.995c1.233-1.27 2.788-1.256 4.378-1.11 5.928 1.048 11.922.296 17.871.652 2.112.127 4.849-.736 5.799 2.402l-.076 2.054c-6.707-3.817-14.005-1.276-21.003-1.953-1.664.96-3.323 1.268-4.968-.042l-2-.008z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#90EFE3"
        d="M89.489 283.827c1.797 2.074 5.586 3.028 3.957 7.031-.75.57-.999 1.643-1.982 1.979-1.301-1.016-1.841-2.414-2.009-3.999-1.063-1.329-1.064-2.66-.007-3.993l.041-1.018z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BAEEEF"
        d="M36.455 202.821v-11.098c3.107 3.449 1.516 7.413 2.016 11.107-.673-.002-1.345-.006-2.016-.009z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#041210"
        d="M80.61 228.875c1.115 3.622 2.359 7.243.122 10.902-.586-3.628-1.301-7.254-.122-10.902z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A7F0E8"
        d="M89.448 284.845l.007 3.993-3.988.001c.547-2.108 1.874-3.439 3.981-3.994z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A0F2EB"
        d="M55.468 158.844l4.968.041c-1.673 2.061-3.341 3.489-4.968-.041z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#97EDE1"
        d="M88.525 253.72l2.167 2.007c-.862.192-1.678 1.307-2.556.521-.94-.843.226-1.676.389-2.528z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6FEAD5"
        d="M189.794 132.955c3.168.341 5.302-1.783 7.718-3.236 2.261-.764 3.619.549 4.878 2.127a6.23 6.23 0 01.399 1.634c.378 10.199.211 20.391.177 30.581-.005 1.482-.128 2.964-.897 4.3-.392.609-.923.774-1.592.499l-.013-21.837c-.004-6.741-4.278-11.819-11.141-13.239-.207-.484-.05-.76.471-.829z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#69EAD1"
        d="M109.466 67.831l1.997 1.011c3.547 6.051 8.504 10.91 13.34 15.883 1.456 1.496 3.551 2.603 3.668 5.089.301.231.4.46.298.688-.102.228-.203.341-.305.341-7.512-6.697-15.093-13.338-18.998-23.012z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5CE1C8"
        d="M175.663 117.929c-.912 1.006-2.042 1.621-3.373 1.874-6.584-5.483-14.227-9.185-21.821-12.969-.229-.897-.054-1.39 1.002-.999 6.547 2.409 12.445 6.05 18.379 9.633 1.808 1.092 3.401 2.77 5.813 2.461z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#99F0E7"
        d="M159.425 150.782c6.22-1.329 4.788-5.755 4.012-9.915l6.035 3.972c1.057 1.337 1.072 2.667-.023 3.991-3.271 1.011-6.401 2.749-10.024 1.952z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#61E5CA"
        d="M151.472 105.835l-1.002.999c-7.841-4.635-15.535-9.471-22.005-15.992l.006-1.028c7.998 4.865 14.657 11.652 23.001 16.021z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#56DFC5"
        d="M200.477 168.859c.273-.014.545-.025.818-.037 1.293.979 1.215 2.243.75 3.587a1.595 1.595 0 01-1.201.862c-3.418-.595-6.513-2.227-9.843-3.122-2.711-1.156-5.612-1.97-7.72-4.23-.02-.844.13-1.503 1.229-1.11 3.834.415 7.277 2.043 10.82 3.397 1.618.619 3.316 1.373 5.147.653z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#72EFD6"
        d="M97.516 48.919c1.603.051 2.94.649 3.952 1.92-1.504.12-1.435.612-.729 1.835 1.944 3.365 5.336 5.929 5.726 10.164-.648-.075-1.698.076-1.885-.257-2.508-4.472-6.377-8.254-7.064-13.662z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#58E1C4"
        d="M184.51 164.808l-1.042.997c-1.24.685-2.342.058-3.471-.351-3.131-1.484-6.465-2.525-9.477-4.265-1.377-.795-3.166-1.246-3.255-3.327.392-.484.796-.494 1.21-.03 5.385 2.233 11.012 3.911 16.035 6.976z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#093951"
        d="M189.794 132.955c-.154.278-.311.555-.472.829-.576.313-1.152.629-1.729.943-5.989-1.211-12.115.449-18.098-.865a359.71 359.71 0 01-.963-.314c7.052-1.495 14.175-.424 21.262-.593z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#93D6E3"
        d="M169.496 133.862c6.015.675 12.122-.589 18.099.865-6.033-.29-12.151 1.197-18.099-.865z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#60E6CB"
        d="M168.475 157.833l-1.027.012c-1.354 1.28-2.782.73-4.215.184-1.72-.925-3.662-1.505-4.955-3.114-.018-.818.109-1.48 1.195-1.085 3.212.858 6.117 2.408 9.002 4.003z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#65F1D4"
        d="M159.473 153.829l-.997 1.002c-1.945 1.009-3.43.426-4.226-1.501-.442-1.069-.94-2.563 1.238-2.534l-.001.004 3.986 3.029z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#81EEDD"
        d="M169.449 148.83l.023-3.991c1.39.114 2.013.87 1.92 2.256-.081 1.225-.875 1.626-1.943 1.735z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF8F8"
        d="M405.397 91.989c-1.719-1.714-3.641-2.386-5.934-1.155-.164-1.798-1.426-1.995-2.863-2.005-.984-.006-2.66.034-2.631-.853.197-5.826-5.24-5.719-8.221-8.169-.209-.172-.191-.619-.277-.938 2.869-1.032 5.85-1.146 8.855-1.048 2.539 2.134 2.832-1.677 4.549-1.729 1.408-.451 2.797-.543 4.148.189 1.258.689 2.152 1.874 3.432 2.538.002.325.004.65.002.976 1.205 1.567 1.73 3.541 3.016 5.063l2.031 3.036c.334 2.611-.377 4.917-2.029 6.947-.383.474-.883.642-1.475.563-.748-.207-1.17-.805-1.633-1.355a6.15 6.15 0 01-.652-.819c-.051-.166-.096-.336-.143-.505a9.604 9.604 0 01-.175-.736z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#74F1DC"
        d="M418.461 198.851c.002-.663.002-1.326.002-1.989 1.521-5.257 2.916-10.55 4.4-15.818.887-2.634 1.498-5.437 4.223-6.959 1.641-.429 3.563-1.606 3.941 1.436-2.217 5.442-5.742 10.373-6.461 16.415-1.971 7.3-2.621 14.845-4.195 22.214a6.216 6.216 0 01-.652 1.391c-1.389 1.733-.686 3.933-1.281 5.848-.996 2.231-2.398 2.613-3.873.563-1.207-1.678-2.301-3.499-2.354-5.697-.076-1.319.02-2.627.361-3.906 2.255-4.369 3.667-9.11 5.889-13.498z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#65E9CF"
        d="M427.45 174.83c-1.959 1.594-2.512 4.112-3.967 6.038-.754-.468-.313-1.536-1.018-2.028 5.764-17.511 2.279-34.308-3.957-50.882-.875-2.323-2.031-4.553-2.049-7.118.338-.404.672-.382 1.002.008 2.334 6.666 4.668 13.331 7 19.997 1.627 3.225 1.49 6.695 1.475 9.907.328-3.489-.666-7.179-.469-10.911 0-2.332-.002-4.665-.004-6.997l.008-.008c2.057 4.116 2.063 8.548 2.002 12.989 1.416 1.371 1.549 3.262 2.049 5.006.121 7.299-1.754 14.339-2.906 19.852.215-1.69.713-4.802 4.561-5.927 1.9 4.519-1.604 7.041-3.727 10.074z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#8A96BA"
        d="M406.375 92.923c.41.641.822 1.28 1.234 1.921.852 1.307.471 2.606-.023 3.905l.016 80.074c.559 1.116.852 2.3.904 3.545.73 8.691.842 17.384.029 26.083a3.67 3.67 0 01-1.094 1.586c-.723.128-1.266-.127-1.635-.761-1.107-2.367-.734-4.896-.736-7.364-.029-32.878-.016-65.756-.025-98.633.399-3.456-.927-7.137 1.33-10.356z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#69EAD2"
        d="M428.469 150.844c-.953-1.55-1.115-3.256-.996-5.019 1.656-3.124 1.518-6.661 1.879-9.979 1.561-14.289 1.068-28.66 1.115-43.007.332-.351.664-.35.994.004l.002 33.993c-1.043 1.778-.289 3.481.104 5.258.676 3.061 1.611 6.154.297 9.296-.533 2.07-.854 4.173-1.146 6.29-.188 1.347-.073 3.135-2.249 3.164z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#75F2DF"
        d="M440.491 135.894c-.371 1.95-1.381 3.785-1.07 5.86a1.252 1.252 0 01-1.105.549c-.674-.053-1.34-.167-2.01-.26-1.176-.164-2.371-.275-3.262-1.21-.627-2.611-1.559-5.22-.129-7.864 4.252-3.337 2.746 1.01 3.514 2.144-.178-1.909-.186-4.201 1.037-6.272 1.082-.5 1.479-2.576 3.152-1.601 1.385.808.676 2.369.848 3.606-1.792 1.4-.385 3.417-.975 5.048z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#67EAD1"
        d="M418.461 198.851c-1.375 4.442-1.818 9.242-4.99 12.993a76.312 76.312 0 00-.588-.549c-.799-1.301-1.18-2.779-.955-4.228.887-5.724-.635-11.309-.818-16.968.373-.513.832-.601 1.371-.266 3.42 4.537 1.332 9.875 2.197 15.038 1.864-1.748.469-5.448 3.783-6.02z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#71F0D7"
        d="M411.274 97.652c2.68 4.221 5.223 8.541 8.146 12.585.641.887.77 1.18.178 1.796-.703.73-1.662.698-2.029-.204-1.953-4.802-6.307-8.426-6.295-14.177z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#68E9D0"
        d="M435.465 121.838c1.637-7.283 4.191-14.154 9-20.011.256.224.344.449.262.678-.082.229-.164.344-.25.344-2.299 5.248-4.578 10.505-6.912 15.737-.611 1.368-1.236 2.702-1.109 4.249-.891.223-1.389.059-.991-.997z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#73F3D7"
        d="M433.469 132.842v7.997c-1 .876-2 .789-3 .001 1.713-2.326.203-4.652.117-7.002-.086-2.32-1.014-4.883.877-7.001.146 1.382-.459 2.95 1 4.003.553.313.844.807.979 1.409.01.198.019.395.027.593z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#70EED5"
        d="M417.461 120.847a334.7 334.7 0 01-1.002-.008c-3.191-3.072-3.707-7.449-5.467-11.239 4.473 2.429 3.925 7.729 6.469 11.247z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#73F3D7"
        d="M437.465 128.84c-1.035 2.902 1.082 6.271-1.193 9.018-2.512-.905 1.633-5.265-2.803-5.016l-.006-.007c-.992-2.553-.221-4.519 2-6.001.27 1.019-.598 2.275.537 3.039.176.12.961-.665 1.465-1.033z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#64E7CE"
        d="M422.465 178.839c.814.438.982 1.199 1.018 2.027-1.656 5.337-2.27 11.001-5.02 15.995.315-6.233 3.145-11.908 4.002-18.022z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6DEFD5"
        d="M444.477 102.849l-.012-1.021c-.471-3.955 3.469-4.344 5.283-6.448.166-.194 1.041-.099 1.277.152.463.493.557 1.393-.15 1.646-2.916 1.047-3.234 4.962-6.398 5.671z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6EEED5"
        d="M431.461 92.844l-.994-.004c-2.215-4.892-.393-9.937-.596-14.919.856 4.952.087 10.056 1.59 14.923z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6FF5DB"
        d="M425.467 139.84c2.082 3.55.576 7.307.223 11.039-.408-3.346-.818-6.69-1.229-10.035l1.006-1.004z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#69E8CF"
        d="M412.481 189.834l-1.014.006c-2.686-1.941-2.803-5.14-3.855-7.881-.004-1.045-.008-2.09-.01-3.136 2.621 3.23 4.191 6.925 4.879 11.011z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6AEBCF"
        d="M435.463 126.834c-1.455 1.738-1.912 3.809-2 6.001-.807-.428-.977-1.175-1-1.995 1.066-2.979.883-6.374 3.002-9.002l.99.997c-.663 1.25-1.146 2.546-.992 3.999z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#65E8CE"
        d="M425.463 132.843c-1.6-2.03-2.072-4.342-1.943-7.59 2.66 2.545 1.701 5.216 1.951 7.582l-.008.008z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#75F5D4"
        d="M440.491 135.894c-.529-1.848-2.67-4.007.975-5.048.02 1.041.037 2.082.057 3.124l-1.032 1.924z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6CF8DC"
        d="M435.383 76.806c-.061.639-.037 1.422-.922 1.417-.873-.005-.902-.781-.906-1.422-.006-.646.029-1.423.906-1.418.864.006.872.777.922 1.423z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#40B8CA"
        d="M452.393 129.804c-1.307 2.114-3.355.554-4.998 1.006 1.428-1.523 3.297-.847 4.998-1.006z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6AEAD1"
        d="M420.909 116.312c.947 1.399 1.938 2.307 1.094 3.784-.985-.927-1.692-1.865-1.094-3.784z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B6F8F4"
        d="M407.586 98.75c.008-1.302.014-2.604.023-3.905l1.865-.002c-.116 1.55-.641 2.903-1.888 3.907z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#40B8CA"
        d="M461.512 130.816c-1.688-.213-3.598.722-4.994-.974 1.701.144 3.568-.579 4.994.974z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF8F8"
        d="M480.385 174.745c2.406 5.741-.154 11.785 1.074 17.598.129.608.262 1.217.355 1.659 1.039.492 1.582-.019 1.908-.544 4.617-7.419 11.984-6.025 18.854-5.708 11.77.544 23.453-1.726 35.211-.854 2.236.166 4.664-.861 6.678.935-7.271.017-14.541.076-21.813.032-3.67-.022-5.469 1.376-5.229 5.331.24 3.949.012 7.928-.01 11.894-5.625 1.919-6.438 1.568-11.432-4.921-1.178-1.685-1.715-3.754-3.156-5.277-1.281-1.087-2.625-.846-3.986-.177-.764.412-1.535.806-2.387 1.021-1.477.39-3.195.094-4.268 1.56-.773 1.122-1.992 2.058-1.484 3.696 1.266 2.294 3.295 4.076 4.279 6.543.131.954-.232 1.771-.701 2.558-1.117 1.621-1.865 3.476-3.107 5.022-.703.83-1.391 1.672-1.975 2.597-.762 1.125-1.615 2.156-2.857 2.784-2.711.909-4.623 4.545-8.23 2.422-1.9-2.82-.779-6.092-1.377-9.108 1.92-4.537 2.881-9.143.975-13.955-.002-1.274.414-2.504.377-3.782.076-3.098.018-6.194.027-9.285a15.79 15.79 0 01-.02-1.442c.105-3.037-3.096-1.743-4.264-3.219-.826-1.046-3.752-.487-2.357-3.208a.82.82 0 01.707-.185c1.16-.505 2.484-.718 3.303-1.836a.824.824 0 01.707-.166c1.18-.436 2.35-.886 3.275-1.787a1.2 1.2 0 01.923-.198z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EBD342"
        d="M539.499 224.839c.842 4.51-1.176 8.408-5.016 9.49-5.639 1.59-11.826 1.984-16.842-2.442-.832-.734-2.488-1.304-2.039-3.049 1.73-1.91 5.613.606 6.23-3.024-1.051.651-2.281.78-2.967-.784-.717-1.629-.559-3.293.791-4.558 1.205-1.129 2.688-1.892 4.238-2.501 1.75-.504 3.525-.514 5.314-.324.994.169 1.906.509 2.592 1.29.789 1.595 1.711 3.033 3.799 3.009 1.515.673 4.773-.98 3.9 2.893z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#24215D"
        d="M492.372 248.928a6.353 6.353 0 01-.902-.102c-1.096-1.192-1.375-2.649-1.371-4.2.168-5.298-.457-10.618.393-15.898.402-1.092 1.141-1.821 2.289-2.088 3.924.866 3.012 3.931 2.514 7.619 1.395-2.547.82-4.674 2.252-5.935 1.266-1.114 2.541-3.756 4.414-.536.516 3.627-1.105 7.413.859 10.917l4.865 9.203c-.748 1.109-1.564 2.111-3.09 2.045-2.998.618-6 .529-8.996.06-1.344-2.274-2.365-4.517 1.344-5.522 1.199-.326.502-.812.25-1.262-.434-.771-.811-.646-1.469-.068-1.814 1.591-.68 4.145-2.055 5.84-.45.264-.881.226-1.297-.073z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E9D53F"
        d="M523.469 218.838c-.854 2.273-5.896 2.241-3.465 6.326 1.553.52 1.273-1.092 1.902-1.65.848-.754 1.918-.933 2.678-.158.805.82-.32 1.353-.691 2.018-1.867 3.357-4.178 5.535-8.291 3.465l-.26-1.667c-1.994-2.085.258-4.318-.254-6.595-.941-4.2-.656-4.265-4.039-5.588a3.88 3.88 0 01-.52-1.518c-.074-2.441 1.313-3.477 3.533-3.858 5.819-1 10.87 3.929 9.407 9.225z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C4EAEC"
        d="M513.057 220.816c-3.332-1.245-6.645-2.684-10.25-.932-1.375-.449-1.586-1.734-2.055-2.838-.35-1.114-.453-2.275-.621-3.422-.186-1.313-.801-2.479-1.299-3.684-.424-1.465-.992-2.855-2.041-4.011-.932-1.513-.613-2.732.855-3.688 1.203-.525 2.406-.509 3.611-.006 1.063.582 1.855 1.459 2.596 2.392.857 2.531 2.297 4.591 4.768 5.809 1.41 1.212 1.631 3.144 2.75 4.533l-.039-.063c.721 1.927 3.868 3.146 1.725 5.91z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A8EDEA"
        d="M539.499 224.839c-.258-2.73-3.059-.467-3.926-1.998-.904-1.216-3.094-.791-3.449-2.705.381-3.131-2.217-1.946-3.627-2.49-2.57-2.277-4.801-4.679-3.16-8.514 3.314 1.027 6.104-.255 9.133-1.494 1.27-.52.695 2.052.996 3.206-.221.217-.463.409-.689.617-.551.501-1.816.874-1.537 1.489.539 1.188 1.404-.837 2.227-.11 3.408 2.537 4.121 6.662 5.838 10.169.488 1.002-.705 1.687-1.806 1.83z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EDD245"
        d="M525.336 209.132c.514 2.992 1.422 5.785 3.914 7.782.824.58.789 1.235.168 1.94l-5.949-.017c-.52-4.683-3.771-7.793-7.887-8.051-3.236-.202-4.516 1.064-4.211 4.182-2.326-.245-2.732-2.012-3.047-3.849 1.354-5.099 3.547-6.12 9.432-4.389 3.143-1.142 4.594 3.053 7.58 2.402z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8D347"
        d="M517.756 206.732c-3.955-.282-7.352.639-9.432 4.388-3.746-.403-4.609-3.079-4.896-6.209-.803-.902-1.338-1.936-1.551-3.132.176-1.603 1.109-2.648 2.473-3.384.758-.229 1.434-.073 2.035.438 2.738 3.736 5.555 7.337 11.029 6.254.114.548.227 1.097.342 1.645z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EDD245"
        d="M513.057 220.816c.164-2.186-2.23-3.625-1.725-5.91 2.213 1.244 3.525-.764 6.299-2.084-1.977 5.167-.674 9.884-2.289 14.349-3.336-1.193-1.115-4.383-2.285-6.355z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#142A4F"
        d="M501.499 216.776c1.455.606.723 2.135 1.309 3.107l.012 18.823c-2.928-3.672-.588-7.948-1.367-11.866-1.063-1.187-1.334-2.628-1.342-4.155.095-2.055-.376-4.245 1.388-5.909z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A3F0E4"
        d="M535.465 212.84c-.365 1.681-1.57 2.378-3.117 2.274-1.152-.077-.855-1.2-.844-1.954.047-2.909 2.271-2.17 3.961-2.316v1.996z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BAB1AC"
        d="M511.577 290.922c-.014-2.738-.025-5.477-.037-8.215.316.025.629.076.938.149.748 2.641.816 5.277-.047 7.908a5.95 5.95 0 00-.854.158z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DBD7D2"
        d="M512.43 290.765l.047-7.909c1.547 2.645 1.502 5.282-.047 7.909z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9DF4E5"
        d="M540.311 233.415c.957-.063.977.686 1.053 1.303.082.659-.027 1.405-.768 1.564-.941.203-.973-.65-1.045-1.268-.08-.655.045-1.282.76-1.599z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A4EFEC"
        d="M87.63 216.887c-3.066-.509-2.122-2.948-2.129-4.738-.062-14.437-.034-28.873-.034-43.31 3.723-2.069 7.745-.778 11.616-.926 6.351-.242 6.357-.071 6.382-6.564.003-.827.016-1.655.024-2.483.653-.58 1.365-.607 2.123-.229.551.604.773 1.33.791 2.133-.048.811-.405 1.481-.941 2.07-.102 2.665-.459 5.352 3.712 5.087 3.603-.229 1.306 3.963 3.403 4.993.91 2.241-.64 2.501-2.206 2.754-2.179.149-5.099-1.135-5.319 2.772.063.214.109.426.168.641.097.446.129.893.118 1.347-.425 1.512-1.029 2.973-1.189 4.483.565-1.133.093-2.976 2.039-3.357.473.113.896.325 1.285.613 2.446 1.983 5.073 3.843 5.179 7.451.17 1.609-.202 3.249.292 5.006 1.443.213 1.469-1.417 2.343-1.873 1.68-.454 2.392.88 3.189 1.853 12 14.636 24.354 28.959 37.487 42.598.99 1.028 2.271 2.091 1.515 3.871-1.655 1.359-4.154.714-5.675 2.397-1.347 1.002-2.55 2.311-4.461 2.126-2.51-.933-5.032-1.805-7.785-1.478-1.011-.002-2.014-.063-2.999-.301a4.967 4.967 0 01-1.386-.591c-3.41-2.889-7.237-5.177-10.981-7.587-2.266-1.458-4.438-3.004-4.177-6.183 1-1.873 2.692-1.771 4.403-1.561.347-.005.839.422 1.049-.04.167-.368-.353-.71-.546-1.09a4.49 4.49 0 01-.408-1.902c.037-1.535.949-2.704 2.022-4.021-1.132.103-1.779.704-2.593.535a3.236 3.236 0 01-1.235-.592c-2.242-1.94-2.784-4.373-1.782-7.841-1.375 2.584-3.043 3.197-5.146 2.838-2.228-.361-2.917-2.54-4.436-3.74-.699-.465-1.39-.94-2.04-1.472-.489-.39-.96-.801-1.456-1.187-.713-.493-1.472-.922-2.11-1.524a4.97 4.97 0 01-1.266-2.447c-.792-3.205 1.218-5.451 2.68-7.886 1.307-3.768-.512-4.43-3.707-3.755-2.609.552-4.081 2.557-5.729 4.375-1.411 1.556-2.132 3.73-4.204 4.689-3.074 4.218-2.214 10.079-5.88 14.046z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3EB3DD"
        d="M109.483 174.765c1.448.083 2.78-.028 3.094-1.846 7.26-.508 14.338-2.855 21.718-2.147 3.696-.651 7.374-.896 10.978.479 2.606.781 4.934 2.183 7.368 3.346 1.038.533 2.082 1.062 3.088 1.657 2.305 1.486 4.414 3.245 6.679 4.794 6.834 5.9 11.939 13.032 15.253 21.443.306 1.729.057 3.055-2.157 2.927-5.8-2.413-11.357-5.375-17.188-7.727-3.126-1.643-6.464-2.779-9.749-4.041-1.674-.787-3.379-1.501-5.142-2.077-2.291-1.132-4.698-1.95-7.155-2.636a11.37 11.37 0 01-1.333-.491c-5.052-2.02-9.849-4.756-15.385-5.387a6.636 6.636 0 01-2.001-.647c-2.489-2.553-6.173-2.584-9.074-4.28a2.298 2.298 0 01-.568-1.252c.081-1.035.533-1.795 1.574-2.115z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FDFDFE"
        d="M81.516 158.786c-5.491-1.923-11.163-.452-16.735-.88-2.459-.189-5.025.436-7.286-1.073.74-7.992 3.654-11.121 11.389-11.924 1.772-.184 3.082-.912 4.34-2.02 1.23-1.083 2.463-2.229 4.317-1.979 3.757-.048 7.2-.285 10.629 2.659 2.274 1.952 6.628.16 9.402-.629 7.055-2.006 11.943-.33 15.739 5.592.773 1.206 1.978 1.71 3.15 2.313 3.381 4.262 2.636 7.054-2.264 8.046-2.785.563-5.567.066-8.394-.193-6.757-.622-13.574-.837-20.351.123l.006.011a1726.95 1726.95 0 00-3.942-.046z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#76F2DB"
        d="M161.449 170.817l-10.021-10.902c.288-2.725 2.06-.849 3.173-1.036 1.578.517 3.012 1.307 4.336 2.303 2.892 2.217 6.047 4.008 9.27 5.693 2.519 1.349 5.14 2.462 7.814 3.468 5.443 3.134 11.098 5.889 17.042 7.833 5.554 1.818 9.385 4.629 9.363 10.98.385 1.836.43 3.694.397 5.559-.008 1.328-.008 2.657-.023 3.985-.009 1.318-.109 2.62-.75 3.813-2.97 2.178-5.093-.174-6.948-1.718-3.05-2.539-6.184-5.024-8.942-7.904-1.613-1.304-3.314-2.514-4.682-4.098-4.021-2.784-7.032-6.803-11.333-9.239-1.059-.314-2.098-.672-2.961-1.397-.895-.946-1.552-2.079-2.404-3.061-.753-1.703-3.615-1.773-3.331-4.279z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A5EFEA"
        d="M77.541 140.91c-3.473 2.235-5.632 6.437-11.209 5.345-2.877-.563-5.717 2.498-6.591 5.733-.491 1.817-1.382 3.286-2.246 4.845l-4.026.009-1.994.003-.008-6.004c-.274-4.913-1.16-10.198 6.407-10.27.171-.002.051-1.24.595-1.729l7.004-.001c.157 1.37.869 2.083 2.297 1.882 1.863-.264 1.68-1.734 1.685-3.016.007-2.404-.003-4.639 3.346-4.872 3.125-.217 5.189.353 4.713 4.146-.162 1.288.008 2.618.027 3.929z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#77F2DA"
        d="M158.45 161.839l-3.961-1.994c-1.277-.769-2.512-2.274-3.948-.224-.373-.302-.845-.536-1.103-.916-1.52-2.241-4.397-4.622-2.395-7.323 2.074-2.797 5.496-1.938 8.444-.587-2.198 3.71 1.367 3.152 2.988 4.035l4.985 2.021c.875 1.812 2.742 2.254 4.339 2.914 2.372.98 3.651 2.578 3.843 5.102-.495.533-1.125.732-1.829.743-1.273-.336-2.55-.309-3.832.016-2.773-.745-4.944-2.678-7.531-3.787z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#44B3DD"
        d="M161.449 170.817c1.041 1.646 3.943 1.418 4.037 4.016-1.876 1.179-3.194-.733-4.83-.873-2.365-.884-4.785-1.571-6.943-1.793 1.956-.044 3.975 1.288 6.291 1.329 1.415 1.298 3.82.979 4.825 2.95a7.323 7.323 0 01-.883 4.203 1.793 1.793 0 01-1.213.623c-2.449-.786-4.111-2.817-6.308-4.005-1.094-1.161-2.647-1.468-4.007-2.133-2.294-.804-4.018-3.316-6.917-2.307-3.301-3.046-7.421-1.631-11.205-2.055 5.358-1.629 10.856-.939 16.244-.551 3.636.264 7.266.503 10.909.596z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D7F5F5"
        d="M85.453 158.82c3.536-2.084 7.385-.726 11.076-.911 5.096-.256 10.214-.056 15.322-.068 6.235-.016 6.723-.764 4.61-6.996 4.25-.13 2.782 3.076 2.966 5.215.263 3.043-1.997 2.768-3.96 2.796-1.19 1.024-2.595 1.384-4.131 1.344-2.068-.019-4.189.185-5.932-1.311-.639-.008-1.277-.016-1.915-.022l-18.036-.047z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CAF5F6"
        d="M111.464 158.856l4.003-.001c.991 2.984-.108 4.201-3.206 4.012-2.259-.139-4.533-.026-6.8-.026l-.003-2c1.617-1.827 4.393-.146 6.006-1.985z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#63E8CC"
        d="M150.541 159.622c1.523-3.592 2.714-1.308 3.948.224-1.012.354-2.068-1.228-3.06.068a3.088 3.088 0 01-.888-.292z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#25205A"
        d="M251.505 323.08l-5.706-.242c-1.721-1.611-.785-3.088.225-4.568.876-.86 1.933-1.369 3.127-1.609 8.468-.464 16.946-.078 25.419-.23 1.953-.034 4.029.452 5.709-1.05 3.203-5.563 1.707-11.545 1.377-17.342-.243-4.264-1.714-8.358-3.351-12.33-.448-3.098-3.908-5.571-1.929-9.178 3.496-1.495 7.268-1.492 10.938-2.003.481-.024.972-.016 1.454-.003.659 0 1.326.018 1.978-.054 1.753-.395 1.201-1.609.945-2.715a8.534 8.534 0 01-.266-1.238c-.224-1.688.035-3.457-.887-5.024-.649-1.834-1.101-3.676-.259-5.585.764-1.342 1.96-2.034 3.429-2.342 15.121-.726 30.248-.313 45.368-.279 11.302.024 22.605-.08 33.908.111 2.58.15 5.229-.446 7.725.689 2.582 2.025 2.436 4.423.951 7.001-2.039 1.52-4.432 1.134-6.717 1.14-14.913.041-29.825.007-44.739.036-1.804.003-3.648-.306-5.364.435-1.708 2.288.449 3.728 1.329 5.271 4.293 7.535 8.113 15.216 8.914 24.04-.324 2.297-.49 4.66-2.57 6.229-3.297 4.202-.984 9.115-1.721 13.631-.783 3.969 2.76 3.802 4.832 5.042.381.672.43 1.318-.145 1.917l-78.976.234c-1.665.003-3.332.01-4.998.016z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A4EFEC"
        d="M334.113 295.931c-1.498-9.351-5.515-17.664-10.469-25.608-.847-1.359-2.313-2.482-2.057-4.379.822-.778 1.856-.583 2.829-.581 18.876.044 37.751-.117 56.629.075 1.721 1.229 1.594 2.703.57 4.296-.316 1.174.434 2.047.852 3.014.055.729.244 1.428.467 2.117.662 1.063 2.125.975 2.826 1.976.219.664.232 1.27-.463 1.676-2.268-.385-3.457.09-4.037 2.811-2.496 11.67-5.318 23.271-8.084 34.881-.299 1.248-1.014 2.396-1.538 3.592-.734.041-1.42-.15-2.092-.426-1.205-.426-2.465-.634-3.693-.994-8.25-.327-16.497-.081-24.739-.137-8.629-.058-8.629-.032-7.824-8.496.906-2.658.967-5.366.432-8.107.459-1.881.092-3.818.391-5.71z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#289EE6"
        d="M415.465 332.842c1.354 6.665.693 13.437 1.072 20.152-.238 2.186-.477 4.369-.721 6.549-2.031.016-4.137.166-4.502-2.644 5.441-3.057.314-3.474-1.199-4.793 3.396-2.478 4.758-7.104 2.615-10.85-2.341-4.09-.548-6.383 2.735-8.414z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A1EFE9"
        d="M400.504 322.784c-3.67-2.805-10.543-2.76-13.951.092-1.084-1.026-1.336-2.282-1.02-3.691 2.242-3.537 4.199-7.242 6.252-10.892 2.559-1.04 3.316 1.305 4.688 2.504 2.262 3.687 3.541 7.704 4.031 11.987z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#222159"
        d="M370.352 318.89l1.287.909c-.053.348-.107.694-.162 1.042-.791.984-2.105 1.18-3.014 1.991l-1.006-.002c-5.326-.835-10.653-.819-15.979-.006l-15.998.003-.014-1.987c.209-.201.416-.402.623-.607 5.053-1.582 10.244-.476 15.365-.758 4.813-.267 9.655.379 14.448-.409 1.452-.746 2.95-.483 4.45-.176z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#29A0E5"
        d="M392.237 308.706c-2.342 3.165-2.676 7.462-5.762 10.207a1.636 1.636 0 01-1.025.482 1.58 1.58 0 01-.982-.561c.684-1.243 1.156-2.539.998-3.993l.004-.003c2.822-1.369 5.432-2.68 2.641-6.496-1.979-2.703 1.287-4.426 2.08-6.494.303-.787 2.744 1.105 3.262 2.896.522 1.606.196 2.95-1.216 3.962z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EEEBA7"
        d="M385.297 278.516l.047-1.582c.848-1.116 2.08-1.315 3.354-1.424 3.609.363 7.484-1.213 10.785 1.449l-.027 1.768c-2.76 2.236-5.887.618-8.838.839l-5.321-1.05z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B9DE3"
        d="M384.467 318.834l1.01.012c-.023 1.338 1.037 2.701-.098 4.012-1.18.28-1.818 2.24-3.285 1.323-1.082-.676-.563-2.052-.584-3.133-.041-2.068 1.42-2.209 2.957-2.214z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2891DB"
        d="M407.465 284.839c.094.481.127.986.297 1.438.48 1.271 2.484 2.246 1.152 3.829-.869 1.029-1.861-.081-2.367-.815-1.174-1.711-2.279-3.573.92-4.449l-.002-.003z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#25205A"
        d="M351.478 322.825c5.327-1.603 10.653-1.61 15.979.006l-15.979-.006z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B9DE3"
        d="M385.413 330.83c.152 2.319-.414 4.429-1.844 6.284.748-2.711-1.965-4.406-2.137-7.354 1.494.095 2.574 1.641 3.981 1.07z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BBFBFA"
        d="M390.618 279.566c2.811-1.695 5.924-.214 8.838-.838l6.123.275c-.129.229-.227.47-.289.724-4.576 1.091-9.164.785-13.756.118a27.729 27.729 0 01-.916-.279z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9DEBF7"
        d="M392.237 308.706l1.215-3.961c1.65 1.696 2.604 3.741 3.021 6.052-.189.55-.262 2.134-.98.386-.668-1.629-1.707-2.263-3.256-2.477z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#599995"
        d="M391.534 279.845l13.758-.118c-4.573 1.848-9.161 1.562-13.758.118z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3199C7"
        d="M385.379 322.858c.092-1.336-.912-2.698.096-4.012l1 .065c.025 1.322.051 2.644.078 3.964-.352 2.388.49 4.947-1.037 7.165-.045-2.392-.09-4.787-.137-7.182z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2495E1"
        d="M400.479 313.857c.863-1.212 1.959-1.214 2.961-.335 1.15 1.011 1.434 2.201.031 3.319-3.494 1.508-1.83-2.153-2.992-2.984z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2C9EE1"
        d="M376.372 353.843l-1.102 2.825c-.596.405-1.189.812-1.783 1.217-1.335-2.985-1.176-4.907 2.885-4.042z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2299E1"
        d="M413.473 326.838l-1.006 1.001c-.053-2.702-1.498-5.229-1.002-8 1.686 2.042 2.057 4.46 2.008 6.999z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1F96E0"
        d="M392.467 292.839c1.434 2.392 1.98 4.985 1.938 8.642-1.678-3.263-2.117-5.881-1.939-8.64l.001-.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1B90D4"
        d="M400.479 313.857c1.303.689.801 3.188 2.992 2.984-4.051 2.067-2.666-1.316-2.992-2.984z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1E95DE"
        d="M392.465 292.841c-1.537-1.472-1.063-3.181.002-4.927v4.925l-.002.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B9DE3"
        d="M383.235 338.843c-.027 1.602-.682 2.941-1.715 4.125.158-1.547-.838-3.573 1.715-4.125z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#25205A"
        d="M368.463 322.833c.568-1.325 1.57-1.994 3.014-1.991.271 2.592-1.424 2.21-3.014 1.991z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#29A0E5"
        d="M385.465 314.841c-1.127-.796-1.531-1.896-1.807-3.435 2.174.734 1.666 2.222 1.811 3.432l-.004.003z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#20A4DD"
        d="M407.467 284.842c.121-1.003.346-1.939 1.656-1.834.217.018.613.389.584.521-.266 1.211-1.309 1.185-2.242 1.31l.002.003z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#55E0C5"
        d="M183.499 113.281l-2.078 1.365c-4.463-11.069-11.141-20.94-16.964-31.272-.815-1.447-1.842-2.768-2.024-4.488-.292-.252-.383-.495-.273-.73.108-.231.213-.348.316-.348 6.998 8.388 11.868 18.115 17.16 27.56 1.42 2.534 3.502 4.831 3.863 7.913z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5CE2C7"
        d="M162.475 77.807l-.042 1.077c-3.029-2.852-4.959-6.468-6.977-10.024-.276-.242-.364-.48-.264-.714.098-.231.195-.347.291-.347 3.45 2.554 5.252 6.259 6.992 10.008z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5EE4C9"
        d="M155.482 67.799l-.026 1.061c-1.291-1.515-2.8-2.899-2.997-5.062 1.58.901 2.912 1.99 3.023 4.001z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#43B3DC"
        d="M213.39 290.08c-3.059-1.487-5.699-3.532-8.007-6.019-1.345-2.911-.117-4.039 2.771-4.013.458.063 1.056.696 1.135.567.336-.556.152.265-.336-.248-1.36-.966-2.614-1.936-1.64-3.851 1.597-1.542 3.458-2.014 5.59-1.397 1.376.589 1.842 2.141 3.066 2.9.538.48.928 1.052 1.078 1.77-.09 1.877-.203 3.75-1.689 5.172-.45.176-.878.119-1.284-.138-.5-.354-1.044-.551-1.669-.447.951.004 1.469.597 1.866 1.369.479 1.606.515 3.118-.881 4.335z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A0E7EA"
        d="M139.604 316.964l-.081-1.068c.055-1.554.708-2.774 2.015-3.632 1.104-.49 2.235-.529 3.375-.188 2.05.88 3.333-2.419 5.488-1.038.428.167.781.437 1.062.801-1.625 2.405-.864 4.792.06 7.177-4.138 1.737-7.651.164-11.037-2.083l-.442-.03-.44.061z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#126BC4"
        d="M214.602 284.948l1.856-5.104c1.344-.841 2.534-1.151 3.041.885-2.266 5.561-2.117 11.406-2.032 17.243.021 1.438-.214 2.655-1.958 2.866l-.282-8.917c-.469-2.301-2.017-4.505-.625-6.973z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#41B4DF"
        d="M207.467 276.867l2.004 3.979v-.001c-2.369-.208-4.324.11-4.089 3.216-2.922-.932-4.462-3.682-6.903-5.247 1.13-3.733 4.59-1.561 6.758-2.675.842-.059 1.612.105 2.23.728z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9CE9FE"
        d="M197.481 278.822l-.056 1.138c-2.194 1.47-4.467 1.548-6.811.396-1.814-1.853-1.553-4.073-1.111-6.321 2.745-3.659 3.853.751 5.776 1.169.591.306 1.196.593 1.778.92.374.236.67.55.881.94.124.655.115 1.279-.457 1.758z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9AEAE7"
        d="M186.474 299.811c-1.452 2.387-3.178 4.351-6.336 4.1-2.597-1.518-1.935-3.447-.691-5.453 2.589-.846 5.311-2.355 7.027 1.353z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A2EEEE"
        d="M196.464 282.835l-.044 2.147c-.757 1.56-.525 3.514-1.921 4.817l-.006.022c-1.686.59-2.877-.052-3.753-1.5-.509-5.618.873-6.942 5.724-5.486z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#95E1E7"
        d="M151.463 311.839l-1.109-.046c-1.17-1.125-3.055.289-4.134-1.166-.04-1.219.606-1.992 1.625-2.532 2.433-.854 4.927-.608 7.421-.431 1.129.27 2.189.63 2.448 1.976-.984 1.844-2.432 2.084-4.2 1.211l-2.051.988z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#126BC4"
        d="M215.44 305.836c1.648.949 4.047 1.299 3.943 3.839-.108 2.648-3.473-.068-3.996 2.186l.053-6.025z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9CBFBF"
        d="M171.644 308.664c-1.063.259-1.982.032-2.715-.813-2.729 2.644-5.895 1.231-8.94.972-.775-.278-1.417-.699-1.623-1.566a2.116 2.116 0 011.037-1.119c.954-.418 1.968-.505 2.992-.534 1.455-.023 2.913.019 4.371.007.482-.022.963-.006 1.445.017.486.005.967.055 1.448.127.733.121 1.412.373 1.987.861.465.68.358 1.364-.002 2.048z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9FE7FA"
        d="M177.451 306.032l-1.795.802a2.017 2.017 0 01-.94-1.147c-.45-2.735 1.509-4.742 2.161-7.15.58-.696 1.201-1.018 1.941-.203-.189 2.614 1.326 5.53-1.367 7.698z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#357EA8"
        d="M186.474 299.811c-2.122-1.922-4.613-.632-6.937-.797-.427-.427-.473-.891-.141-1.394 2.297-1.631 4.932-.899 7.436-1.071.707-.031 1.418-.063 2.128-.093.478-.004.9.155 1.264.469-.09 2.47-1.478 3.252-3.75 2.886z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A3ECFC"
        d="M196.464 282.835c-4.693-.628-5.353 2.188-5.006 5.863-.602.397-1.107.3-1.523-.291-1.047-2.396-1.196-4.73.492-6.936 2.091-.781 4.155-1.184 6.055.48-.008.296-.014.591-.018.884z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#62817F"
        d="M159.483 307.863c3.146-.832 6.296 1.635 9.444-.013-.439 1.079-1.035 1.983-2.351 2.067-1.922.817-3.782-.446-5.69-.169a3.283 3.283 0 01-1.349-.566c-.33-.427-.347-.867-.054-1.319z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3B83A5"
        d="M179.467 297.937l.07 1.077c.19 1.634-.591 3.387.602 4.896.298 2.222-1.46 1.834-2.688 2.12 1.56-2.573.759-5.444 1.031-8.182l.519-.249.466.338z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#58C2EB"
        d="M197.481 278.822l-.141-1.78c.8-1.296 2.153-1.334 3.44-1.525 1.513.02 3.033-.751 4.545.008.449.396.496.838.14 1.321-1.877 2.259-5.102-.264-6.987 1.968l-.499.017-.498-.009z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#64AED3"
        d="M190.488 288.784c.327.013.65-.016.97-.084l3.034 1.123-1.055 2.928c-1.667.729-2.399-.534-3.263-1.526-.204-.406-.3-.84-.311-1.293.077-.454.286-.836.625-1.148z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9FE9FD"
        d="M190.472 290.868l2.965 1.883-1.923 3.097c-3.098-1.085-2.284-2.988-1.042-4.98z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3DB3E8"
        d="M214.602 284.948c-.247 2.366 1.375 4.563.625 6.974l-1.837-1.844.077-5.216c.263-.386.559-.414.89-.084l.245.17z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#71BAD5"
        d="M190.472 290.868c.235 1.684-.707 3.612 1.042 4.979l-1.289 1.077a2.23 2.23 0 01-.78.121c-1.575-1.581-1.271-3.535-1.095-5.469.115-.547.336-1.05.651-1.512.415-.474.9-.556 1.451-.248l.02 1.052z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4D9BBC"
        d="M190.451 279.914l6.975.046c-.002.261-.021.52-.053.778-2.025 1.115-4.188.446-6.296.486-.553-.272-.762-.71-.626-1.31z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#88CBF3"
        d="M160.564 308.919c2.135-.46 4.014.618 6.011.998-.869 1.026-2.03.975-3.206.864-.521-1.242-3.167.714-2.805-1.862z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#79C5DA"
        d="M190.455 280.792l6.918-.054-.892 1.213c-1.975-.003-3.949-.008-5.924-.012-.36-.142-.493-.399-.397-.774l.295-.373z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A2EEE3"
        d="M191.182 304.042c-.192.275-.369.813-.722.981-.902.431-1.091-.43-1.22-.981-.07-.298.248-.936.513-1.016.662-.198 1.264.037 1.429 1.016z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4E8CA7"
        d="M175.374 306.122a.918.918 0 00.28.712c-.987 1.376-2.764 1.026-4.012 1.831-.023-.536-.047-1.07-.072-1.605.252-.683.822-.99 1.447-1.236.819-.176 1.686-.686 2.357.298z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3F88A9"
        d="M160.564 308.919l2.806 1.863c-1.633.024-3.265.05-4.898.075l-.309-.604c.187-.699.583-1.207 1.304-1.413l1.097.079z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#519FB6"
        d="M153.514 310.851l3.898-1.083c.608-.027.667.629 1.067.859l-.008.23c-1.654 1.248-3.307 1.656-4.957-.006z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5099AE"
        d="M194.499 289.8c.632-1.609.356-3.581 1.921-4.818.19 1.938.401 3.884-1.921 4.818z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7E27E"
        d="M113.37 252.782c-4.052-.354-8.435 1.497-11.8-2.942-1.091-1.438-3.703 2.021-6.03 1.004-1.613-1.42-1.504-3.292-1.019-5.04 3.358-12.091 3.163-24.487 3.313-36.858 2.769 1.125 1.442 3.999 2.517 5.848 1.773 4.6 2.675 9.592 6.077 13.46.234 3.184 1.265 5.993 3.815 8.091 1.223 1.322 2.18 2.78 2.37 4.628.143 2.661-.971 5.445.783 7.95l-.026 3.859z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2AE3C1"
        d="M115.316 274.774c-5.369-1.002-10.725-1.972-16.234-1.965-8.613.012-7.54 1.095-7.604-7.791 8.05-2.189 15.971-1.068 23.858.927l.234 6.886c.43.714.526 1.385-.254 1.943z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FA9792"
        d="M111.555 240.746c.099-1.658-1.504-2.445-1.956-3.822.212-.377.504-.678.858-.922 1.789-.627 1.868-2.756 3.266-3.733 1.105-.536 2.226-.526 3.361-.114 1.064.505 1.898 1.333 2.833 2.025.462 2.483 2.016 4.679 1.838 7.362-.077 1.15 1.333.283 1.79.914 2.082 2.746 4.872 5.052 5.352 8.766l-.397.585c-2.184-.023-4.367-.047-5.216-2.674-.633-.324 1.046-2.832-1.467-1.493-.649.346-1.575-.271-2.207-.854-2.702-.396-3.18-4.046-6.079-4.153-.95-.325-1.373-1.201-1.976-1.887z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#73F3DB"
        d="M115.316 274.774l.253-1.943c2.495 3.319-.7 6.625-.021 9.939l-.099.083c-5.388 1.504-10.595-1.295-16.003-.637-2.643.321-5.622.775-7.979-1.377l-.002-3.943c5.529-2.262 11.184-.634 16.785-.543 2.376.227 4.659 1.976 7.154.468l-.088-2.047z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EED33C"
        d="M136.623 302.833l.025-3.96c2.598-2.053 5.437-1.508 8.294-.781.521.261.918.653 1.198 1.164.818 2.128.708 4.3.275 6.483-.156.511-.42.965-.776 1.363-.873.627-1.859.771-2.898.655a4.698 4.698 0 01-1.33-.446c-1.624-1.454-3.245-2.925-4.788-4.478z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9EE4E6"
        d="M136.456 263.819l-1.981-4.998a2.479 2.479 0 011.228-.682c2.068-.096 2.799 1.534 3.749 2.888.706 1.268 2.12 1.954 2.735 3.302.55 1.529.582 3.064.071 4.613a3.305 3.305 0 01-.996 1.297c-1.347.738-2.671.737-3.97-.118-.962-2.009-1.807-4.036-.836-6.302z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#418AB7"
        d="M136.456 263.819l1.014 6.027c.117.736.284 1.466.286 2.219 0 2.285.042 4.569.06 6.856.022.803.023 1.603.029 2.405.069 2.505.066 5.007.01 7.51-.137 2.581.249 5.191-.444 7.74a2.843 2.843 0 01-1.086 1.345c-1.565-1.295-.907-3.08-.911-4.646-.018-8.787.062-17.575.125-26.362.008-1.106-.41-2.367.917-3.094z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A3EFE6"
        d="M131.466 306.839c-.165-1.544.557-3.53-1.875-3.97-1.335-.242-2.132-.858-1.976-2.317.102-.948.669-1.528 1.594-1.595 1.293-.094 3.234-.615 3.634.692.748 2.449 2.145 5.409-1.377 7.19z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9FEBFE"
        d="M139.53 310.87c-2.042.995-2.913.099-3.092-1.915 1.282-1.367 2.884-1.511 4.603-1.207 1.344.203 2.746-.06 4.049.491.802.496.977 1.236.819 2.105a1.74 1.74 0 01-1.01 1.188c-1.857.333-3.721.714-5.369-.662z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#82A084"
        d="M136.325 297.921l.298-1.236a4.449 4.449 0 011.426-.841c2.493-.403 4.98-.732 7.288.73.62.72.708 1.475.145 2.271-2.945.009-5.89.019-8.834.026-.108-.316-.216-.632-.323-.95z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C0EBC1"
        d="M111.555 240.746c1.197.065 1.975.57 1.975 1.887l-.134 6.289c-3.652-2.042-1.286-5.438-1.841-8.176z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EED048"
        d="M136.623 302.833c2.662-.021 3.98 1.644 4.851 3.869-1.655 1.557-3.312 1.358-4.968.001l.117-3.87z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F89594"
        d="M132.369 256.789c-4.133.547-4.048-2.181-3.869-4.982l-.063.063c3.443-1.273 3.924 1.28 4.614 3.568a1.748 1.748 0 01-.682 1.351z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#70ABB3"
        d="M136.506 306.703l4.968-.001.946.337c.294.888-.252 1.32-.917 1.688-1.688.075-3.376.15-5.065.227l.068-2.251z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3B82CC"
        d="M139.53 310.87l5.935-.005c.579.655.568 1.312.004 1.969l-4.027.008c-1.102.623-1.403-.461-1.992-.933l.08-1.039z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F09D9C"
        d="M119.61 246.785c1 1.135 4.845-2.19 3.674 2.347-1.601-.194-3.092-.559-3.674-2.347z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A5EADF"
        d="M132.369 256.789l.301-1.016c.678-1.555 1.706-1.79 3.057-.81.806 1.188.903 2.407.159 3.663l-1.412.194c-.411-.978-1.126-1.642-2.105-2.031z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B0D4D1"
        d="M113.446 294.863l1.012-.015c.8 2.657.792 5.313.001 7.971-.285.009-.569.028-.853.06l-.288-2.016c-1.035-1.33-.652-2.653.019-3.976l.109-2.024z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BEE2E0"
        d="M114.459 302.819l-.001-7.971 1.002-.03c-.427 2.655.999 5.543-1.001 8.001z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#62A7C1"
        d="M139.45 311.909c.664.311 1.329.621 1.993.933l-1.919 3.054-.999-.075.925-3.912z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F58D8D"
        d="M499.471 284.967v9.668l-1.006.014v-9.687c.338-.312.672-.327 1.006.005z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F99697"
        d="M519.497 326.835c-.293 1.313.623 3.047-1.256 3.759-.578.219-1.438-.014-1.365-.854.132-1.539.802-2.762 2.621-2.905z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A7A5D1"
        d="M499.471 284.967l-1.006-.006c-1.236-.282-2.816-.071-2.908-2.008.225-.105.455-.135.697-.087 1.629 1.181 3.762-.249 5.369 1.041-.449.896-1.345.888-2.152 1.06z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3A76BF"
        d="M502.446 282.778c1.139-2.274 3.131-2.089 5.16-1.787-1.518 1.177-3.166 1.981-5.16 1.787z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#746387"
        d="M501.624 283.908c-1.793-.326-3.832.628-5.367-1.041l6.205.078c-.282.321-.559.641-.838.963z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1E6AC3"
        d="M495.52 281.8c-.002.291.002.582.014.873-1.674.113-2.867-.921-4.148-1.746l1.189-.289c1.31-.447 2.674-1.024 2.945 1.162z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3EB3DE"
        d="M279.275 284.836c4.84 10.236 5.233 20.913 3.148 31.835-5.905 1.475-11.909.266-17.849.654-4.488-1.12-9.155-1.6-13.447-3.447-1.783-.767-3.834-1.28-4.795-3.299.532-5.905 1.642-11.773 1.139-17.746-.752-.89-.54-1.617.364-2.227 1.135.311.876-.14.781-1.022-.237-2.214-.636-4.636 2.14-5.801 2.12-.351 2.496-3.509 5.056-3.157 5.642 2.128 10.757.797 15.595-2.377 2.4-.934 3.795.081 5.237 2.071 1.049 1.45.95 3.508 2.631 4.516z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BFCA76"
        d="M219.498 280.728c-.708-1.343-1.999-.686-3.041-.885l-.989-1.063c-.836-1.064-.895-2.13-.009-3.199.909-.523 1.916-.607 2.886-.366 8.058 1.997 16.104 1.223 24.157-.015 1.466-.226 2.947-.52 4.423-.004 1.315.65 1.4 1.743 1.07 2.984l-.524.706c-1.725.131-3.587-.453-5.061.979-1.799 1.139-3.97-.191-5.781.87l-1.167.258c-4.256 1.81-8.717.335-13.057.813-.969-.358-1.938-.719-2.907-1.078z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#97ECF1"
        d="M246.333 310.58c5.462 2.886 11.934 2.977 17.262 6.233-4.948 1.45-10.127-.443-15.073 1.042l-1.943 1.044c-2.285.2-1.852-1.736-2.334-2.959-.13-1.494-.069-2.942 1.026-4.133l1.062-1.227z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1975CF"
        d="M248.439 290.773l-.967 2.062c-3.944-.755-3.854-4.201-5.229-7.418 2.66.469 2.424 3.637 5.229 3.521v-10.051l-.108-.227c.656-.211 1.192-.041 1.611.507 1.688 3.954-.315 7.739-.536 11.606z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#176DBB"
        d="M222.405 281.807c4.255-1.825 8.705-.536 13.057-.813-.981 3.154-3.603 1.565-5.508 1.79-2.137.252-4.327.058-6.493.058l-1.056-1.035z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1974CC"
        d="M219.469 293.835c-1.443-2.39 1.932-2.362 2.003-3.993 3.769.08 2.908-4.929 6.603-5.847-1.719 4.777-4.045 8.256-8.606 9.84z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#0F66B7"
        d="M245.272 311.807l.113 3.862c-1.351 1.49.976 3.968-1.392 5.186-.973-2.3-1.94-4.592-1.527-7.195.266-1.679.769-2.902 2.806-1.853z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#0F68B5"
        d="M232.465 300.833c1.815 1.756.678 4.003 1.001 6.008-2.465-.65-2.683-1.958-1.001-6.008z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#97E3E8"
        d="M243.993 320.855c.795-1.64.126-3.672 1.393-5.186.149 1.168-.11 2.487 1.194 3.229-.801 1.205-1.611 2.409-.78 3.938a3.146 3.146 0 01-.187.655l-1.969.377.349-3.013z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1568CA"
        d="M235.464 348.841c0 .163.016.327-.003.487-.145 1.212.45 2.743-1.262 3.291-.335.107-1.139-.217-1.206-.477-.37-1.433.443-2.438 1.472-3.304l.999.003z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2E639A"
        d="M240.527 340.313c.011 1.99.242 4.018-.967 5.806l-.063-7.203c1.192-.162 1.596.26 1.03 1.397z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#447165"
        d="M236.629 280.736c1.769-1.346 3.839-.685 5.781-.87-1.681 1.927-3.848.617-5.781.87z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1E6EC5"
        d="M242.675 327.917c-.088 2.106.074 4.257-1.106 6.167.214-2.084-1.104-4.442 1.106-6.167zM240.527 340.313l-1.031-1.398c-.033-1.236.495-1.991 1.793-2.082.17 1.252.058 2.444-.762 3.48z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B2D8C8"
        d="M99.417 292.933c3.427-.013 6.854-.056 10.28-.024 1.544.015 3.454-.519 3.744 1.958l-2.966-.037c-3.075-1.127-6.26-.211-9.38-.506a6.645 6.645 0 01-1.455-.137c-.288-.236-.417-.501-.387-.794.031-.307.085-.46.164-.46z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F68C8D"
        d="M106.302 296.192c1.332.389 1.138 1.48 1.123 2.444-.017 1.057-.261 2.072-1.616 1.986-1.236-.077-1.716-1.171-1.722-2.103-.008-1.286 1.044-1.963 2.215-2.327z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9EC5B4"
        d="M99.494 293.857c3.647.47 7.476-1.107 10.98.973-3.652-.03-7.303-.061-10.955-.09-.263-.189-.354-.383-.274-.581.081-.201.163-.302.249-.302z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A7F0E8"
        d="M91.464 292.837c.041-1.28.678-1.964 1.982-1.979l.028 2.009c.313.253.507.576.582.972-.05.397-.213.743-.473 1.045l-.374 1.965c-1.184-.092-1.699-.845-1.895-1.913 1.258-.613.299-1.385.15-2.099z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CFACAD"
        d="M82.303 340.598c-.808-1.331-3.073-1.683-2.605-3.873 1.462.246 1.749-1.559 2.983-1.708-.125 1.861-.251 3.722-.378 5.581z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#87F0DF"
        d="M103.613 342.554l-1.01 3.101c-2.039-1.688-1.397-3.414-.078-5.152.858.419 1.106 1.165 1.088 2.051z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F98D8B"
        d="M113.337 296.887l-.019 3.976c-.701.212-1.586.794-1.795-.472-.256-1.556.327-2.793 1.814-3.504z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BFB0AD"
        d="M93.583 294.883l-.023-1.013c1.957-.825 3.918-.775 5.884-.035l.049.021c-.014.295-.005.59.025.883-1.977.049-3.956.096-5.935.144z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#346494"
        d="M229.379 359.154a3.176 3.176 0 01-.801-.373c-1.527-8.374-.21-16.81-.547-25.209.175-.748.626-.996 1.352-.742l-.004 26.324z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4AA4EB"
        d="M229.779 312.526c.907 2.684.901 3.961-.277 5.209-1.779-1.705-.254-2.738.277-5.209z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#34638C"
        d="M229.382 332.83l-.388.004h-.388c-2.095-2.346-1.072-4.935-.586-7.482.233-.637.683-.886 1.347-.749l.015 8.227z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#126BC4"
        d="M233.467 286.84c-.106 1.733.078 3.444.489 5.138-1.85-1.579-2.064-3.288-.489-5.138z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#89C3E6"
        d="M229.367 324.602c-.242.119-.488.229-.737.332-.955-.36-.414-1.52-1.085-2.031-.337-1.194.578-1.987.947-2.955 1.803 1.267.412 3.135.875 4.654z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A8E9DE"
        d="M77.383 333.752l-.051 3.258-2.684 1.545c.483-2.277.953-3.852 2.735-4.803z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5CE3C9"
        d="M171.463 74.843l.005-1.029c5.136 5.602 9.192 11.889 12.025 18.952.535.696.613 1.388-.026 2.07l-12.004-19.993z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#54E1C5"
        d="M183.468 94.836l.025-2.069c4.555 4.203 6.036 10.418 9.874 15.091-.537 1.212-1.784.837-2.696 1.208-1.427-5.236-5.073-9.35-7.203-14.23z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B3EDE9"
        d="M555.481 202.824l-1.025-.008v-10.768l1.025-.009v10.785z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A4EFEC"
        d="M565.44 202.891c-3.332 1.46-6.656 1.541-9.973-.056l9.973.056z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4D719A"
        d="M139.479 339.686a33.374 33.374 0 01-.005-.707l14.977.016c.339.162.452.323.34.485-.112.162-.224.243-.339.243l-14.973-.037z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6188B2"
        d="M165.698 338.806c-1.796 2.177-4.127.868-6.244.959-.32-.173-.426-.345-.32-.517s.212-.258.321-.258l6.243-.184z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5A7DA8"
        d="M159.455 338.991c.007.259.007.518-.001.775l-5.004-.042a8.078 8.078 0 000-.73l5.005-.003z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#167ED4"
        d="M222.61 329.958c-.703 3.206-1.413 6.411-2.105 9.619-.457 2.117-.75 4.785-3.753 3.983-2.238-.598-5.158-1.226-4.345-5.043.682-3.198.678-6.54 1.313-9.752.536-2.71 2.178-4.41 5.314-3.843 2.868.518 3.83 2.277 3.576 5.036z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1968BB"
        d="M220.632 354.15c.207 2.822-.969 5.402-1.424 8.104-1.3-.807.02-2.911-1.736-3.481-.034-2.285-.133-4.612 3.16-4.623z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A4EFEC"
        d="M563.961 220.22v-14.708c1.946 5.253 1.909 10.367 0 14.708z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#AAEEEB"
        d="M58.469 138.842c-.01 1.572 2.436 4.258-2.276 3.318-3.729-.743-4.938 1.558-3.359 5.044.796 1.757 1.057 3.16-1.367 3.636-.02-.818-.19-1.563-.987-1.997.133-2.682-.584-5.47.996-7.971 1.997-.717 5.015 1.591 6.031-2.033.321 0 .641.001.962.003z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D4EEF5"
        d="M413.405 80.661c.008.668-.041 1.413-.783 1.573-.949.205-.973-.655-1.053-1.27-.084-.659.029-1.406.77-1.567.947-.206.908.667 1.066 1.264z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#176CBE"
        d="M318.55 45.819l-1.494-2.845c1.036.067 2.404-.643 2.938.732.418 1.076-.619 1.631-1.444 2.113z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FEFEFD"
        d="M373.465 258.711l-80.993.06c-2.917-2.216-.628-5.289-1.311-7.876-.156-3.728.952-7.05 3.212-10.002.758-.943 1.638-1.773 2.488-2.631 2.555-2.577 5.324-4.952 7.522-7.875.535-.742 1.121-1.433 1.957-1.857 1.356-.271 2.698-.288 4.002.268 1.547.887 3.29.925 4.855.479 5.114-1.457 9.672.375 14.285 2.06.639.102 1.284.157 1.922.186 3.121-.809-.123-3.301 1.198-4.573.405-1.401 1.587-2.521 1.483-4.109-.338-3.82-3.758-2.169-5.664-3.192-.799-.334-1.539-.847-1.711-1.687-.699-3.389-2.21-3.099-5.309-2.361-5.783 1.377-11.882.442-17.847.6-5.407-.508-10.921.932-16.282-1.011-.847-.308.136 1.362-.622 1.826-1.201 1.072-2.708 1.036-4.155 1.201-2.535.939-4.646 3.128-8.733 2.049 5.713 5.8-.217 6.771-2.411 9.247-.755.492-1.571.862-2.413 1.175-1.917.493-3.415 1.581-4.521 3.223-.269.352-.564.673-.872.988-1.323 1.188-2.401 2.681-4.146 3.343-4.043.181-5.605-1.78-4.919-5.683-2.149-2.746-4.796-.788-7.231-.775-2.613-.298-4.527-1.861-6.395-3.514-2.5-3.249-.572-6.025.936-8.846.187-3.808-2.435-2.798-4.328-2.303-3.875 1.013-1.763 3.39-.985 5.405.85 2.601.326 4.849-1.717 6.704-1.797.914-3.926 1.018-5.588 2.269-1.725.577-2.563 1.993-3.296 3.51-.666.854-1.445 1.605-2.122 2.448-.686.715-.886 1.815-1.566 2.432-3.777 3.424-4.487 7.187-1.561 11.493.17 1.59.15 3.166-.204 4.734-.447 1.447-1.068 2.769-2.509 3.506-3.158.742-6.33 1.53-8.428-2.065a8.101 8.101 0 01-.379-2.45c-.016-32.034-.247-64.068.108-96.088.55-1.578 1.085-3.69 3.024-1.153 1.841 2.408 3.44 4.646 6.327 1.269 1.197.19 2.516.763 2.74 1.805.632 2.938 2.171.779 3.313.773 1.475-.176 2.944-.181 4.395.191 2.047.544 1.789 2.494 2.385 3.927.997 2.396 6.795 5.185 9.763 4.688.437-.18.891-.266 1.361-.277 2.425.885 3.711.285 3.79-2.543.062-2.198 1.004-3.985 3.661-3.596 2.367.348 2.479 2.265 2.59 4.165.196 3.334.234 3.332 6.727 3.229-.291-1.457-.334-2.896.5-4.198.35-1.338-.91-2.322-.81-3.608.331-1.5 1.706-1.93 2.753-2.7.603-.356 1.232-.558 1.933-.33 2.422 2.366 5.369 1.34 8.173 1.251.714.102 1.349.36 1.832.921.35 2.036-1.085 3.797-.888 5.824.121 1.239.369 2.403 1.827 2.521 1.303.106 2.331-.525 2.331-1.966 0-1.972.692-3.593 2.805-2.958 2.236.672 5.852-1.645 6.578 2.474.485 2.75 2.191 2.846 4.313 2.87 2.224.024 4.545-.464 6.18-1.541 2.907-1.915 6.326-2.016 8.872-1.33 3.396.913 4.794-.839 6.751-2.392.473.012.903.155 1.293.424 3.255 3.959.714 9.014 2.51 13.256a6.79 6.79 0 01-.094 2.076c-.893 3.655-1.859 7.294-2.676 10.968-.313 1.413-.896 3.234.782 3.946 1.631.692 2.534-1.049 3.505-2.095.988-1.064 1.416-2.612 2.842-3.311.83.034 1.311.535 1.648 1.229.76 2.057.298 4.289.92 6.36.296 1.036.586 2.077 1.451 2.822 2.547.841 5.066.98 7.553-.161.916-1.016 1.229-2.295 1.568-3.564 1.011-2.396-.736-6.425 2.021-7.165 2.407-.646 2.599 3.711 4.559 5.206.52.396.932.942 1.394 1.411.604.484 1.473 1.627 1.811 1.281 1.188-1.214-.272-2.588-.206-3.941-.297-2.671-.013-5.387-.737-8.013-.474-2.611-.751-5.271-1.982-7.684-2.082-3.306-4.825-4.389-8.413-2.458-2.233 1.203-4.434 1.442-6.527-.181-2.758-2.136-5.423.417-8.133.063-1.146-.23-2.352-.358-2.043-2.079.844-4.714 7.685-8.882 11.621-7.08 1.5-.573-.601-.872-.134-1.376-.056-1.446.847-2.06 2.044-2.43 2.162-.291 4.293-.702 6.278-1.669 1.861-.52 3.712-1.115 5.683-1.046.939.111 1.852.362 2.771.569.682.158 1.321.416 1.869.827.099.1.234.205.317.342.23.377.728.442.716.216-.234-5.008 2.622-5.593 6.573-4.665.39.268.63.639.743 1.09-.188 1.106-.049 2.086 1.1 2.65.338.291.594.642.789 1.031.527.243-.488 1.936.819 1.162a163.66 163.66 0 013.599-2.07c1.223-.559 2.881-.617 2.885-2.563.275-1.516-.014-3.282 1.818-4.098 2.365 1.281 2.486 4.908 5.631 5.375.602.311 1.092.742 1.438 1.321.475.675.328 1.985 1.762 1.685 1.438-.44 2.963-.63 4.051-1.813 2.396-.729 4.877-1.205 7.131-2.366.469-.168.988-.434 1.434-.314 3.611.965 4.545-.223 3.109-3.626-.721-1.71-1.98-3.529.559-5.032.99-.586.004-1.486-.307-2.115-.588-1.189-1.285-.588-1.848.108-.879 1.088-1.875 1.857-3.387 1.48a2.905 2.905 0 01-1.523-1.447c-.436-1.421.324-3.041-.602-4.35-.861-1.216-1.25-3.992-3.631-1.356-.311.344-.973.427-1.412.239-5.19-2.209-9.59.114-14.588 1.339-4.283 1.049-9.769-.264-14.715-.616-.952-.067-1.402-2.221-3.072-1.958-1.323-.052-2.658.003-3.946-.332-1.321-.344-2.835-.964-2.501-2.491.276-1.265-.49-3.21 1.855-3.751 2.221-.512 4.173-1.85 6.578-2.032 8.947-.676 11.493-3.045 13.334-12.049 12.195-7.427 24.192-15.199 37.108-21.375 1.156 1.138 1.428 2.598 1.352 4.11-.834 16.512.072 33.04-.471 49.543-2.432 4.91-2.936 10.309-3.398 15.614-.504 5.766.416 11.641-.4 17.377-.48 3.37 2.949 2.668 3.627 4.573.295 10.138 1.031 20.261.6 30.395-1.758 4.729-2.949 5.425-7.393 3.77-1.855-.691-3.512.468-5.262.061-1.568-.032-2.645-.807-3.316-2.192-.951-1.354.369-4.282-2.842-4.073a1.698 1.698 0 01-.938-.917c-1.795-5.672-7.071-5.965-11.553-7.473-.951.038-1.881-.068-2.77-.423-.857-.396-1.527-1.049-2.229-1.651-2.594-1.566-4.381-1.352-4.717 2.115-.486.51-1.097.825-1.731 1.101-3.379 1.491-3.169 5.907-6.221 7.663-1.01.506-1.915 1.218-2.932 1.683-3.121 1.426-3.266 1.898-1.215 5.096 1.01 1.495 1.584 3.551 4.076 3.126.949.09 1.861.278 2.645.868.764 1.035.194 1.813-.488 2.571-.592.424-1.263.611-1.947.65-.271.1-2.148-.347-.145.539.406.18.779.419 1.154.674.522.431 1.25.915 1.232 1.518-.166 5.563 3.893 8.189 7.881 10.126 3.916 1.901 8.488.944 12.771.488 2.36-.251 5.104-1.959 5.706 2.169.459 3.145-2.291 5.867-5.92 5.945-8.738.186-17.478.138-26.217.137-.652 0-1.316.126-1.565.034 9.05.004 18.492.02 27.933-.056.967-.008 2.198-.337 2.581.848.479 1.474-1.146 1.76-1.859 2.563z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FCFDFD"
        d="M327.467 168.839c-4.093-1.857-10.419 2.236-10.681 6.942-.002.037.602.108.922.164.209 1.929-.42 3.336-2.418 3.895-1.645-4.188-.84-8.72-1.822-12.994.693-.949 1.822-.229 2.645-.683-1.026-.327-1.926-.166-2.646.68-1.839.057-1.522 1.896-2.306 2.681-.822.823-1.377 5.449-4.146.87-.706-1.167-5.595-1.367-7.131-.172-4.271 3.324-8.888 2.354-13.471 2.554-.671.029-1.679-.377-1.445-.984 2.455-6.392-4.024-2.561-5.376-4.657-.334-.519-1.874-.036-1.516 1.036 1.484 4.439-1.488 4.823-4.364 4.535-3.683-.369-1.833-3.551-2.208-5.548-.346-1.846 1.404-2.913 1.923-4.458-.952-3.623.425-7.367-.574-10.939-.703.313-.882 1.122-1.503 1.484-.636.254-1.255.228-1.87-.045-1.25-.909-1.586-3.138-3.806-2.612-1.799 2.644-.395 5.707-1.147 8.48-.195.742-.53 1.386-1.225 1.778l-.838.997c-.581.359-1.074.264-1.482-.279-1.71-3.743-.622-7.735-1.03-11.582-.382-.341-.155-2.217-.988-.952-.784 1.19-.115 3.196-.175 4.843-.208 5.769-1.685 6.832-7.409 5.337-2-2.114-.48-5.164-2.163-7.939-.676 3.048-.35 5.666-.388 8.248.05.423.097.852.173 1.266 2.467 2.494 6.328.607 8.878 2.82.5 1.846 2.356 2.195 3.586 3.237-1.604 2.246-1.898 4.154 1.375 5.977-3.689 0-7.38.044-11.068-.022-1.379-.024-2.424-.535-1.143-2.082.692-.837.836-1.77.81-2.769-.035-1.315.097-2.813-1.793-2.952-1.836-.135-1.998 1.164-2.19 2.588-.813 6.011-.846 6.006-6.034 3.205-.837-.949 1.075-1.8.327-2.934-1.567 1.008-.83 2.003-.327 2.934-.117 1.838-1.251 2.234-2.755 1.908-5.041-1.095-8.522-4.798-9.49-10.025-.168-.951.313-1.685.799-2.421.656-.896 1.303-1.809 2.533-1.962.917.082 1.635.528 2.217 1.209.462.38.821 2.146 1.451.077.126-1.557-.069-3.13.452-4.634.297-.688.75-1.197 1.529-1.328 1.502.693 1.318 2.37 2.058 3.507.376 1.19.45 2.5 1.37 3.471.299.231.606.455.938.626 1.368.307 1.505-.646 1.63-1.608.047-2.843.125-5.674-.154-8.434-1.018 1.932.7 4.918-2.399 5.937-2.32-.745-1.814-3.132-2.736-4.686-.306-.803-.465-1.66-.857-2.426-.806-.92-1.582-.963-2.32.072-.498 2.591.813 5.406-1.014 7.807-2.922.081-1.966-2.63-2.893-3.989a32.407 32.407 0 00-1.206-2.418c-.431-.762-.869-1.52-1.438-2.191-.785-1.847-5.028-.765-3.726-4.379.581-.598 1.27-.967 2.116-1.005-.932-.034-1.609.443-2.2 1.091-2.05 1.168-3.013 3.188-4.028 5.166-1.276 3.134-1.325 6.625-2.829 9.688-3.16 4.192-5.147 3.445-7.958-2.994-1.838-1.698-1.375-3.962-1.398-6.055-.049-4.46-.113-8.922.051-13.381.091-2.472 1.053-4.238 3.851-4.028 7.94.596 15.361-1.467 22.65-4.265 4.328 1.035 8.44 2.729 12.899 3.527 8.92 1.597 17.142.524 24.823-4.331.84-.17 1.676-.099 2.402.346 8.937 5.464 18.431 5.915 28.276 3.169 1.924-.177 3.437-1.079 4.581-2.631a2.632 2.632 0 011.182-.683c3.54 1.098 6.206 3.825 9.617 5.168l2.756.244c4.208.725 8.418.653 12.628.017.549-.061 1.098-.121 1.646-.183 1.837-1.292 4.082-1.246 6.123-1.87 4.404-.692 6.479-5.407 10.796-6.254.942.734.636 1.732.717 2.706.043-1.176.505-2.273.515-3.459 1.68-1.5 3.588-2.61 5.706-3.37 1.908 5.381-3.559 13.076-9.436 13.338-2.894.129-5.703-.309-8.57 1.506-1.436.908-3.014 2.115-2.893 3.06.285 2.232 2.565 1.186 4.045 1.408.648.098 1.326.017 1.99.018.477 2.438.156 4.683-1.586 6.591-1.188 1.244-2.434 2.362-4.365 1.796-4.525-2.416-8.728-1.569-12.73 1.284-1.145.112-2.238-.257-3.359-.349-1.076-.098-2.151-.155-3.221.05-1.963.174-1.986 2.66-3.701 3.12a2.256 2.256 0 01-1.186-.284c-.678-.674-.8-1.669-1.371-2.396-.012.022-.486-.076-.486-.076s-.434.214-.431.243c-.677 1.263-.541 2.957-2.078 3.716-1.188.448-2.336.401-3.44-.244-.998-.642-.846-2.104-2.334-2.959-.706 3.002-.456 5.812-.1 9.314 1.857-2.456 2.497-6.288 6.416-4.173.876.821 1.021 1.934 1.21 3.019.147.743.416 1.358 1.368 1.226.557-.18 1.073-.429 1.598-.675.787-.351 1.574-.679 2.464-.515 2.113 1.819 4.667 2.287 7.346 2.371 1.683.496 4.796-.923 3.985 2.94-1.301.034-1.965.703-1.998 2.001.59.664.585 1.33-.004 1.996z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3FB3DE"
        d="M236.146 129.557c-6.714 4.788-14.4 5.493-22.254 4.991-2.861-.184-3.777.539-3.667 3.406.241 6.291.208 12.592.287 18.89-.072 28.14-.131 56.278-.229 84.418-.019 5.316-.192 10.631-.294 15.946-2.426-1.265-2.062-3.645-2.073-5.705-.125-22.795-.049-45.589-.005-68.384.026-14.14-.27-28.28.079-42.404.322-2.78.388-5.471-2.719-6.917-1.261-1.041-2.687-1.862-3.945-2.909-1.813 1.379-2.286-1.616-3.813-1.17l.769-.991c1.208-.337 2.06-1.156 2.834-2.092.363-.229.75-.386 1.168-.479.858-.142 1.763-.174 2.243-1.089 15.396-9.478 30.792-18.955 46.187-28.437 1.266-.779 2.414-1.744 4.051-1.74 10.946.024 21.892.013 33.277 1.045l-44.69 27.804c-.589 1.045-1.528 1.667-2.582 2.157-.832.406-1.694.717-2.622.819-2.292-.238-4.583-.499-6.835-.442 1.411.445 3.12-.496 4.488.666.583.81.94 1.651.345 2.617zM281.225 124.632c12.778-8.603 26.989-14.969 39.432-23.93 13.028-9.383 27.108-4.044 40.595-6.112.139.398.275.797.414 1.196-6.083 3.843-12.213 7.615-18.239 11.547-8.875 5.789-18.294 10.744-26.641 17.343-1.217 1.425-2.917 1.515-4.574 1.532-8.823.09-17.647.087-26.47.002-1.653-.015-3.376-.012-4.517-1.578z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#251F5A"
        d="M399.483 206.841c3.273-.832 1.918-3.519 1.924-5.384.086-28.811-.113-57.623.188-86.431.07-6.798 2.709-13.474 1.992-20.445-.123-1.197.977-1.603 1.986-1.855l-.049.002c.926 3.433.195 6.934.428 10.396 0 33.322.018 66.643-.023 99.964-.004 3.506.107 6.965 1.084 10.347.193.593.27 1.206.236 1.829-.721 2.519-2.152 3.501-4.66 2.137-4.782-3.535-5.169-4.851-3.106-10.56z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#252241"
        d="M399.483 206.841c-.803 4.192.451 7.553 4.031 9.974-1.492.779-3.105 1.464-2.813 3.635-.004 1.02-.021 2.029-.285 3.024-.32.815-.613 1.655-1.742 1.581-.543-.399-.773-.929-.699-1.598.016-10.14.688-20.332-.188-30.388-.867-9.961-1.156-19.919-.578-29.794 1.197-20.402.465-40.797.771-61.19.01-.673.086-1.321.352-1.942l.676-.608.463 1.306c1.332 1.997 1.326 3.996.01 5.998.002 33.333.002 66.667.002 100.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E9E6FE"
        d="M398.333 100.143c.047 39.738.092 79.476.148 119.214.002 1.824.117 3.648.18 5.473 1.129 1.558 1.205 3.167.242 4.828-1.068.916-1.994.816-2.756-.4-.303-1.982.705-3.65 1.309-5.417l-.008-33c-.607-.733-1.07-1.536-1.215-2.495-.342-5.876-.068-11.76-.184-17.641.039-5.326-.305-10.686 1.4-15.863l-.012-54.704c.3-.065.597-.062.896.005z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#26225A"
        d="M310.646 126.892l4.855.112c-.278 3.166 3.041 4.208 3.942 6.677-3.96-.127-7.185-1.729-9.67-4.816-1.043-1.247.196-1.487.873-1.973z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1F2359"
        d="M199.467 122.839c-2.509.02-2.505 3.488-5.493 3.63 1.806-2.691-.352-3.605-2.093-5.071 4.011.387 8.183-2.748 11.585 1.443-1.334.962-2.667.968-3.999-.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6092C7"
        d="M279.472 125.029l-.885.852c-.383.395-.831.69-1.342.895-2.093.547-4.318.33-6.374 1.115-3.651.395-7.306.881-10.896-.383-.532-.296-.793-.752-.783-1.361 1.492-1.74 3.757-.049 5.38-1.207 4.967.028 9.933.059 14.9.089z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#184A7D"
        d="M264.572 124.939c-1.543 1.238-3.417.519-5.111.865-2.379 2.065-5.281 1.215-7.992 1.439-2.408-.019-4.826.114-7.221-.109-1.451-.136-3.394.214-3.555-2.169l2.657-1.226c3.445 2.332 7.283.738 10.926 1.033 3.414.277 6.863.128 10.296.167z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#618DC2"
        d="M325.492 125.858c.686-.008 1.369-.015 2.055-.021 4.311.147 8.501-1.569 12.85-.825.371.149.506.321.408.518-.104.207-.213.312-.326.312-4.976.988-9.993 1.207-15.043.806-.297-.197-.387-.38-.271-.548.109-.162.217-.242.327-.242z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#28235E"
        d="M199.467 122.839l3.999.001c-.198.745-1.009 1.545.195 2.163.129 1.12-.528 1.534-1.497 1.672a.839.839 0 00-.695.251c-.579.492-1.202.583-1.876.204-1.495-1.387 1.113-2.895-.126-4.291z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FEFEFD"
        d="M354.625 124.882c2.223 1.807-.498 3.715.113 5.556-.436.05-.963.272-1.281.103-.32-.171-.63-.747-.602-1.119.098-1.268.348-2.524.538-3.786l1.232-.754z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#251F5A"
        d="M399.481 106.838c-.002-1.999-.006-3.998-.01-5.998 3.094 1.994 3.084 3.993.01 5.998z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#26225A"
        d="M334.828 133.942c-4.211 1.229-8.42 1.126-12.627-.017l12.627.017z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#66B6E3"
        d="M325.492 125.858c-.022.263-.042.525-.058.789l-9.999.045c3.234-1.708 6.709-.507 10.057-.834z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#26225A"
        d="M342.597 131.889c-1.837 1.292-3.855 1.986-6.123 1.87 1.42-2.658 3.686-2.542 6.123-1.87z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#526AA1"
        d="M340.478 125.84a59.587 59.587 0 01-.082-.829c1.391-.148 2.794-.481 4.198.289-1.327.906-2.741.573-4.116.54z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3FABD8"
        d="M199.593 127.13l1.876-.204c-.216 2.098-1.713 1.932-3.188 1.802l1.312-1.598zM202.164 126.675l1.497-1.673c.291-.014.579.008.864.065.084.599.454 1.404.198 1.757-.804 1.107-1.702.1-2.559-.149z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#0B60A5"
        d="M395.524 75.977l2.973-.271c.043.363.086.727.131 1.09-.703 1.097-1.314 2.271-2.143 3.264-.535.642-1.422.869-2.256.326-1.379-.898.35-1.697.098-2.563.398-.616.797-1.231 1.197-1.846z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BAE7E9"
        d="M280.481 58.834c2.438-2.568 6.127-2.322 8.968-3.984-2.038 3.469-5.739 3.197-8.968 3.984z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ABD9E3"
        d="M287.458 50.844c4.009-1.58 8.018-1.628 12.026.004l-12.026-.004z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF8F8"
        d="M303.468 90.832l-16.009-.002c.016-.604.005-1.737.053-1.739 5.018-.267 10.047-.614 15.043.166.378.058.612 1.029.913 1.575z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#40B3DB"
        d="M478.379 199.945c3.129 4.853 2.322 9.415-1.021 13.788-.85 2.254-3.047 3.168-4.637 4.687-1.695 1.026-3.27 2.221-4.807 3.47-.891.606-1.707.063-2.545-.158-2.254.566-4.104 1.896-5.979 3.175-.58.422-1.219.641-1.941.578-.701-.185-1.201-.588-1.418-1.297-.602-2.039-2.738-3.32-2.801-5.635-.051-1.05.52-1.69 1.404-2.122 3.203-2.325 6.916-3.589 10.527-5.063 2.266-1.107 4.672-1.88 7.113-2.841-2.486-.237-4.129 3.105-6.809 1.314.611-1.038 2.162-1.45 2.113-3.106.461-.422 1.242-1.398.885-1.746-.561-.545-.279.419-.389.67-.18.41-.246.865-.496 1.076-4.398-1.143-8.83 3.041-12.891-.382 3.463-3.572 4.756-8.196 4.742-13.201-.014-4.729 1.986-8.092 6.111-10.275.566 1.254-.039 2.326-.516 3.421-2.516 6.301-1.771 8.925 2.908 10.186 1.223.028 2.441.01 3.662.046 1.488.119 3.029.106 3.996 1.549-.145 1.165-1.064 1.454-1.984 1.742.666-.104 1.234-.406 1.732-.851.465-.627 1.092-.772 1.822-.623.747.275.958.954 1.219 1.598z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#41B2DD"
        d="M423.575 190.835c1.174-5.542 3.035-10.77 6.889-15.087 2.283-2.441 4.148-2.963 5.018 1.092-1.352.096-2.947.415-3.365 1.619-.604 1.744 1.467 1.783 2.408 2.457 2.883 2.061 2.807 3.973-.051 5.923-1.264 2.783-.139 5.454.383 8.153.154 1.54.125 3.08.025 4.62-.615 1.755-.361 3.578-.416 5.377.076 2.086.178 4.174-.496 6.199-.066.779-.072 1.562-.111 2.343.02 2.713-.85 5.136-2.396 7.337-.467 1.738-3.098 1.843-3.018 3.996-2.57-.321-1.811-2.266-1.875-3.817.334-1.611.68-3.222 1.061-4.825 1.531-5.149 1.611-10.436 1.451-15.736a18.806 18.806 0 01.879-6.332c.193-2.37-1.623-4.498-.875-6.286-.191 1.259-.029 3.122.846 4.879.021.69.055 1.383-.176 2.053-1.559 1.111-2.594.324-2.783-1.167-.279-2.184-2.15-2.026-3.398-2.798z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#73F2DA"
        d="M435.481 176.84c-1.188-2.593-3.066-2.005-5.018-1.091-.309-2.589-2.053-.47-3.014-.92l4.02-9.994c.025-.225.053-.449.074-.676 1.592-2.239 1.924-5.765 5.789-5.694 1.34.574.445 2.162 1.346 2.93.406-.054.654.116.76.499.258 2.02-.637 4.229.99 6.023 1.246 1.462-.176 3.47 1.012 4.944l-.008.006c1.803 2.657.443 5.313-.002 7.971-.328-.003-.658 0-.986.009-.865-.864-2.229-.994-2.979-2.028l-1.984-1.979z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F78081"
        d="M433.641 226.879c2.141-.069 3.092-2.992 5.545-2.313.5.216.857.575 1.076 1.074.746 2.264.424 4.601.479 6.913-.02 1.017-.168 2.013-.504 2.976-.58 1.36-1.461 2.529-2.373 3.678-2.324 1.597-3.572 5.511-7.57 3.568-3.855-1.305-3.992-4.6-4.205-7.858.109-.937.52-1.739 1.098-2.469 1.127-1.398 2.74-2.27 3.918-3.615.763-.754 1.71-1.278 2.536-1.954z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECF8F8"
        d="M471.467 197.726l-3.975.019c-1.846-.775-2.152-2.315-1.916-4.046.244-1.789.371-3.563-.018-5.343-.313-1.951.209-3.777.85-5.586 1.168-1.967 2.961-3.114 5.063-3.856 1.055 2.352 4.314 1.118 5.443 3.349 4.027-2.249 1.9 1.531 2.543 2.598-4.439-.216-6.451 1.812-6.375 6.334.029 1.758-.213 3.64-.777 5.395a5.14 5.14 0 01-.838 1.136z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#40B3DD"
        d="M450.473 141.841l.994.998c2.723 3.188 5.035 6.628 6.469 10.605 1.166 2.646.75 5.564 1.441 8.292.18 3.368-.557 6.573-1.902 9.624-.398.9-.809 2.485-2.41 1.123-.184-3.249-.033-6.5-.086-9.745-.674-2.695-1.139-5.444-1.984-8.098-.709-2.58-2.592-4.479-3.916-6.705a15.246 15.246 0 01-1.588-1.914c-.744-1.073-2.141-2.213-1.348-3.483.955-1.534 2.68-1.703 4.33-.697z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#59B7DF"
        d="M431.542 228.866c-.529 2.181-2.348 3.042-4.08 3.99-1.119.964-2.426 1.289-3.871 1.149-.826-.098-1.582-.37-2.23-.902.717-4.739 2.689-8.856 6.104-12.257.135 1.386-.426 2.942.98 4.019-.344 1.519-2.336 2.727-1.172 4.395.277.395 2.088-.285 3.193-.47.388-.391.747-.366 1.076.076z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#48B8E3"
        d="M455.471 172.838c3.123-3.094 2.451-7.225 3.008-11.02a3.13 3.13 0 01.988-.979c1.037-.611 1.449-2.161 3-1.998l-.002-.001c-1.785 6.213-2.924 12.679-6.988 18.008-.768-.797-.408-1.796-.488-2.717a1.808 1.808 0 01.482-1.293z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#45B7E4"
        d="M450.473 141.841l-3.9.809 2.895 5.188c.277.226.369.45.275.673-.096.223-.189.334-.283.334-1.121-.958-2.105-2.194-3.387-2.825-5.012-2.464 1.199-4.927-.1-7.334 2.361-.175 3.428 1.493 4.5 3.155z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#48B8E3"
        d="M463.467 154.84c.875-3.803 1.164-7.797 3.572-11.252.697 1.29.238 3.296 2.426 3.25.68 1.168-.846 1.254-.99 2.018l-5.008 5.984z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#46B7E4"
        d="M465.467 209.84c2.971.374 4.637-2.298 7.129-3.063 1.008-.31 1.996-.713 2.43.61.365 1.111-.752 1.134-1.381 1.59-2.457 1.78-5.693 1.239-8.18 2.858-.346-.222-.461-.443-.346-.666.115-.221.23-.332.348-.332-.002-.332 0-.664 0-.997z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4ABBE6"
        d="M453.467 180.838c-1.254 4.677-2.383 9.413-5.992 13.004-.336.488-.67.465-1.004-.001 2.402-4.296 3.967-9.043 6.998-13l-.002-.003z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F2837E"
        d="M445.336 224.687l-2.867.297a3.376 3.376 0 01-.936.55 3.107 3.107 0 01-1.088-.004 2.507 2.507 0 01-.9-.599c-.121-.12-.242-.241-.359-.364.949-2.982 3.242-3.941 6.102-4.047 1.443 1.372 1.287 2.763.048 4.167z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4CBDE8"
        d="M442.467 203.841c-1.592 4.432-3.881 8.456-7.002 11.996a2.215 2.215 0 01-.688-1.151c-.061-.722.113-1.356.691-1.84 3.045-2.449 3.295-7.068 6.996-9.007l.003.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#40B9C5"
        d="M439.438 161.894a11.772 11.772 0 00-.918-.126c-1.82-4.742-1.443-9.701-1.449-14.623.117-1.851-.188-3.819 1.445-5.252.303-.037.604-.083.904-.138l.018 20.139z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4BBBE5"
        d="M465.467 210.838c0 .333 0 .666-.002.998l-11.016 5.011c-.666.546-1.33.63-1.99-.014 4.108-2.493 8.159-5.11 13.008-5.995z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#50BEEA"
        d="M457.45 152.842l-5.982-10.003c3.797 2.313 5.492 6.09 6.982 10.011-.338.488-.67.463-1-.008z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4CBDE8"
        d="M446.471 193.841l1.004.001c-.066 4.136-3.033 6.819-5.008 9.999l-.002-.002c-.172-3.936 3.272-6.424 4.006-9.998z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#43B5E2"
        d="M469.551 134.733c1.299 3.401.686 5.234-1.188 3.801-.553-.422-.588-1.464-1.076-2.04-.326-.385-1.033-.447-1.656-.688 1.307-1.421 2.744-.769 3.98-1.05.003 0-.06-.023-.06-.023z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#53BFEB"
        d="M435.465 214.835v1.002c-1.342 1.671-1.967 3.913-4.004 5.031.783-2.616 1.256-5.271 1.008-8.018 1.819-.575 1.774 1.662 2.996 1.985z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F1B165"
        d="M445.336 224.687l-.049-4.167c.072-.55.146-1.099.219-1.648.816-.813 1.746-.925 2.771-.456.42.313.68.728.789 1.239.029 2.11-.561 3.919-2.5 5.06l-1.23-.028z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5BB6DB"
        d="M448.614 219.787c-.088-.301-.174-.601-.26-.901-.357-.77-.02-1.347.518-1.868l.654-.273 2.934.09 1.99.013-.996 1.984c-.113.176-.229.353-.34.532-.822.727-1.775 1.147-2.873 1.231-.664-.025-1.248-.212-1.627-.808z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5BC5F2"
        d="M455.471 172.838c-.008.332-.012.663-.012.995-.324.45-.646.471-.963-.008-.012-3.995-.021-7.99-.031-11.984.33-.338.656-.352.977.013l.029 10.984z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#41B3E7"
        d="M441.43 180.838l.004-7.971c4.377 2.659.42 5.314-.004 7.971z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#52BEEB"
        d="M455.442 161.854c-.324-.009-.65-.014-.977-.013-1.502-2.458-1.461-5.303-2.004-8 .33-.389.662-.407.992.001.663 2.671 1.327 5.341 1.989 8.012z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4DBBE8"
        d="M434.471 194.84c-1.545-2.668-1.563-5.335.002-8.001-.508 2.771.953 5.303.98 8.009-.329.467-.658.488-.982-.008z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#54C2EE"
        d="M434.471 194.84c.328 0 .656.003.982.008v9.974l-.633.362c-.473-.212-.734-.583-.814-1.089.133-1.418-.439-2.91.441-4.251l.024-5.004z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C7F4F6"
        d="M481.438 164.792c-.387 3.331 1.352 6.89-1.074 10.001.822-3.283-.678-6.817 1.074-10.001z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#57C5F1"
        d="M457.45 152.842l1 .008c.832 2.601 1.262 5.252 1.018 7.989l-.988.98c.438-3.082-.726-5.98-1.03-8.977z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#39B3EA"
        d="M445.467 214.85c.113-1.824 1.326-2.205 2.781-1.886.809.178 2.197.376 1.213 1.884-1.33 1.064-2.662 1.062-3.994.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#50C0EB"
        d="M454.497 173.826c.32.009.641.012.963.008l.018 3.015c-.186 1.574-.701 2.982-2.01 3.99l.002.003c.341-2.34.685-4.678 1.027-7.016z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4FBDE9"
        d="M453.454 153.842l-.992-.001c-1.307-1.481-2.766-2.871-3.002-4.996l.008-1.007c1.72 1.742 2.972 3.794 3.986 6.004z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A1EAF5"
        d="M466.409 182.77c1.215 1.678-.262 3.377.037 5.063-1.656.237-2.367-.446-2.061-2.119.387-.946.771-1.893 1.158-2.839.29-.023.579-.058.866-.105z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#51C2EC"
        d="M468.475 148.856c-1.068-1.359 1.137-1.111.99-2.018 1.246-.68 2.543-1.164 4.002-1.006.289.221.385.44.287.66-.098.219-.193.328-.291.328l-4.988 2.036z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#49AFD6"
        d="M445.467 214.85l3.994-.002.064 1.896-.104.156c-1.291.784-2.588 1.056-3.902.05l-.052-2.1z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4AB5DE"
        d="M435.465 214.835c-2.424 1.491-1.746-1.701-2.996-1.984.334-.337.666-.674.998-1.012.326-.495.656-.522.988-.004l1.014 1.011-.004 1.989z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B1A197"
        d="M445.52 216.951l3.902-.051c-.355.662-.711 1.324-1.068 1.985l-2.848-.014.014-1.92z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4AB5DE"
        d="M434.463 204.837c.33.003.66-.002.99-.016.445 2.133.863 4.263-.975 6.026-.786-2.001-.765-4.005-.015-6.01z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5DC2EC"
        d="M434.463 204.837l.016 6.011c-.012.329-.02.658-.023.987-.33.004-.658.006-.988.004.002-2.33.004-4.66.008-6.99.328-.459.66-.46.994-.005l-.007-.007z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3EB5C7"
        d="M441.44 172.862c-1.525-1.405-.789-3.273-1.012-4.944 2.139 1.28.539 3.324 1.012 4.944z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C7F4F6"
        d="M475.481 176.894c.773 3.977-2.225 1.179-3.301 1.836.852-1.058 1.842-1.869 3.301-1.836z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#48B8E3"
        d="M462.467 158.841c-.008-1.419-1.412-3.187 1-4.001v-.001c-.143 1.382.463 2.95-1.002 4.001l.002.001z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4EBFEB"
        d="M473.463 146.821l.004-.988c.766-1.169 1.855-1.005 3.838-.804-1.765.823-2.805 1.307-3.842 1.792z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C7F4F6"
        d="M479.463 174.941c-.238 2.156-1.799 1.892-3.273 1.788.887-.968 1.853-1.793 3.273-1.788z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#41B2DD"
        d="M437.465 178.819c1.447.01 2.387.764 2.979 2.028-1.463.012-2.901-.009-2.979-2.028z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#53C5F1"
        d="M431.542 228.866c-.357-.024-.717-.05-1.076-.076.619-1.366 1.693-1.979 3.176-1.91-.067 1.329-.724 2.038-2.1 1.986z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3FB3DE"
        d="M527.467 168.773c5.488.002 10.977-.005 16.467.007 1.553.003 3.211.076 3.104 2.229-.088 1.805-1.574 1.881-2.947 1.883-11.311.012-22.621.02-33.93.016-1.361 0-2.742-.016-2.766-1.966-.027-2.277 1.596-2.161 3.107-2.165 5.655-.015 11.311-.006 16.965-.004z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5EA8C0"
        d="M507.508 178.879c.346-2.646 2.439-1.772 3.895-1.783 10.475-.077 20.949-.07 31.424-.047 1.758.004 4.15-.447 4.264 2.175.131 3.038-2.457 2.542-4.371 2.549-10.475.033-20.951.035-31.426.003-1.252-.003-2.717.493-3.6-.98 1.555-1.387 3.467-.92 5.246-.93 8.307-.049 16.615-.022 24.922-.023-8.531-.01-17.063.011-25.592-.018-1.637-.006-3.357.281-4.762-.946z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3DB4DF"
        d="M507.508 178.879h37.283c.012.639.023 1.278.037 1.917h-37.135c-.062-.639-.122-1.278-.185-1.917z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#82F2DC"
        d="M497.545 171.877c0 .664.018 1.328-.004 1.991-.09 2.859-1.4 5.574-3.734 6.568-2.387 1.017-2.338-2.62-3.908-3.742-.936-.669-2.219-1.533-2.162-3.867 3.461 1.26 6.824 1.418 9.689-1.064l.119.114z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9EEFDB"
        d="M497.426 171.763c.066-.63-.014-1.324.229-1.878.488-1.127 1.594-1.522 2.711-1.673.271-.036.842.476.9.803.26 1.438-.949 1.895-1.898 2.414-.531.291-1.211.308-1.824.448l-.118-.114z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2866B5"
        d="M491.374 244.838l.096 3.988-2.844.977-.232-1.826.123-2.13c.754-4.337.738-8.675.012-13.014a6.965 6.965 0 01-.115-.887c-.234-1.389.205-2.255 1.752-2.268 1.627 3.194.428 6.614.783 9.91.188 1.746-.394 3.555.425 5.25z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1472CA"
        d="M514.405 273.863c-.668 2.148-1.877 3.176-4.164 2.058-.508-1.674 3.688-1.874 1.227-4.076-.715-.289-1.809-.388-2.068-.905-.6-1.193.699-.999 1.314-1.252.975-.399 1.857-.442 2.424.686.56 1.114-.016 2.639 1.267 3.489z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#20367A"
        d="M492.372 248.928l1.113-.158c.676-.528 1.336-.52 1.98.056 2.826 2.128 6.127.411 9.129 1.128-2.893 1.841-6.127.451-9.16.964-.365.379-.666.352-.891-.143-.722-.616-1.447-1.232-2.171-1.847z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1973C7"
        d="M509.551 254.717c-.156.616-.209 1.286-.494 1.836-.4.771-.605 2.012-1.977 1.446-.414-.17-.98-.517-1.051-.867-.258-1.288.947-1.467 1.727-1.874.549-.286 1.219-.343 1.834-.503l-.039-.038z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1674CF"
        d="M502.706 253.204c-1.59 1.967-2.656 2.663-5.123 1.771 1.55-1.37 2.769-1.713 5.123-1.771z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#176FCA"
        d="M496.461 269.859l-.996-1.019c1.248-.68 2.545-1.158 4.002-1.002l.002.003c.717 1.086.973 2.313-.189 3.095-1.182.793-2.199.135-2.819-1.077z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#136DD1"
        d="M509.454 260.842c.043-1.37.842-1.974 2.121-2.091l-.02-.023c-.355 1.54.65 3.771-2.082 4.106-.537-.659-.609-1.322-.019-1.992z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1173BD"
        d="M509.454 260.842l.02 1.992-.008 2.007c-.322.345-.65.349-.98.013-1.39-1.751-1.862-3.28.968-4.012z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1570CE"
        d="M493.463 269.842c-1.217 2.575-3.041 2.104-4.992.996 1.399-1.665 3.309-.76 4.992-.996z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#176FCA"
        d="M495.026 265.352c-.209-.942.221-1.319.705-1.288.602.04 1.42.195 1.725.609.584.795-.143 1.135-.83 1.103-.586-.027-1.163-.3-1.6-.424z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1774CD"
        d="M503.467 264.838l-.992-.005c-.076-.739-1.707-.966-.896-1.748.512-.494 1.82-1.156 2.588-.252.58.683.07 1.513-.7 2.005z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1972CB"
        d="M507.465 272.84c-1.152-.2-2.686.583-3.367-.753-.531-1.039.691-1.043 1.367-1.247.955.38 1.621 1.045 2 2z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1975CB"
        d="M508.485 264.854l.98-.013 1.57.861c-.281.321-.521.868-.848.923-1.331.227-1.569-.754-1.702-1.771z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1775CB"
        d="M503.272 258.918c-.57.341-.916.711-1.281.73-.682.038-1.246-.361-1.008-1.108.086-.269.77-.503 1.158-.471.334.027.635.456 1.131.849z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1777D0"
        d="M494.543 250.775c.305.003.602.051.891.143-.594.978-1.148 2.105-2.588 1.454-.316-.143-.426-.74-.631-1.129l2.328-.468z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1879CF"
        d="M507.438 252.865c-.709.282-1.082.541-1.455.54-.246 0-.605-.322-.719-.585-.305-.714.268-.904.754-.826.393.062.736.432 1.42.871z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1776CA"
        d="M503.467 268.849c-1.107-.67-.09-1.338.002-2.007.52.257 1.412.432 1.488.784.235 1.081-.761 1.073-1.49 1.223z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FD8080"
        d="M421.446 232.717l2.023.292c.799.938 2.33.678 3 1.831 1.529 2.286.625 5.947 4.047 7.166-.311 2.632-2.389 3.565-4.449 3.802-4.092.47-7.813 2.348-11.863 2.822-2.258 1.601-1.104 3.979-1.342 6.012-.326 2.782.068 5.665-1.242 8.301-.07 1.302-.143 2.604-.215 3.906-2.273.658-3.877 3.321-6.895 1.879 1.174 1.739 2.633.785 3.846 1.09-7.586 2.045-15.236 1.001-22.873.454-1.295-.093-2.578-.354-3.867-.538l-.322-3.624c-.412-.446-.385-.865.08-1.256.063-2.063 1.158-4.23-.611-6.111.148-4.655 1.521-9.09 2.98-13.411 1.092-3.236.604-5.328-2.125-7.257-1.76-1.243-2.939-3.153-4.447-4.702-.873-1.101-1.654-2.265-2.389-3.461-1.658-2.538-2.627-5.418-4.01-8.099-.549-2.354-1.311-4.677-1.035-7.149a2.57 2.57 0 01.828-1.178c4.233-.261 6.579 2.455 8.706 5.52l.027-.009c1.869.811 3.115 2.266 4.117 3.976.559 1.382 1.623 1.919 3.061 1.831 3.459.998 7.221 1.266 9.912 4.115l1.941.889c.473.058.896.231 1.262.534.305.338.545.721.732 1.133.688 2.809 2.137 1.65 3.553.663 1.154-.47 2.352-.548 3.57-.45.734.07 1.438.264 2.107.568 3.256 1.952 6.537 1.785 9.842.114.738-.202 1.426-.111 2.051.347z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#41B2DE"
        d="M441.465 252.84l-2.006 1.004c-1.854 1.103-4.045 1.188-5.996 1.999l.008-.006c-6.471 1.456-12.984 2.377-19.635 1.54-.861-.568-.984-1.379-.75-2.302 2.146-2.253 5.09-2.112 7.828-2.626 3.428-.644 6.896-1.132 10.162-2.444 2.859-.716 5.564-1.991 8.514-2.399 2.186-.047 4.404-.392 6.479.662 1.328 1.214.295 1.877-.602 2.572v-.001c-.988 1.361-2.773 1.123-4.002 2.001z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#979FB4"
        d="M413.592 254.848l-.012 1.997c.488.667.486 1.327-.023 1.981-.395 1.49.523 3.598-1.938 4.116-.025-4.251-.07-8.503-.064-12.754.002-1.448-.199-3.111 2.039-3.15 1.434 1.651 1.201 3.616 1.059 5.567-.121.857-.553 1.568-1.061 2.243z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#51BFE9"
        d="M413.557 258.827c.006-.66.014-1.321.023-1.981 6.65.044 13.303.157 19.891-1.008-6.347 2.935-13.232 2.291-19.914 2.989z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6DAB93"
        d="M446.42 249.07l-6.883-.262-.369-.672c.217-.486.57-.837 1.053-1.059 2.725-1.331 5.447.561 8.174.012l2.123-.067c-.01.289.025.571.104.85-.391.382-.781.765-1.174 1.146-.998.66-2.006.745-3.028.052z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#47B5E6"
        d="M446.42 249.07c1.01-.019 2.02-.036 3.027-.053-.439 2.548-2.475 1.606-3.98 1.823.319-.59.637-1.18.953-1.77z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#51BFE6"
        d="M433.463 255.843c1.732-1.469 3.803-1.916 5.996-1.999-1.57 1.949-3.75 2.073-5.996 1.999z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4FB5E7"
        d="M441.465 252.84c1.016-1.304 2.416-1.835 4.002-2.001-.326 2.683-2.429 1.811-4.002 2.001z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#106ECB"
        d="M495.52 281.8c-.699-1.104-1.908-.917-2.947-1.161.215-.79.531-1.696-.736-1.789-1.926-.142-2.871-1.145-2.029-2.882.906-1.875 4.059-1.372 4.197-.954.716 2.171 5.048 3.741 1.515 6.786z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#116BC4"
        d="M496.461 269.859c2.348 1.333 3.18.406 3.008-2.018 2.85 1.976 2.637 4.384.988 6.995-.75-1.035-2.229-.979-2.99-1.996-2.593-.232-1.566-1.685-1.006-2.981z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1776D0"
        d="M507.6 277.04c-.412.181-.959.574-1.537.63-.703.068-1.43-.401-1.043-1.153.207-.4 1.125-.511 1.742-.6.49-.072.971.134.838 1.123z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1B74CE"
        d="M501.67 278.017c-.426.203-.959.566-1.547.705-.463.109-1.135-.2-.84-.74.264-.482.953-.826 1.527-1.015.437-.143.948.094.86 1.05z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1873D0"
        d="M497.467 272.84c1.449-.012 2.91-.041 2.992 1.996-1.453.017-2.904.033-2.992-1.996z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EAD441"
        d="M456.434 223.927l.969 1.093c1.012 1.136.748 2.913 1.979 3.938-.064 3.545 1.848 6.556 2.965 9.712 1.838 5.2 1.813 5.746-3.756 6.334l-.199-.302c-1.275-4.454-1.66-9.105-2.996-13.546-.93-1.305.18-3.049-.93-4.317l-.996.003-.004-.004c-.143-1.585 1.5-2.005 2.047-3.141.409-.335.716-.259.921.23z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DDC337"
        d="M441.526 224.961c.316-.054.629-.047.943.021 2.016 7.182 1.676 14.793 3.996 21.918-.975.612-1.998.476-3.025.196-1.76-1.726-.424-4.089-1.199-5.842-.145-.828-1.09.019-.451-.174.055-.017.074.056.127.189.898 2.304.932 4.381-1.508 5.83-.58.126-1.051-.042-1.424-.503-1.139-2.102-.926-4.36-.809-6.609.377-1.351.352-2.829 1.252-4.017l.164-3.086c.297-.361.535-.757.717-1.188.65-2.199-.719-4.767 1.217-6.735z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EAD441"
        d="M447.467 232.837c-.152-4.151 1.852-6.146 5.998-5.999l.004.004-.002 3.996c-1.143 1.169-2.723 1.615-4.064 2.463-.725.173-1.385.082-1.936-.464z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EED33C"
        d="M447.467 232.837l2.002.002c1.332-1.068 2.664-1.067 3.996-.001-.301 1.146-.133 3.763-.865 3.195-2.014-1.559-5.203.16-6.449-2.659.439-.178.877-.358 1.316-.537z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DDC535"
        d="M455.465 230.85c2.063 4.39 2.869 9.043 2.928 13.854-2.387-3.968-2.688-8.41-2.936-12.863-.271-.223-.361-.443-.268-.663.093-.219.185-.328.276-.328z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B2B762"
        d="M448.614 219.787l1.787.127c.785.437 1.68.825.861 1.964-1.199 1.555-2.539 2.873-4.697 2.838.684-1.644 1.365-3.287 2.049-4.929z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F0D33B"
        d="M453.303 240.17c-2.07.834-3.668 1.002-6.465-.721 2.928-.565 4.551-1.191 6.465.721z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#8AC8B0"
        d="M439.594 246.718c.314.049.623.024.928-.073.986-.47 1.973-.714 2.939.048l3.004.208 1.93.188c-2.814 1.549-5.877.347-8.789.801-.248-.258-.332-.517-.252-.778.078-.263.158-.394.24-.394z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4AB4E5"
        d="M456.434 223.927a26.965 26.965 0 00-.922-.229c-.359-.972-1.289-.773-2.02-.984-1.139-1.286-1.059-2.582-.033-3.886l-.006.003c2.719.69 1.926 3.433 2.981 5.096z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3DB4D9"
        d="M453.459 218.828c.012 1.295.021 2.591.033 3.886-.969.324-1.775.217-2.23-.835l-.861-1.966 3.058-1.085z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F0D149"
        d="M453.465 232.838l-3.996.001c.328-2.676 2.428-1.808 3.998-2.001l-.002 2z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D5BF2F"
        d="M456.436 246.667l-4.93.012c1.641-1.246 3.284-1.243 4.93-.012z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E1C73C"
        d="M455.465 230.85c.002.331-.002.661-.008.991-1.65-1.405-.75-3.316-.992-5.002 1.471 1.054.856 2.627 1 4.011z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C6ABB0"
        d="M465.37 221.731c.67-1.167 1.506.159 2.234-.149.846.098 1.543.483 2.131 1.089.209.36.32.75.34 1.165-.08.411-.273.762-.576 1.052l-.527 1.003-.455-.034c-1.3-1.187-3.591-1.613-3.147-4.126z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B1E9BF"
        d="M459.381 228.958c-2.311-.483-1.783-2.394-1.979-3.939l1.988-.113c-.901 1.349.271 2.702-.009 4.052z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8957C"
        d="M409.502 275.642l-3.881.262c-3.527.146-7.045.052-10.549-.42-.574-.279-.781-.729-.621-1.346l11.98-.314c.95.73 3.687-1.554 3.071 1.818z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EF8D8D"
        d="M381.719 274.732c-.193-.827-.074-1.538.746-1.983l4.826.2c.447.239.592.61.48 1.097a4.331 4.331 0 01-.748 1.146c-.174.147-.355.289-.531.436-1.833 1.004-3.458.882-4.773-.896z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D79472"
        d="M386.512 274.814l1.01-.987c1.986-.735 3.969-.754 5.951.015.326.098.652.195.979.295 0 .23-.002.459-.004.688-2.647 1.513-5.293 1.525-7.936-.011z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6DBAB"
        d="M393.473 273.841l-5.951-.014a8.463 8.463 0 00-.229-.879c2.081.141 4.332-.887 6.18.893z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#156DC9"
        d="M485.467 230.746l-4.014-.201c.211-1.667-1.998-1.316-2.242-2.569.873-1.879 4.221-.22 4.26-3.127.463-.839 1.221-1.234 2.121-1.425.459.006.859.161 1.209.459.369.576.49 1.209.43 1.881-.113 1.219-1.398 2.037-1.148 3.386.033.624-.096 1.186-.616 1.596z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#93DCE7"
        d="M469.637 223.764a4.932 4.932 0 01-.082-.932c1.102-1.203 2.57-1.293 4.057-1.344 1.801-.134 3.514.117 5.025 1.196 3.574 1.717 4.332-3.986 7.664-2.908 1.049 2.781-1.084 3.482-2.879 4.405-.992.114-2.004.408-2.902-.322-.375.009-.752.018-1.129.025-3.26.657-6.514.828-9.754-.12z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1B6CAD"
        d="M469.637 223.764l9.754.121c-1.033 1.451-2.588.782-3.932.969-1.988.011-3.975.021-5.961.033l.139-1.123z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#166DB0"
        d="M480.52 223.86l2.711-.094c.758-.431 1.502-.522 2.213.098-.42.803-1.166.955-1.973.984-1.076-.054-2.256.206-2.951-.988z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1168BE"
        d="M485.467 230.746l.006-1.898c.896-.728 1.967-.652 3.021-.659.426.074.807.244 1.143.517.207.413.15.788-.166 1.124-.354.705-.705 1.411-1.059 2.117l-.416-.021-.418.028c-.308-1.09-1.324-.952-2.111-1.208z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#26519E"
        d="M488.528 232.833c1.576 4.34 1.535 8.678-.012 13.014l.012-13.014z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F58E7E"
        d="M386.512 274.814l7.936.011c3.748.11 7.553-.377 11.172 1.078-.096.293-.189.587-.285.88l-5.852.176-10.848-.19c-.643-.734-2.508.039-2.242-1.815l.119-.14z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F8E27F"
        d="M99.467 214.841c-2.03-1.555-.117-4.201-1.633-5.897-.199-2.521 1.236-4.322 2.699-6.11 2.41-.428 3.353 1.464 4.584 2.899l1.403 2.071c.215 1.153-1.004 1.716-1.174 2.742.83-.028 1.482-.516 2.238-.624.665-.091 1.337-.069 2.007-.103l1.866 1.282c1.106 1.956-.705 2.273-1.695 3.054-.816.529-1.389 1.245-1.396 2.241 0 .093.889-.123 1.384-.081 1.213.306 1.939 1.03 2.038 2.305-2.61 3.09.066 4.43 2 6.014.316.618.372 1.266.203 1.935-.34.761-.771 1.52-.128 2.346.243.627.249 1.255.035 1.892a3.327 3.327 0 01-.852 1.018c-2.079 2-3.099 2.025-4.412-1.11-2.358-5.632-5.488-10.942-9.167-15.874z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#0F0F0C"
        d="M93.51 202.844c1.842-4.951 5.496-8.139 10.099-10.424 1.937-.962 3.543-.426 4.975.974 1.542 1.508 1.134 2.917-.305 4.231-2.01.595-3.847-.231-5.728-.696-.302-2.04-1.27-1.646-2.125-.456-1.726 2.402-3.317 4.902-4.964 7.361l-1.952-.99z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E39594"
        d="M102.551 196.929c2.121-1.516 3.871.037 5.728.695-.683 2.849-4.069 4.644-3.161 8.109-2.16.028-2.864-2.242-4.587-2.9.034-.195.076-.39.125-.582.414-1.871 1.017-3.674 1.916-5.372l-.021.05z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1B1916"
        d="M84.443 232.828c-2.091-2.405-.83-4.24 1.016-5.976 1.588-.172 1.912-2.873 4.018-2.01-1.626 2.695-4.809 4.408-5.034 7.986z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#191414"
        d="M94.469 214.826c1.554-2.153-3.439-5.239.995-6.981-1.38 2.177 1.454 4.955-.995 6.981z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#0F0F0C"
        d="M102.573 196.879c.377 2.153-.556 3.839-1.917 5.372-1.448-2.535.442-3.879 1.917-5.372z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5CEDD0"
        d="M91.467 280.839c8.059-.104 16.123-.257 23.982 2.014-.197 2.165-1.875 2.268-3.286 1.925-6.021-1.463-12.129-.705-18.193-.992-1.62-.077-4.068.057-2.503-2.947z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3BE8C4"
        d="M109.437 276.858l-17.972.037-.912-1.062c7.08-2.012 14.023-1.187 20.902.999-.666.577-1.339.574-2.018.026z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D0C1BE"
        d="M99.444 293.835l-5.885.035-.085-1.004 5.943.065c.031.302.04.603.027.904z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CAF5F6"
        d="M102.458 163.067l-.633.836c-.339-.541-.777-1.05-.963-1.639-.069-.218.496-.918.706-.891.824.108.815.859.89 1.694z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#49DBC0"
        d="M109.437 276.858l2.018-.024 3.949-.013c-1.98 1.704-3.97 1.385-5.967.037z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#251F5A"
        d="M205.467 132.837c3.316.703 4.978 2.484 3.931 6.031-1.305 2.053-2.259.881-3.329-.531 1.432 9.565.488 19.004.823 28.409.302 8.489.626 16.971-.013 25.458-.16 2.129.204 4.319-.843 6.329-.515.719-1.233.911-2.068.794-2.098-.802-.999-3.296-2.369-4.486l-.31-6.024c-.348-3.275-.524-6.572-1.255-9.801-.055-2.142-.205-4.304 1.242-6.141l.02-4.054.235-36.779c1.517-.751 2.709.11 3.936.795z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3FABD8"
        d="M205.467 132.837l-3.936-.796-.205-1.153c1.765-.17 3.337.073 4.141 1.949z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#76F2DB"
        d="M201.276 172.875l.016 5.976c-.423 1.231-.636 2.776-2.582 1.938-5.892-2.536-12.205-4.135-17.553-7.878-.188-1.54.014-3.073-2.221-3.671-1.765-.473-4.478-1.384-3.582-3.845.91-2.496 3.297-1.185 5.133-.565l2.98.975 7.995 3.075c2.011 3.562 6.074 2.464 8.993 3.962.274.012.547.023.821.033z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6EF4DB"
        d="M200.456 172.842c-3.4-.408-7.851 1.568-8.993-3.962 2.874 1.599 6.539 1.406 8.993 3.962z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#71F4DA"
        d="M180.487 164.831l-4.808.256c1.816 3.587 5.288 3.233 7.905 4.384.273 1.836-2.629 1.496-2.113 3.317-1.979.313-3.454-.952-5.115-1.63-1.791-1.69-4.879-1.28-6.161-3.793-.018-1.06 1.387-1.41 1.272-2.525-1.572-2.68-4.221-4.114-6.754-5.599-1.088-.638-2.053-.936-1.252-2.39 1.25.647 2.533 1.164 3.987.993 3.756 3.43 9.049 3.993 13.039 6.987z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1B274A"
        d="M405.467 102.834c.02-3.368.037-6.737.057-10.106a.763.763 0 01.852.195l.02 9.904c-.306.463-.616.465-.929.007z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3FB3DE"
        d="M409.403 232.972l-2.066-.16a5.079 5.079 0 01-.678-1.271 4.299 4.299 0 01-.021-1.409c.256-1.026.857-1.916 1.891-2.052 3.961-.519 4.264-2.865 3.164-5.993a10.508 10.508 0 01-.641-1.13c-.434-1.061-1.551-1.494-2.197-2.366a6.602 6.602 0 01-.838-1.941c-.91-2.23-2.57-4.396-.605-6.875l.213-1.161c2.166-.072 3.174 1.529 4.301 2.963.736 1.349.393 3.077 1.502 4.302-.277 2.457 1.395 4.25 2.51 6.041.879 1.411 1.291-.242 1.543-1.069a4.27 4.27 0 00.787-1.044c.516-1.655-.301-3.618 1.168-5.052.482-8.129 2-16.077 4.139-23.919 1.906-.816 4.146-2.721 4.254 1.579.021.913-.258 2.545 1.635 2.426 1.127 7.41.625 14.747-1 22.033-.131 1.375.463 2.931-.998 3.972-1.434 4.248-3.227 8.313-6.018 11.872l-1.887.322c-3.394 1.175-6.781 1.271-10.158-.068z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#67EAD1"
        d="M413.426 215.878c-1.699-.804-2.061-2.291-2.035-3.978.674-.588 1.361-.661 2.07-.064l.01.008c-.015 1.345-.029 2.69-.045 4.034z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#75EFF3"
        d="M418.344 220.819a8.048 8.048 0 00-.865.031c.328-1.995-.869-4.252 1.027-5.977.629 2.001.868 3.991-.162 5.946z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#40B8C9"
        d="M418.344 220.819c.055-1.981.107-3.964.162-5.946.313-.025.621-.064.93-.117-.318 2.028.963 4.345-1.092 6.063z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#75F3DB"
        d="M430.469 140.84l3-.001 4.02.012c.928 1.853.26 3.835.463 5.744-.004 2.144.01 4.29-.008 6.434-.439 4.88-4.738 7.646-6.48 11.813l.006-.007c-3.105 1.778-2.986 5.744-6.117 8.718l3.117-22.709c2.052-3.057.253-6.885 1.999-10.004z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#75F3DA"
        d="M413.461 211.836l-2.068.063a2330.928 2330.928 0 01-3.77-3.285c-.004-8.887-.01-17.772-.012-26.656 1.84 2.356 3.178 4.958 3.855 7.882 3.251 7.098 1.427 14.656 1.995 21.996z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#0C2D51"
        d="M405.467 102.834c.309.003.619 0 .928-.007.057 33.205.104 66.411.189 99.617.006 2.475.305 4.949.467 7.423-.33 1.617.268 3.32-.457 4.9-1.965-1.541-1.082-3.711-1.084-5.583-.056-35.449-.043-70.899-.043-106.35z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#41A7CC"
        d="M406.594 214.768c.15-1.634.303-3.268.455-4.9l.361-.092c-.648 2.797 1.471 4.886 1.9 7.408-1.313.479-2.168.083-2.504-1.307l-.212-1.109z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#74EEF5"
        d="M437.479 146.837l.01-5.986 1.027 1.042-.199 4.944c-.279.442-.559.463-.838 0z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#136AC0"
        d="M485.444 223.864c-.736-.032-1.473-.064-2.211-.098 1.611-.875 3.031-1.899 3.068-3.989l2.457-2.832c1.59-.017 1.232-1.4 1.598-2.278l3.064-4.666c2.543-1.504 4.736-1.218 6.502 1.267.752 1.902.486 3.898.533 5.864.162 2.028-.35 3.831-1.783 5.325-.271.385-.58.741-.902 1.085-1.178 1.179-2.455 2.162-4.266 1.994-2.295-.742-5.459 2.099-7.025-1.684l-1.035.012z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A9EFEC"
        d="M471.51 196.854c-.836-3.604.48-7.153.98-10.562.574-3.923 4.246-2.553 6.967-1.433-.004.321-.004.644.002.966a25.616 25.616 0 00-.004 11.037l-1.076 3.081-.963-1.003c-1.408-2.28-4.058-1.05-5.906-2.086z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9CE8EC"
        d="M478.637 222.685l-5.242.044c-1.217-1.522-1.857-3.16-1.012-5.094 1.254-1.814 3.145-2.819 4.975-3.901 2.068 2.749.051 6.082 1.279 8.951z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F59F94"
        d="M497.354 202.837c-.658 1.157-.336 2.203.365 3.205-.389 1.764-1.547 2.261-3.199 1.948l-5.055-6.987c1.924-2.048 4.215-1.547 6.523-.95 1.085.617 1.901 1.371 1.366 2.784z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8D449"
        d="M496.608 201.009l-7.143-.007c-2.537-2.914 2.234-2.435 1.99-4.283 1.398-1.237 3.215-.648 4.793-1.097 1.477-.281 2.221.501 2.613 1.796a5.7 5.7 0 01-.996 3.353c-.366.345-.786.424-1.257.238z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#0B3A8B"
        d="M494.52 207.991l3.197-1.947c2.939.201.994 2.596 1.707 3.796.529.433.492.807-.115 1.123-1.867-.904-3.877-.94-5.889-.963.368-.669.733-1.339 1.1-2.009z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EAD239"
        d="M498.459 197.886c-.381-1.014-1.074-1.701-2.109-2.038-.275-.374-.248-.709.129-1 .648-.346 1.297-.691 1.943-1.038 1.223-.53 2.184.095 3.152.704.961 1.604.141 2.595-1.178 3.416-.211.086-.428.166-.643.25-.467.07-.899-.03-1.294-.294z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C7F4F6"
        d="M479.456 196.863c-1.604-3.68-1.59-7.358.004-11.037-.002 3.678-.004 7.357-.004 11.037z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CBF2E3"
        d="M496.479 194.848l-.127 1c-1.475 1.181-3.211.88-4.896.871.777-3.034 3.25-1.513 5.023-1.871z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EAD239"
        d="M506.385 198.833l-1.928.016c-.441.402-.877.397-1.311-.014-.84-1.13-.699-2.397-.521-3.672.145-.503.422-.917.832-1.242 1.825 1.131 2.463 2.969 2.928 4.912z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8D553"
        d="M503.458 193.92c.018.311.021.622.012.933-.66.579-1.334.585-2.023.052-1.008-.364-2.016-.729-3.023-1.095 1.705-1.261 3.385-1.321 5.034.11z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#267DCA"
        d="M490.356 214.667c.387 1.021 2.406 1.576 1.064 3.061-1.225 1.356-1.711-.699-2.662-.782l1.598-2.279z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9CF2EB"
        d="M529.418 218.855c-.055-.646-.111-1.294-.168-1.94 1.646.352 5.307-1.416 3.125 2.967-.303.465-.609.445-.922.011-.376-.936-1.255-.889-2.035-1.038z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E5D047"
        d="M531.454 219.892a3.31 3.31 0 01.922-.011c.559 1.534 3.766.207 3.197 2.96-2.1.033-4.379.316-4.119-2.949z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EFD434"
        d="M532.016 225.691c.33-.7.951-.832 1.605-.745.613.083 1.461.135 1.238 1.068-.174.73-.918.822-1.572.74-.619-.078-1.357-.111-1.271-1.063z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#271F56"
        d="M501.461 222.84c-.002 1.333-.006 2.667-.01 4-5.191 1.248-3.434 5.99-4.598 10.007-2.15-1.967-4.676-2.98-2.33-6.086 1.328-1.759-1.465-2.408-1.061-3.92.145-.166.289-.331.43-.499 1.617-.731 3.664-1.035 3.529-3.524l.012-.012c1.353-1.029 2.694-1.05 4.028.034z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#291F58"
        d="M495.465 248.826l-1.98-.055c-.803-3.535 1.268-6.266 2.865-9.845.992 3.067 4.221 4.786 2.689 8.243-1.893.725-1.355-2.649-2.986-1.622-1.051.661-.474 2.153-.588 3.279z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1168BE"
        d="M486.479 223.852c1.914 3.008 5.182-1.516 7.133 1.282.439.609.422 1.179-.145 1.702l-.004.005-1.898 1.056c-.635.45-.973 1.549-2.086.953l-.039-.029c-1.223-.765-2.533-1.441-2.971-2.986l.01-1.983z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#26519E"
        d="M489.479 228.85l2.084-.953c-.063 5.647-.125 11.295-.189 16.941-1.807-3.008-.5-6.323-.936-9.466-.256-1.858.672-3.926-.967-5.544 0-.326.002-.652.008-.978z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#24215D"
        d="M501.461 222.84l-4.027-.034c.264-1.896 2.516-2.891 2.275-5.015 1.057-1.452-1.049-3.904 1.543-4.871l.246 3.855c-.011 2.022-.025 4.044-.037 6.065z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#384869"
        d="M501.252 212.92c-1.566 1.291-.008 3.572-1.543 4.871l-.398-6.831c.037-.372.074-.746.113-1.12 1.211.669 1.58 1.839 1.828 3.08z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CDF1D8"
        d="M496.608 201.009c.305-.098.615-.17.932-.218.803-.714 1.725-.971 2.777-.741.76.232 1.322.68 1.568 1.463.057.516-.082.966-.449 1.341l-4.082-.017-.746-1.828z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EBD855"
        d="M501.436 202.854l.178-1.015c.285-.399.568-.398.85.003l.965 3.068c-1.163-.203-1.721-.991-1.993-2.056z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8D553"
        d="M502.463 201.842l-.85-.003-1.059-1.095c-1.084-.593-2.086-1.222-1.199-2.693l.131-.265c1.49-.271 2.867-.106 3.982 1.047l.988.015c-.663.998-1.329 1.996-1.993 2.994z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3EB3DE"
        d="M201.469 276.813c-1.375.075-2.751.15-4.128.227 0 .002.107-.136.107-.136-.487-.49-.632-1.082-.526-1.741.177-.664.552-1.371-.375-1.832a8.27 8.27 0 01-1.055-.533c-1.996-1.019-4.154-.845-6.283-.904-.714-.089-1.358-.336-1.908-.808-.423-.611-.514-1.279-.343-1.989 1.354-2.502 4.14-3.781 5.404-6.342-1.326-1.914-1.788-4.244-3.123-6.113-1.891.254-3.186 2.133-5.243 1.905-7.661-2.637-14.17-7.328-20.876-11.673-1.606-2.201-5.141-2.469-5.735-5.689-3.751-5.705-8.976-10.119-13.502-15.129-9.766-10.808-19.092-21.976-28.435-33.137-1.932-.337-3.128-1.562-3.933-3.259.196-3.553-3.058-4.696-4.809-6.89.492-1.982-1.295-2.72-2.163-3.959l-.024-.019c.384-2.528 2.093-2.384 3.942-1.953v.992c2.826 1.736 6.657 1.214 9.012 4.01l1.965-.004c5.403 1.878 10.733 3.954 16.069 6.01.329-.001.657.001.985.004 2.131 1.768 5.067 1.854 7.269 3.475 1.473-.088 2.589.857 3.87 1.328 3.59 1.731 7.449 2.848 10.944 4.793 5.648 2.514 11.407 4.786 16.825 7.791 2.389.376 4.342 1.741 6.426 2.812 2.889 1.179 5.756 2.4 8.494 3.914 3.717 3.191 9.349 3.488 12.168 8.047 1.084 9.924.247 19.877.495 29.813.074 2.983.136 5.978-.008 8.954-.196 4.032 1.511 5.821 5.572 5.559 1.973-.128 3.985-.106 5.923.491 3.633 1.737 2.392 4.673 1.829 7.445a3.283 3.283 0 01-1.584 1.71 1.829 1.829 0 01-1.44-.033c-2.015-1.788-3.503-1.664-4.232 1.187-.307.667-.791 1.057-1.563.98-2.137-.95-4.203-1.246-6.011.696z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DBBF38"
        d="M193.152 262.983c-.884 2.904-3.3 4.347-5.617 5.884-2.988 2.229-6.457 1.051-9.711 1.375-2.566-.122-5.174.258-7.689-.548-2.556-1.122-2.763-3.494-3.064-5.815-.306-2.362-1.342-4.263-3.906-4.442-5.943-.415-11.893.401-17.85.066-1.172-.066-2.1.907-3.053 1.571-1.11.718-2.266 1.212-3.612.702-1.054-.934-.71-3.095-2.765-3.149l-.333-3.705a21.4 21.4 0 00.18-.559c.292-.514.65-.979 1.028-1.434.247-.313.526-.595.816-.866.762-.687 1.432-1.479 2.319-2.03 1.854-.933 3.145-2.581 4.804-3.749.832-.638 1.991-.675 2.741-1.478 1.774.065 2.016-2.515 3.9-2.259 2.737 1.254 4.148 3.026 2.369 6.047-.513.593-1.156.991-1.896 1.245a4.022 4.022 0 001.443-.762c.45-.536.994-.847 1.708-.806.451.083.868.249 1.264.471 3.865 2.559 4.479-2.853 7.25-2.957l20.872 12.105c.977.413 2.008.711 2.886 1.339 2.095 1.059 4.299 1.946 5.916 3.754z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A8EBE8"
        d="M135.552 254.921l-2.883.852c-1.314-1.406-1.449-4.092-4.232-3.904-.668-3.593-4.116-5.617-5.099-9.032-2.291-3.354.897-3.077 2.387-3.143 3.689-.163 6.883 1.725 10.159 3.151l.188-.025c1.681.909 2.455 2.384 2.641 4.229.136 2.052-.002 4.055-1.106 5.873l-.09-.025c-2.158-.785-1.14 1.535-1.986 2.032l.021-.008z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F19392"
        d="M135.884 242.845c-3.624.989-6.474-1.895-9.865-1.969-1.254-.027-3.779-1.385-2.681 1.96-4.496-1.114-3.103-5.099-3.905-8.013-1.098-1.456-1.316-2.996-.447-4.642.406-.54.856-.577 1.347-.11 2.461 4.384 7.358 5.693 11 8.588 1.641 1.304 3.639 2.114 4.551 4.186z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A4EEEB"
        d="M120.333 230.072l-.406-.042-.405.045c-.514.22-1.001.173-1.466-.137-2.115-2.031-3.779-4.298-3.824-7.403-.014-1.892.29-3.683 1.656-5.128 1.661-1.309 3.426-1.783 4.366.579.655 1.646 2.234 1.818 3.212 2.854 1.432.95.635 3.015 1.999 3.999l.001 2.001c.603.667.531 1.334-.001 2-1.751.242-3.789-.711-5.132 1.232z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DAC03E"
        d="M153.466 248.84c.647-2.555-.828-4.394-2.125-6.293 1.336-3.46 3.923-1.384 6.046-1.364l6.092 4.603c-1.888 1.686-1.686 5.657-5.69 5.068-1.331-.195-2.188-.599-2.324-2.014.477-.448.847-.958.936-1.629-.14.642-.46 1.18-.936 1.628l-1.999.001z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F3E07A"
        d="M116.5 217.826l-1.163 5.037c-.634.577-1.342.575-2.091.271-1.17-1.191-3.087-2.077-1.784-4.297-.378-.952-1.044-1.618-1.996-1.998-.978-1.171-1.992-2.334-1.002-3.998 1.324-.021 2.767.165 2.993-1.74 2.8-.3 1.602 3.589 3.946 3.767 1.023.742 1.164 1.811 1.097 2.958z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A4EFE7"
        d="M116.5 217.826c-1.374-.612-.863-1.924-1.097-2.959 3.867 1.604 3.745-4.283 7.605-3.749-2.164 3.444-1.976 6.701.458 9.723-1.698-.109-3.7.497-4.058-2.24-.299-2.283-1.752-1.191-2.908-.775z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B8F1F3"
        d="M111.517 189.66c1.455.911 3.202 1.471 3.933 3.258-.101.801-.044 1.666-.34 2.387-.442 1.075-1.316 2.201-2.486 2.055-1.548-.193-1.094-1.747-1.132-2.81-.057-1.628.01-3.26.025-4.89z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A4EFE7"
        d="M125.465 224.839c-2.678-.327-1.809-2.428-1.999-3.999 1.857.141 2.316-2.296 4.3-2.229 1.06 2.731-2.08 3.981-2.301 6.228z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#51B9DB"
        d="M108.464 176.839l-3.943 1.953c-.974-.676-2.137-1.891-1.12-2.665 1.663-1.266 3.679-2.65 6.082-1.362l-1.019 2.074z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BAD38E"
        d="M147.441 244.806c-.02 1.369-.667 2.055-2.078 1.912-1.912-.932-4.282-.22-6.048-1.686-.386-.699-.435-1.37.171-1.983 2.892-.501 5.661-.45 7.955 1.757z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F3E07A"
        d="M108.514 210.812c-.162.02-.332.081-.485.052-1.605-.306-2.837 2.956-4.161 1.034-1.715-2.488 1.843-2.626 2.652-4.094.774.093 1.588.101 2.017.938-.207.687.503 1.385-.023 2.07z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C9F5F6"
        d="M111.464 158.856c-1.032 3.599-4.008 1.31-6.006 1.984l-.054-1.953 6.06-.031z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9FEEE5"
        d="M106.278 181.85c-1.295 1.057-.587 3.324-2.45 4.099-1.121-2.258.505-4.152.692-6.207 1.448-.015 2.428.358 1.758 2.108z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DAAFAA"
        d="M139.486 243.049l.055 1.946c.702 1.086.267 1.785-.776 2.276-.508.053-.928-.123-1.271-.494-.471-1.319-.941-2.64-1.417-3.959 1.133.078 2.272.155 3.409.231z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A4EFE7"
        d="M125.465 228.84l.001-2c1.353.1 2.021.821 1.923 2.182-.047.651-.274 1.432-1.018 1.273-.387-.083-.609-.945-.906-1.455z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#52B7D1"
        d="M106.278 181.85c-.183-1.039-.924-1.611-1.758-2.107-.003-.312.004-.621.025-.932 3.044.053 3.64 1.44 2.162 3.96l-.429-.921z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F3A77A"
        d="M108.514 210.812c-.153-.691-1.177-1.393.022-2.069l1.054 1.076-1.076.993z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#76D1FB"
        d="M162.511 180.802l.943.076c8.151 4.654 13.368 11.388 14.767 20.832-.319.73-.736 1.315-1.676 1.091-3.398-8.162-8.312-15.234-15.074-20.979-.211-.908-.026-1.413 1.04-1.02z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6BCDF8"
        d="M175.466 205.825c-5.639-2.729-11.643-4.687-16.991-8.032-.259-.184-.348-.37-.266-.561.082-.191.166-.287.251-.287 6.076 1.734 11.732 4.39 17.047 7.789.333.256.438.502.315.74-.12.234-.239.351-.356.351z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#57C3EE"
        d="M135.511 187.847c-5.73-1.002-11.007-3.218-16.069-6.01 5.868.636 11.077 3.033 16.069 6.01z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#66C9F7"
        d="M158.46 196.945c.008.283.013.566.015.849-3.855-1.253-7.671-2.592-11.034-4.943.342-.402.69-.388 1.044-.017 3.659.562 7.065 1.737 9.975 4.111z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6FCCF8"
        d="M175.466 205.825l.041-1.089c1.865.17 1.386-.917 1.038-1.935l.939-.991c2.829 1.353 3.866 4.481 6.236 6.294-.387 1.359-1.183 1.463-2.249.734-2.372-.266-3.86-2.293-6.005-3.013z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4BBEE8"
        d="M117.477 181.841c-2.854-1.675-6.568-1.415-9.012-4.01 3.298.674 7.168.065 9.012 4.01z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6BD0FA"
        d="M162.511 180.802l-1.04 1.021a26425.58 26425.58 0 00-6.072-4.955c.353-.399.72-.432 1.102-.042l6.01 3.976z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#62C8F5"
        d="M143.472 191.805c-2.146-1.635-5.441-1.242-6.976-3.954 2.438.723 5.084.947 6.985 2.942.344.229.457.454.34.678-.116.223-.232.334-.349.334z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5FC5F3"
        d="M145.5 172.828c3.065-1.974 4.839.64 6.975 1.965.347.225.463.451.349.678-.114.228-.229.342-.345.342l-6.979-2.985z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#66CBF8"
        d="M143.472 191.805l.009-1.011c1.938.018 3.7.466 5.005 2.039l-1.044.017-3.97-1.045z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6ACEFB"
        d="M152.479 175.812l-.003-1.02c1.592.183 2.971.788 4.026 2.033l-1.102.041-2.921-1.054z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#40B3DE"
        d="M183.445 207.872c-3.777-.26-4.883-3.147-5.962-6.062-1.258-6.98-5.214-12.362-10.239-17.063-1.325-1.239-2.917-2.192-3.79-3.868.163-1.39-.46-2.978 1.014-4.038 1.336-.785 2.145.275 3.083.883l2.889 1.118c8.553 7.286 14.093 16.745 19.131 26.562.753 1.467 1.692 2.905 1.384 4.699-3.563 2.827-5.293-.52-7.51-2.231z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3FB3DD"
        d="M186.459 191.894c5.205 3.305 8.675 8.962 14.851 10.95 2.622 2.813 1.122 6.291 1.539 9.459.002 1.442-.049 2.878-.786 4.182-4.852 1.321-7.677-1.752-10.495-4.849-.186-.975-.125-2.009-.651-2.91-1.37-5.105-5.396-9.096-6.104-14.487.23-1.005.705-1.839 1.646-2.345z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6CCBF3"
        d="M185.423 193.869c1.325 5.262 5.715 9.278 6.066 14.936.425 1.074-.11 1.221-.994 1.03-5.328-10.092-10.276-20.438-18.883-28.346-.774-.712-1.168-1.594-1.172-2.647 3.394-.078 4.244 3.454 6.726 4.775 1.937 1.031 3.461 2.836 5.169 4.297-.213 2.628 3.139 3.41 3.088 5.955z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#56E1C5"
        d="M176.493 170.818l4.978 1.97c5.212 2.12 10.438 4.209 15.627 6.382 1.512.633 2.942 1.801 4.193-.318l-.002 9.967c.211-6.666-4.955-7.937-9.669-9.845-5.612-2.271-11.521-4.004-16.228-8.107.349-.418.717-.416 1.101-.049z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#221F5E"
        d="M201.583 212.838l-.272-9.994.29-4.004c.621-.594 1.243-.591 1.865-.001l2 .002c2.04 1.028 3.56 2.502 1.513 4.571-1.859 1.879-1.971 4.056-2.3 6.361-.235 1.647-.223 3.923-3.096 3.065z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#61E7CE"
        d="M158.45 161.839c3.223-.474 4.952 3.027 8.004 3.01.792.403 1.481.892 1.571 1.882a1.49 1.49 0 01-.556 1.099c-3.079-1.887-6.591-3.122-9.019-5.991z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5CE5CA"
        d="M167.469 167.83l.006-1.03c.496-.547 1.12-.733 1.839-.66.45.12.825.36 1.125.718l6.053 3.962-1.1.047c-3.072.111-5.296-1.988-7.923-3.037z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#39B2DC"
        d="M185.423 193.869c-1.441-1.771-4.377-2.77-3.086-5.956l4.123 3.981c-.018.831-.23 1.559-1.037 1.975z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#64C7F1"
        d="M167.551 177.723a3566.03 3566.03 0 01-3.083-.883l-4.008-2.998.005-.008 5.021.998c1.281.541 1.967 1.506 2.065 2.891z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#242058"
        d="M203.465 198.839l-1.865.001-.001-3.999c2.577.42 1.66 2.471 1.866 3.998z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7DF0DC"
        d="M170.439 166.857a44.485 44.485 0 01-.968-.032c-.585-.66-.627-1.321-.004-1.983l2-.002c.692.195 1.843.136 1.438 1.253-.38 1.053-1.587.646-2.466.764z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#71F4DA"
        d="M169.468 164.841l.004 1.984-1.997-.025-1.021-1.952c1.003-.623 2.007-.632 3.014-.007z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#57C2ED"
        d="M160.46 173.842c-2.5.284-4.712-.813-7.803-1.532 3.425-.878 5.682.009 7.808 1.524l-.005.008z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FDFDFD"
        d="M295.466 240.843c-1.562 3.158-3.616 6.169-2.995 9.981-1.972 3.165-.64 6.938-1.884 10.236-.104 1.399 1.425 2.44.866 3.939-.727 2.132.301 3.958 1.015 5.839.265.197.302.431.11.7.591 1.666.702 3.207-1.107 4.247l-2.003.042c-.504-.493-.655-1.165-.912-1.785a5.96 5.96 0 01-.169-1.344c-.115-1.182.864-2.588-.745-3.443-4.87-.733-5.268-.409-4.294 3.496 1.288 1.721 4.801-.223 5.113 3.086l-12.337.995c-5.703 2.047-11.607 1.695-17.449 1.165-3.396-.308-4.277-3.164-4.595-6.126.024-1.991-.077-3.974-.697-5.896a16.04 16.04 0 01.117-5.738c.39-1.283.551-2.604.584-3.944.125-1.874-.15-3.821.988-5.511 3.08-2.297 7.14-.529 10.298-2.484 1.283-.743 3.086-.152 4.081-1.609-.243-1.446.089-2.529 1.745-2.77 1.493-.12 2.986-.055 4.197-.072-3.208-.259-6.669.325-10.155.346-2.872-.047-5.811.226-8.248-1.795-2.821-1.858-6.312-3.199-5.93-7.57 1.146-1.371 2.099-3.181 4.405-1.989-.31 2.972 1.119 4.559 3.983 5.001 1.843-.83 2.925-2.424 4.02-4.004l-.003.004c1.778-1.198 3.166-2.886 5.009-4.002l1.992-.998c1.082-.327-.02 2.912 1.931 1.17 1.38-.503 2.815-.451 4.24-.497 1.688-.006 3.375.005 5.059.021 1.292-.021 2.582.168 3.836.063-.09-1.077-1.143-2.155.026-3.198a4.464 4.464 0 011.255-.577c2.26-.357 4.492-.431 6.688.39.328.123.893.495 1.122-.236-.72.569-1.056.045-1.389-.495.303-1.204 1.281-1.522 2.303-1.795 2.611-.335 5.223-.307 7.831-.002 1.825.882 4.259 1.04 4.582 3.764-.205.771-.854 1.072-1.483 1.393l-1.056 2.097c-.513.388-1.108.516-1.733.556-1.217-.11-2.556.264-3.528-.866-.407-.223-.846-.288-1.297-.307.491.09 1.001.108 1.437.406 1.621 2.472-.283 3.264-2.011 3.77-3.572 1.044-4.327 3.144-2.813 6.346z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FCFCFB"
        d="M377.559 232.468c2.557 2.313 5.148 4.591 7.641 6.97.543.517 1.232 1.68 1.012 2.07-3.029 5.377-2.01 12.019-5.451 17.234l-7.295-.031c.525-1.499 2.102-3.06-1.516-2.964-10.113.267-20.237.093-30.366-.907 7.877 0 15.754.086 23.627-.101 1.084-.026 5.016 1.79 2.908-2.55-.324-.666.369-1.261 1.119-1.188.611.06 1.674.327 1.721.633.607 3.815 2.627 1.803 4.44 1.229 3.236-1.022 1.842-3.255 1.783-5.464-5.817 2.531-11.633.958-17.305 1.441-3.118.267-1.775-4.59-5.368-4.104-4.595.62-2.379-3.165-2.698-5.188-.293-1.856-.787-3.526-2.346-4.712-.583-.667-.62-1.333.002-1.998l2.001-.001c2.852-1.152 2.73 1.097 3.023 2.721.271 1.509-.438 3.333 1.53 4.206 2.507.714 4.957-.42 7.441-.224 2.438.158 4.639-.771 6.885-1.488.893-.256 1.805-.375 2.725-.434 1.943.115 3.258-.51 3.201-2.748.181-.936.421-1.839 1.286-2.402z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#43B3DB"
        d="M255.309 270.842c.094 4.576 1.813 6.832 6.974 6.167 4.548-.586 9.226-.158 13.844-.177 1.048 2.669 2.099 5.336 3.149 8.004-2.271-.152-1.952-2.424-2.823-3.661-1.314-1.866-2.822-2.626-4.988-2.333-5.15 2.127-10.266 4.529-15.998 1.998-1.719.947-1.389 3.945-4 3.999-1.736-1.687-1.068-4.325-2.444-6.156-.655-1.173-.464-2.506-.728-3.754-.179-1.331-.031-2.616.525-3.847 1.062-1.52 2.24-2.879 4.3-2.946 1.705.111 1.704 1.605 2.189 2.706z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#222159"
        d="M334.113 295.931c.483 1.822.773 3.659.452 5.547.592 2.557.608 5.112-.008 7.667.67 2.555-1.823 6.056.009 7.333 1.923 1.342 5.377.479 8.162.6 8.371.366 16.78-.769 25.129.589-1.686 1.775-3.902 1.527-6.031 1.566-8.088.148-16.182-.255-24.26.229-.852.225-1.506.756-2.1 1.378-3.293.605-6.461 1.024-6-4 1.421-1.062.711-2.916 1.551-4.193 1.041-1.256 1.269-2.719 1.074-4.288-.228-2.507-2.348-4.856-.627-7.517 3.309-.329 1.117-3.624 2.649-4.911z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#132C4E"
        d="M381.374 264.854l-.08 1.256-59.706-.165c1.365-1.857 3.356-1.064 5.066-1.069 18.239-.054 36.479-.027 54.72-.022z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#291D5C"
        d="M331.468 312.841c-.191 1.571.676 3.673-2.002 3.999.002-3.744.006-7.487.004-11.23-.002-1.871.509-3.521 1.994-4.768-.789 3.026 2.791 4.965 1.992 7.994-.861 1.237-.631 3.014-1.988 4.005z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#293063"
        d="M248.522 317.855c4.918-1.864 10.086-.12 15.072-1.042l18.83-.142c-1.141 1.804-2.969 1.151-4.531 1.16-9.79.053-19.58.025-29.371.024z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#291E58"
        d="M270.754 320.383h-14.568l-.041-.961h14.577l.032.961z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DCDCDB"
        d="M290.587 261.061c.812-3.378-2.346-7.486 1.884-10.235.431 2.648-.913 5.297.001 7.945l-1.885 2.29z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F4F6F7"
        d="M289.334 273.611l.133 2.218-1.006.01c-1.792-2.329-5.205.456-6.898-2.185 2.582-1.658 5.172-1.651 7.771-.043zM292.469 270.839c-1.581-1.73-2.596-3.559-1.015-5.839 1.407 1.761.989 3.839 1.015 5.839zM291.471 275.787l1.107-4.247c.117 1.542 3.17 3.849-1.107 4.247z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1B2756"
        d="M335.466 318.841c1.463-1.622 3.402-.944 5.141-.968 9.082-.12 18.165-.147 27.249-.207 1.018.032 2.043.044 2.496 1.224-.973.635-1.936.517-2.891-.04-1.416 1.176-3.127.971-4.773.976-7.484.023-14.967.023-22.452 0-1.647-.005-3.358.198-4.77-.985z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FEE1B0"
        d="M386.393 274.953c.746.605 1.492 1.211 2.24 1.816-1.094.054-2.191.108-3.287.164-1.496-.262-3.711.662-3.629-2.2 1.543.421 3.053 1.517 4.676.22z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9AF5E6"
        d="M375.274 272.928c.664-.016 1.404.028 1.576.76.223.938-.625.979-1.238 1.063-.656.09-1.402-.01-1.574-.737-.225-.934.642-.92 1.236-1.086z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#25205A"
        d="M334.557 309.145l.008-7.665c.946 2.555.915 5.11-.008 7.665z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A4ECF2"
        d="M389.211 318.549c.611-2.084 2.246-1.488 3.34-1.96.795-.344 1.307-1.784 2.404-.85.357.304.396 1.225.271 1.796-.262 1.202-1.34 1.292-2.326 1.272-1.202-.022-2.401-.162-3.689-.258z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#291F58"
        d="M335.466 318.841l31.995.009c-.475 2.757-2.672 1.95-4.316 1.961-9.226.061-18.452.029-27.678.029l-.001-1.999z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A4D3A4"
        d="M213.488 273.978l1.894-1.216c.939.93.944 1.923.199 2.965l-.112 3.054c-2.318.175-1.899-1.604-2.1-2.94-.508-.657-.426-1.274.119-1.863z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#62CBF8"
        d="M213.488 273.978l-.118 1.862-5.903 1.026c-.667-.007-1.333-.015-2-.021.001-.327.006-.653.015-.98.618-.599 1.269-.585 1.945-.104l1.054-.896c1.429-1.354 3.059-1.776 4.933-1.063l.074.176z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3CB7D0"
        d="M209.471 280.845c1.167.252 2.684-.611 3.616 1.318-1.779.768-3.147 1.157-3.616-1.318z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#59C5F3"
        d="M214.356 284.778c-.295.042-.592.07-.89.084h-3.799c1.592-.846 3.191-1.633 4.689-.084z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3A85B5"
        d="M145.469 312.833l-.004-1.969.004-.029c.367-.534.787-.579 1.259-.135 1.181.457 2.764-.422 3.626 1.093-1.293.358-3.402-.807-3.397 2.071.001.491-1.205-.268-1.488-1.031z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4CB4E5"
        d="M195.583 276.588c-2.316-.376-2.943-3.071-5.077-3.697-.477.297-.897.216-1.27-.189l-.02-.755a1.507 1.507 0 011.326-.585c1.819.48 4.243-1.254 5.445 1.487.61 1.328.565 2.584-.404 3.739z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#59A1B8"
        d="M189.392 272.808l1.114.083-.055 7.022c.008.293.009.587.004.88l.009.072c-1.224.455-1.885-.303-2.505-1.157-.587-1.193-.571-2.433-.282-3.694.355-1.181.69-2.38 1.715-3.206z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#238BC8"
        d="M195.583 276.588l-.032-3.771c.321-.462.633-.479.936.018a16.3 16.3 0 01.964.02c.618.641.605 1.302.061 1.978l-.063 2.071-1.866-.316z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#508AA0"
        d="M158.479 310.627l-1.066-.859-1.913-1.127c-.214-.221-.3-.452-.257-.696.044-.25.097-.374.158-.377.438-.446.967-.744 1.548-.959a2.959 2.959 0 011.205-.109c.17.11.34.223.51.335l.818 1.028a26.51 26.51 0 00-.016.978c-.328.595-.657 1.191-.987 1.786z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#699595"
        d="M155.5 307.95c-.006.231-.007.462 0 .692l-8.018.107c-.276-.634-.121-1.132.466-1.499 2.624-.92 5.21-1.417 7.552.7z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5087B9"
        d="M147.523 307.826c-.021.308-.036.616-.042.925l-.755 1.951-1.257.134-.018-1.97c-.581-.679-.577-1.354.013-2.024l-.041-.06c.571-.532 1.189-.523 1.839-.162.237.229.354.484.352.766 0 .292-.031.44-.091.44z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F1CD4F"
        d="M173.746 306.512l-2.175.547-2.029-.324c-2.089-2.695-1.691-5.568-.613-8.492.827-1.074 1.907-1.294 3.158-.932.531.254.947.638 1.254 1.139 1.383 2.621 1.571 5.307.405 8.062z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DDC636"
        d="M162.486 306.696l-2.999.008c-.607-.573-.612-1.246-.327-1.968 2.604-1.612 4.388-5.36 8.429-3.258.214.421.276.866.19 1.332-1.159 2.113-3.237 2.984-5.293 3.886z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECD441"
        d="M162.486 306.696c1.369-1.575 2.73-3.158 4.82-3.823 1.367 1.287 1.21 2.583.021 3.884l-4.841-.061z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#758A6B"
        d="M169.587 297.803l-.046 8.933-1.162.042c-.493-2.617-.753-5.254-.676-7.921.22-.519.581-.908 1.077-1.173l.807.119z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9FB394"
        d="M168.597 297.811l-.217 8.968c-.351-.008-.702-.016-1.052-.022l-.02-3.884.038-1.079c-.46-.82-.819-1.666-.68-2.641.111-.461.329-.866.634-1.227l.626-.311.671.196z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C8D29B"
        d="M159.591 304.862l-.103 1.843a7.69 7.69 0 01-.825.13l-.306-.062c-1.771-2.372-1.447-4.863-.422-7.395a1.735 1.735 0 011.471-.718c1.447 1.342 1.361 3.013 1.014 4.739a7.415 7.415 0 01-.829 1.463z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A2F0E6"
        d="M173.746 306.512l-1.128-7.672c1.022-1 2.236-1.188 3.577-.854.485.192.906.481 1.262.865.87 2.87-2.438 4.544-2.083 7.27l-1.628.391z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A5E8FE"
        d="M177.457 298.851c-.325-.009-.65-.014-.975-.016-.959-3.104-1.496-6.106 1.948-8.161 1.657 1.678 1.421 3.68.981 5.719a7.13 7.13 0 01-.937 1.458l.007-.002-1.024 1.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9FE8FD"
        d="M178.475 297.851l.014-1.068a7.04 7.04 0 011.166-.777c4.363.636 6.692-1.772 8.172-5.468.591.003.953.287 1.097.857-.25 2.109.666 4.32-.593 6.327l-8.863.215-.993-.086z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#58A3B9"
        d="M188.33 297.722l.341-6.916.688.037.086 6.2c-.372.228-.743.454-1.115.679z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#65B0C2"
        d="M188.434 279.796c.677.355 1.354.712 2.03 1.068l.092 1.074-.069 6.846-.035 1.032-1.062.018c-.907.317-1.321-.257-1.684-.928a6.303 6.303 0 01-.362-1.417c-.134-1.692-.109-3.387-.042-5.084.031-.491.13-.97.271-1.44.105-.222.217-.44.326-.661.177-.171.355-.34.535-.508z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#46B3D6"
        d="M207.427 275.761c-.648.034-1.297.068-1.946.104l-4.012.948c1.438-3.453 3.74-2.011 5.958-1.052z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#549FC7"
        d="M188.448 288.774l.943 1.061-.031 1.009a6.89 6.89 0 01-.691-.037l-1.224-.031c-2.428 1.564-5.041.173-7.555.476a23.165 23.165 0 01-.666-.339 2.576 2.576 0 01-.284-1.482c.141-.537.448-.94.923-1.226.482-.253.989-.42 1.523-.52 2.437-.175 4.917-.617 7.062 1.089z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F8E27A"
        d="M99.467 214.841c.084-.824.121-1.717.994-2.1.19-.084.859.36.932.654 1.358 5.474 4.663 9.859 7.77 14.393.85 1.24.917 3.016 1.354 4.584 1.134-.217 1.593-1.753 2.941-1.533.563.676.611 1.377.102 2.104.055 2.163-.094 4.166-3.09 3.929-2.658-2.063-4.506-4.63-5.004-8.038-4.022-3.797-4.932-8.929-5.999-13.993z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EFD76E"
        d="M105.464 228.834l5.004 8.037c-.291.024-.581.041-.871.051-3.203-1.76-4.335-4.583-4.133-8.088z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F2D15E"
        d="M118.605 229.766c.326.04.631.143.917.309l-.087 4.749c-1.338.048-1.932-.669-1.989-1.936-.538-.624-.741-1.339-.583-2.151.339-.756.782-1.328 1.742-.971z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EDD16F"
        d="M117.458 230.853l-.013 2.034-3.887.056-.101-2.104.02.001c1.334-2.019 2.658-1.398 3.981.013z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#88987E"
        d="M147.328 307.041l-1.904-.259.43-7.245c.736-1.174 1.472-.98 2.212-.002.827 2.118.732 4.268.207 6.433a2.35 2.35 0 01-.945 1.073z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#749FA3"
        d="M145.465 306.841l-.013 2.024-3.949-.138.917-1.69c1.015-.064 2.03-.13 3.045-.196z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#458397"
        d="M147.494 298.862c-.547.227-1.094.452-1.64.676a5.288 5.288 0 01-.372-.691l.027-1.945.329-.409a1.97 1.97 0 011.03-.124c.339.121.625.319.863.59.176.313.268.651.278 1.012l-.141.514c-.125.124-.25.251-.374.377z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EBD441"
        d="M141.481 260.842c.74-1.75 1.629-3.345 3.935-2.983 5.841.916 11.678-.063 17.516.013 3.316.043 5.24 1.77 5.491 5.117.147 1.962-.167 3.986 1.033 5.753-.213.222-.427.443-.638.668-5.09 1.622-10.332.455-15.492.838-3.916-.521-8.122 1.232-11.755-1.496l-.11-4.907c-.212-1.003-.222-2.004.02-3.003z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C7D4A0"
        d="M141.572 268.751l11.859.188c.323.521.244.973-.237 1.354-1.413.882-3.003.793-4.569.843-2.044-.079-4.115.155-6.124-.453a2.296 2.296 0 01-1.151-.989c.056-.318.129-.632.222-.943z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D6C443"
        d="M141.481 260.842c.627 1.005.605 2.005-.019 3.002-1.046-.542-2.614-.373-2.813-2.067l2.832-.935z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#317B9F"
        d="M136.556 270.99l.914-1.144 3.883-.151.106.346c.055.55-.144.982-.595 1.302-1.507.747-2.949.703-4.308-.353z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A0E2E1"
        d="M136.556 270.99l4.623-.262.645.379c.565.926.533 1.895.212 2.886-1.101 1.627-1.216 3.786-2.765 5.179-1.018.476-1.954.484-2.717-.479l.002-7.703z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A4EDEC"
        d="M136.828 288.813l-.23-7.75c.754-1.075 1.737-1.065 2.817-.598.417.342.719.768.913 1.27.544 2.041.517 4.089.037 6.14a3.13 3.13 0 01-.815 1.271 2.767 2.767 0 01-1.444.372 1.925 1.925 0 01-1.278-.705z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A0E7FE"
        d="M136.828 288.813c.21.029.421.056.632.078 1.03 1.098 1.315 2.443 1.301 3.892.027 1.443-.199 2.811-1.237 3.919l-.451.021-.45-.038.205-7.872z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#56A0D0"
        d="M139.355 280.881l-2.758.181-.043-2.369 2.916.189s.368.329.37.329c.167.305.213.627.142.967-.051.375-.261.61-.627.703z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E4D24E"
        d="M137.523 296.702l.008-3.731c.863-1.273 1.021-3.235 3.179-3.264 1.915-.162 3.82-.294 5.294 1.316 1.033 2.053.933 4.011-.478 5.86l-.019.018-7.984-.199z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#40B3E3"
        d="M255.466 280.84c1.57-1.782 3.22.041 4.696.171 4.075.358 7.229-3.262 11.302-2.169-4.148 4.606-12.526 5.653-15.998 1.998z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#40B1E6"
        d="M249.384 278.798c3.695.979 1.426 4.014 2.082 6.041-3.796 1.274-1.22 4.5-2.054 6.682-.043.111-.199.18-.302.269l-.67-1.016v-11.83c.262-.391.579-.423.944-.146z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F8E37E"
        d="M215.581 275.727l-.198-2.965c-.159-2.286 1.016-4.523.248-6.831.324-1.607.847-3.077 2.576-3.718 3.695-.068 7.093 1.495 10.703 1.935 4.327.526 8.574.218 12.821-.683 1.912-.405 3.885-1.036 5.808.072.868.873 1.124 1.981 1.224 3.151.131 2.585-.375 5.133-.461 7.707a2.432 2.432 0 01-.967 1.372c-10.588 1.938-21.175 3.82-31.754-.04z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6AAB96"
        d="M247.333 275.768c.067-.281.132-.563.194-.846.185-.35.477-.554.861-.635.387.036.714.193.969.49l.026 4.021a5.466 5.466 0 00-.944.145l-1.078-.282c-.008-.965-.018-1.929-.028-2.893z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#242058"
        d="M217.667 262.901c-.356 1.228-.477 2.613-2.037 3.031-14.239.466-14.205.466-14.212-13.707-.006-11.145-.11-22.288-.171-33.433-.417-.648-.396-1.29.03-1.925l.307-4.029c2.464-.451 1.669-2.428 1.898-3.966.349-2.339-1.284-5.211 2.769-6.447 2.118-.646-1.46-2.113-.784-3.584 0-4.827-.732-9.797.175-14.447 1.294-6.629-.826-12.987-.3-19.529.558-6.945.146-13.971.1-20.962-.006-.967-.036-2.174-.579-2.848-1.275-1.582-.246-2.536.737-3.312 2.171-1.712.656 1.759 1.93 1.467.617-.141 1.246-.229 1.869-.343.064 36.153.108 72.306.228 108.459.011 3.294-.567 6.629.363 9.889 2.192 3.171 5.466 1.045 8.181 1.661 1.808 1.589.3 2.763-.504 4.025z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F8E37E"
        d="M266.46 248.759c-3.09 3.678-7.361 1.251-10.993 2.127-.4.327-.833.602-1.297.83-1.784.508-3.557.419-5.324-.09-.706-.259-1.325-.664-1.896-1.143-1.877-1.945-3.678-3.219-6.89-2.872-4.261.459-7.113-3.052-10.168-5.477l-.538-.376c.228.126.461.297.736.537 1.916 1.349 3.351 3.228 5.527 4.21 1.275.576 3.128 1.057 2.766 2.96-.295 1.551-2.016 1.417-3.245 1.76-.795.222-1.583.472-2.399.641-4.274.454-8.424.398-11.792-2.872-2.285-4.634 1.449-8.122 2.318-12.157.282-1.03.556-2.067 1.919-2.116 1.65-.818 1.442-3.211 3.278-3.871 1.421-2.057 3.634-1.993 5.763-2.153 2.48-.029 4.942-.225 7.357-.835l5.646 3.088c1.683.978 3.437 1.886 3.951 4.014 1.227 2.806 3.142 4.913 6.074 5.988.828.482.697 1.204.492 1.946-1.013.848-2.056.869-3.5-.134 2.011 1.536 3.956.862 5.767 1.08 2.57.171 5.546-.744 6.911 2.612.23.845.131 1.625-.463 2.303z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F8FBFB"
        d="M302.466 197.84c.88 1.477 1.129 3.085.995 4.772-.051.636-.607 1.713-.743 1.479-2.446-4.19-6.218 2.514-8.623-1.102-8.083 1.48-16.17-1.164-24.39.331-3.902.71-8.065 1.176-12.136 1.527-2.625.227-.921-3.642-3.429-3.177.007-1.054.973-1.668 1.174-2.622.032-.71-.292-1.435.067-2.13l8.403.121c.446.6.69 1.288.886 1.995.323 1.267 1.349 1.308 2.356 1.322 8.63.129 17.26.188 25.889 0 .81-.018 1.701.003 1.826-1.126-5.122-2.098-10.445-.491-15.63-1.013-2.576-.259-5.358.696-7.638-1.301-3.02-3.104-1.143-6.399.177-9.208 1.182-2.516 4.702-1.436 6.472-1.263 6.452.63 12.871.176 19.293.364 3.677.107 2.59 1.43.951 3.054-6.886 1.002-13.813-.005-19.981.477 6.158.463 13.083-.514 19.96.465.377.511.862.976 1.11 1.544.501 1.146 1.326 2.278 2.492 1.598 1.419-.829-.748-1.782-.422-2.853 2.476 2.134 2.519 2.451.941 6.746l-.188-.287-.155.299.343-.012z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FAFCFB"
        d="M343.465 146.834l2.001-5.993c3.51 3.384 8.431.379 11.389 1.808 4.571 2.207 7.184-.138 10.668-1.211 2.963-.913 6.184-1.542 9 .57 1.682 1.263 1.648.487 2.215-.976.213-.553 3.795-.678 3.914.39.262 2.357 3.764 4.464.826 7.115-1.33 2.106-3.551 1.356-5.426 1.702-1.488.052-2.25 1.38-3.428 1.981-2.1.746-2.545-1.069-3.432-2.181-.49-.198-.996-.211-1.518-.098a8.794 8.794 0 00-1.037.483c-.873.631-1.455 1.712-2.715 1.683-1.293-.207-2.008-2.728-3.789-.928-1.123 3.797.975 8.034-1.645 11.596-.277 1.654-2.371 1.168-2.832 2.188-.779 1.726-1.987 2.562-3.308 1.361-1.296-1.178 1.413-1.887 1.106-3.249.067-.2.135-.399.198-.602.667-.802 1.599-1.348 2.156-2.251.551-3.189.863-6.358-.268-9.473-.67-.534-1.461-.666-2.291-.699-.456.01-.901-.017-1.354-.05-.96-.07-1.893-.24-2.802-.544-2.327-1.493-5.443-.711-7.628-2.622z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FAFDFC"
        d="M359.463 196.679c-.23-1.923.631-4.021-.91-5.732-1.574-1.75-1.24-3.073.576-4.554 1.529-1.247 1.596-3.157 1.061-5.265 1.008 3.402 8.844-1.825 6.516 5.811 6.461-.843 13.237 1.629 19.315-2.384 1.371-.904 2.512-.231 3.477.881.967 1.115 1.242 2.418.65 3.708-.984 2.15-3.006 1.639-4.801 1.612-3.271-2.203-6.99-1.364-10.545-1.476-3.456-.107-6.924-.128-10.399.566 5.365.652 10.758.617 16.159.486 1.615-.039 3.287-.67 4.814.402 1.432 1.549 2.781 3.188 4.322 4.619 1.324 1.231 4.262 1.269 3.566 3.921-.564 2.145-2.602 3.164-4.797 3.565-1.801-1.211-2.508-3.78-5.063-4.06-5.801-.886-11.629-.205-17.43-.46-2.265-.097-4.722.413-6.511-1.64z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E0C439"
        d="M352.419 231.017l-2.66-.311c-3.075-.474-4.549-1.962-3.289-5.182.178-.394.408-.763.664-1.108 1.13-1.081 1.189-2.539 1.361-3.959.129-.644.488-1.158.91-1.638 2.794-1.965 1.762-6.917 6.033-7.729 2.643.76 5.358.37 8.047.501 1.527.079 3.113-.015 4.197 1.394-2.236 4.697-2.523 9.849-3.473 14.844-1.203 6.329-1.734 6.674-8.327 5.289-1.357-.363-2.431-1.198-3.463-2.101z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C6CF6E"
        d="M217.667 262.901c.17-1.341.34-2.682.507-4.023.424-1.032.852-2.064 1.279-3.097 1.127-.566 2.286-.373 3.405-.046 7.356 2.152 14.688 2.643 22.032-.084 1.086-.402 2.28-.466 3.438-.09.971.804 1.056 1.887.963 3.028-.576 1.771-.229 3.874-1.869 5.271-10.013 2.626-19.948 2.8-29.755-.959z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#262158"
        d="M334.584 199.318c.071 1.365-.421 2.509-1.37 3.473-3.334-.47-6.66-.538-9.97.195-1.091-.665-.899-1.767-.946-2.786-.027-2.213 1.995-4.016 1.106-6.486-.387-1.074.905-1.646 1.855-1.859 2.017-.453 2.708-2.034 3.683-3.597 1.898-3.046.625-4.095-2.319-4.428a5.773 5.773 0 01-1.254-.498c-1.022-.979-2.378-.995-3.656-1.245-1.851-1.697-2.372-3.663-.557-5.582 1.784-1.885 3.258-.741 5.093.524 1.929 1.33 4.562 3.478 6.588-.248.441-.811 1.049-1.264 1.988-.856 1.154.5 2 1.421 1.842 2.653-.229 1.789-.333 3.598-.668 5.381-2.246 4.959-.671 10.267-1.415 15.359z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#27215C"
        d="M255.382 196.919l1.023 1.919c-1.338 1.323-3.137 1.277-4.804 1.634a6.843 6.843 0 01-1.473-.003c-2.099-.537-4.37-.048-6.395-1.042-3.633-2.588-8.02-3.596-11.875-5.505.564 1.937.267 3.953-.48 5.94-.523 1.312-1.795 1.385-2.893 1.747-2.093-3.031-1.112-6.29-.394-9.369.512-2.196 2.532-2.038 4.505-1.842 3.051.303 6.252 1.703 8.209-2.819 1.122-2.593 2.377.673 3.578 1.289 3.118 3.446 8.47 3.842 11.016 8.067l-.017-.016z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FCFCFC"
        d="M285.47 226.922c-.783 1.963 2.5 1.146 1.995 2.919-1.549.933-3.253.294-4.875.483-1.899 0-3.799.002-5.697.001-1.797.229-3.683-.511-5.412.488-2.034.215-.549-1.382-1.016-1.974 1.367-1.045 2.784-2.03 4.083-3.153.997-.86 2.177-1.895-.089-2.747-.939-.353-2.777-.155-1.979-1.883.477-1.033 1.757-2.787 2.962-2.053 3.182 1.938 3.896-1.893 6.028-2.161.86.793 1.313 1.787 1.453 2.927-.212 1.97 1.276 1.574 2.395 1.696a6.21 6.21 0 011.224.565c1.51.792 3.145.469 4.741.522 1.628.344 3.847-.397 4.206 2.275-.806.022-1.554.169-2.022.927-1.976 1.174-4.14.295-6.188.569-1.253-.01-2.519.029-2.598.024-1.814-.43-1.679.538-1.31.229.581-.481 1.485-.336 2.099.346z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#43B5DE"
        d="M359.463 196.679c6.896.061 13.792.12 20.688.184 1.789.017 3.639-.261 5.184 1.014 1.352 2.662-.436 3.341-2.449 3.876-10.727-.122-21.473.729-32.181-.566-1.092-1.429-1.228-2.854.014-4.275 2.914-.079 5.829-.156 8.744-.233z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#26215C"
        d="M334.584 199.318c-.373-3.226-.725-6.453-1.125-9.674-.319-2.572.333-4.833 2.007-6.805.359-.953 2.163.079 2.106-1.96-.068-2.445 1.721-3.178 4.001-2.077 1.632 2.408 2.012 5.148 2.114 7.962-.282 1.076-2.957 1.541-1.268 2.931 2.263 1.86 1.235 4.127 1.536 6.245.213 1.867-.643 2.809-2.494 2.888-2.834-1.538-4.203-4.269-5.544-7.423-1.097 2.863.291 5.637-1.333 7.913z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6E27D"
        d="M248.273 255.858c-9.618 4.226-19.225 4.142-28.82-.076l.074-4.8c.411-.426.9-.554 1.468-.39 6.006 3.056 12.231 3.46 18.774 1.97 2.945-.67 5.982-2.193 9.119-.519.669 1.415.73 2.729-.615 3.815z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#27235B"
        d="M320.511 191.959c-.527 1.92-1.305 3.826-2.808 5.061-1.109.911-1.96 3.086-3.851 2.161-1.768-.864-2.238-2.849-1.867-4.665.879-4.317 1.551-8.708 3.446-12.757 2.462-3.137 2.462-3.137 7.341 1.156.185.46.258.933.246 1.425-.458 2.665-.001 5.632-2.507 7.619z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#272258"
        d="M322.464 182.839c-1.96-.409-3.281-1.866-5.066-3.181l.695 4.713c-2.088.13-2.505-1.101-2.661-2.612l-.142-1.919c.807-1.298 1.612-2.597 2.418-3.895 3.186-.624 6.378-3.157 9.454.605.985 1.205 2.71.527 4.088-.396 4.013-2.687 7.565-1.733 10.323 2.646-1.436.581-4.523-.078-2.311 3.217.416.619.202 2.109-.421 2.085-1.14-.044-2.252-.804-3.376-1.265-.242-.769-.832-1.632-.654-2.288.348-1.286 2.199-2.806.02-3.636-2.516-.958-.296 1.588-1.334 2.421-3.113 2.497-5.207-.048-7.494-1.109-1.275-.592-1.765-3.189-3.857-1.46-2.128 1.758-.808 3.443.316 5.075.241.334.241.666.002.999z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9FDFB"
        d="M303.466 214.841c5.303-.125 10.607-.239 15.91-.386.778-.021 1.278.574 2.402-.354 3.115-2.575 4.895-1.679 5.662 2.395.247 1.313.603 2.202 2.025 2.344 1.127 2.643 4.012 2.649 6 4.001.41 1.872-.924 2.872-2.001 4-1.896 1.59-.077 4.419-1.999 6h-2c-1.442-1.661-1.318-3.981-2.445-5.777-.309-2.977.004-6.181-3.023-8.155-4.524-1.434-9.162-.358-13.73-.688-2.269-.164-4.642.385-6.724-1.025-.64-.766-.714-1.549-.077-2.355z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#26215C"
        d="M322.464 182.839c0-.332 0-.665-.002-.997 1.657-1.638 2.601-1.131 3.004.999 0-.001-.004.007-.001 0 1.312.01 2.626-.02 3.935.041 1.83.084 3.231 2.141 2.592 2.784-2.502 2.523-1.543 8.687-8.482 7.008 3.286 3.791 1.451 5.783-1.211 7.525-1.366-2.333-.982-4.857-.807-7.359.75-2.949-.017-6.062.969-8.984l.003-1.017z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FDFDF9"
        d="M397.452 188.838l-.004 2.002c-1.766-.188-3.629.46-5.35-.597 2.543-5.502.895-11.306 1.375-16.945.34-3.992-1.092-8.205 1.74-11.922.549-.722.527-2.566-.02-3.321-2.613-3.603.055-3.18 2.256-3.214v15.991c-1.734 6.002-1.536 12.004.003 18.006z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FAFCFB"
        d="M384.586 149.835c3.039.085 2.383-3.026 4.293-5.128 3.84 5.604.1 11.885 3.291 17.109-2.965.326-4.486-2.556-6.75-.991-1.559-2.062-1.32-5.259-4.139-6.527-.803-.913-1.289-1.938-1.115-3.191 1.147-1.556 2.961-.793 4.42-1.272z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6FAFA"
        d="M326.58 149.828c.701-.425 1.387-.878 2.105-1.269 1.242-.675.98-3.639 1.73-2.945 2.713 2.506 7.121-.718 9.139 3.077-.137.188-.274.377-.41.567-1.414.908-3.11.781-4.633 1.277-3.553 3.092-1.371 6.932-1.375 10.463.561.596 1.341.876 1.976 1.364.122.157.241.318.36.479-1.579 1.939-3.756 2.084-6.008 1.999.035-3.305-3.094-.736-4.057-2.188-.328-.925.166-1.619.641-2.322.363-.515.745-1.017 1.084-1.549 1.319-2.213 1.441-4.372-.266-6.462-.409-.793-1.028-1.568-.286-2.491z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7FCF6"
        d="M350.571 200.8l32.896.271c.551.588.496 1.176 0 1.764-9.963-.284-19.948.636-29.89-.504-1.293-.148-1.659.316-2.246 1.255-1.193 1.903-1.865.01-2.59-.578-1.5-1.217-.873-1.888.703-2.188.367-.556.742-.562 1.127-.02z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3FB3DD"
        d="M298.347 190.807c-7.633 2.379-15.454.564-23.174 1.019-.878.052-1.61-.48-1.757-1.421-.154-.99.443-1.677 1.366-1.64 7.864.318 15.835-1.576 23.586 1.101.078.315.071.629-.021.941z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#55ABCC"
        d="M271.474 196.918c7.278.065 14.556.105 21.833.213 1.898.027 4.271-.469 4.184 2.712-10.402 1.816-20.844-.058-31.263.305-1.143.04-2.278-.358-3.066-1.339l.622-1.77c2.564-.039 5.127-.08 7.69-.121z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4DB5DE"
        d="M369.514 148.934l1.992-.183c.732 2.823 1.522 5.632 1.301 8.605-.137 1.852-.383 3.604-2.348 4.479-4.275.406-4.74-2.622-5.143-5.706-.914-.856-1.906-1.632-2.703-2.612-.83-.773-1.182-1.802-1.531-2.833-.102-.664-.117-1.31.396-1.84 2.615-.722 4.039.68 5.045 2.827.74.283 1.152.847 1.469 1.557.271.603.641.897.246.36-.021-.031.111-.178.17-.309-.078-1.588-.25-3.162 1.106-4.345z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FAFDFB"
        d="M327.135 226.673c3.835.899 1.789 4.022 2.331 6.167-4.578-1.96-9.106-3.525-14.319-2.179-1.714.442-4.73 1.619-5.681-1.817-.127-2.053 1.54-1.86 2.767-2.228 1.333-.15 2.673-.079 4.011-.111.529-.033 1.059-.03 1.588-.014 3.087.641 6.23-1.282 9.303.182z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EEA67D"
        d="M241.583 227.862c-2.083 3.523-4.731 2.063-7.355.835 1.237-1.734 2.135-3.547 1.333-5.755 1.687-5.387 3.811-6.261 7.759-3.193-1.786 2.446-3.924 4.817-1.737 8.113z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EEF8F8"
        d="M261.472 161.84l.992.003-2.998 1.997c-.67.669-1.334.037-2.001-.009-3.295-.72-7.044.611-9.877-2.188 1.159-1.008 2.588-.678 3.924-.912 1.564-.273-.428-.447-.188-.83-.126-.453-.016-.811.356-1.077 4.304.653 6.512-.712 5.82-5.521-.347-2.41-.061-4.91-.061-7.896 1.536 1.403 3.9.975 4.002 3.478-2.525 4.324-2.529 8.643.031 12.955z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5EBAD9"
        d="M381.467 153.836c4.775.374 3.83 3.984 3.953 6.989-2.352 1.822-5.012 2.322-7.9 1.836-.768-.067-1.244-.472-1.42-1.227.041-1.228.561-2.188 1.598-2.853 1.434-.369 1.309-1.344 1.189-2.548-.172-1.755.213-3.24 2.58-2.197z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EEFEFE"
        d="M303.466 216.838c5.999.001 11.998-.029 17.996.022 1.552.014 3.51-.609 4.013 1.821a2.243 2.243 0 01-1.624.648c-12.744-.036-25.492-.409-38.23.211-1.111.419-2.26.434-3.421.309-.92-.839-.695-1.954-.728-3.007l4.993-.007c5.667-1.605 11.334-1.603 17.001.003z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EFF9F8"
        d="M343.465 146.834c2.833.03 5.778-.434 8.093 1.856-.158.202-.318.403-.475.607-6.106 1.773-6.104 1.773-6.274 8.632-.028 1.14-.005 2.286-.304 3.406-.18.495-.439.944-.771 1.352-.907.12-1.74.041-2.271-.847-1.709-1.666.121-4.137-1.34-5.858-.242-1.764.084-3.647-1.119-5.209-.186-.71-.101-1.358.438-1.902 0 0 .113-.178.113-.18 1.756.336 2.55-1.358 3.91-1.857z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F8FBFB"
        d="M255.401 196.936c-2.811-1.396-5.163-3.617-8.319-4.427-1.739-.445-2.463-1.932-2.697-3.641 3.526-1.214 6.686 4.4 10.771-.512-.165 3.569-.779 6.147.245 8.58z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1D1614"
        d="M243.319 219.749c-4.048-2.491-5.831.526-7.759 3.192-.836-1.912-3.465-3.521-1.314-5.978 1.953-2.231 4.807-1.495 7.206-1.408 2.512.091 2.169 2.357 1.867 4.194z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FCFAF8"
        d="M379.27 219.005c-3.412-.872-4.852-5.14-8.792-5.106-1.572-.917-3.275-1.731-3.178-3.982 1.857-.219 4.295-2.047 4.721 1.705.119 1.054.637.947 1.252.394.65-.585 1.523-2.65 2.082-.509.757 2.898 7.079 2.771 3.915 7.498z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F4FCF6"
        d="M376.473 161.723l1.047.939c-.25 2.771-2.703 1.449-4.053 2.179-.989-.344-1.237-1.429-2-1.999a956.53 956.53 0 01-1.008-1.007c2.295-4.206.771-8.717 1.047-13.084 1.604-.905 1.536.304 1.344 1.2-.266 1.237.211 1.733 1.333 1.879 1.304 3.173.226 6.897 2.29 9.893z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9FCF7"
        d="M220.464 250.927l-.471-.017s-.467.069-.466.07c-3.219-3.481-3.296-7.297.359-10.048 1.642-1.235.833-4.031 3.381-4.096.568 4.138-2.72 7.659-1.892 11.838.06.899-.062 1.723-.911 2.253z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9FAF9"
        d="M295.466 240.843c-3.589-3.13-3.31-4.992.867-6.976 1.531-.727 4.378.117 4.104-3.07l-.028.02c1.013.374 2.107-1.183 3.081.13-.519 3.788-4.861 4.709-6.015 8.021l-2.009 1.875z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FCFCFC"
        d="M303.466 216.838l-17.001-.002c-.394-1.007-1.414-2.438-1.07-2.942 1.285-1.888 2.066.642 3.157.677 4.969.162 9.942.192 14.914.271v1.996z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4DB1D5"
        d="M272.38 148.822c.852-.095 1.986-.069 2.004.878.084 4.354 1.531 8.835-.958 13l-1.753.032c-2.175-.861-3.606-2.146-2.714-4.756a4.45 4.45 0 01.924-1.171c2.293-2.202 1.77-5.289 2.497-7.983z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7FCFA"
        d="M353.482 158.842c-6.043-1.015-5.321 4.374-6.395 7.897-2.191-1.272-1.382-2.747-1.621-3.93-.297-1.473-.241-2.92.315-4.335 1.925-2.697 4.854-3.514 7.864-4.192.559.101.996.383 1.324.844.408 1.602 1.164 3.343-1.487 3.716z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9F9F6"
        d="M396.387 228.918c-3.461-.991-6.801-2.276-9.912-4.114 2.045.221 4.219-3.164 6.334.257.156.253 3.475.814 4.646-1.221-.208 1.724.684 3.679-1.068 5.078z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FCFCF7"
        d="M251.18 234.963c-1.971-.694-3.306-2.014-3.95-4.015 1.965-1.894 4.573-.958 6.833-1.325 2.336-.379.948 2.086 1.402 3.216l-4.285 2.124z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FAFBF4"
        d="M349.406 218.82l.033 1.949c-.773 1.304-.691 2.98-1.803 4.137l-.307-.113c-.603.716-1.059 1.565-1.895 2.067-1.107-.509-3.176 1.055-3.314-1.507-.043-.776 2.588-4.042 3.137-4.237 1.501-.537 2.269-2.417 4.149-2.296z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#272347"
        d="M228.486 201.61l1.988-1.766c1.414-1.262 3.078-1.292 4.812-.987 2.641.965 5.465.369 8.155.936 1.401.451 3.616-.741 3.916 1.936-6.292.215-12.591 1.658-18.871-.119z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FAFCFB"
        d="M340.373 155.8c4.359 1.292.023 4.154 1.09 6.041-1.997.33-3.879 1.351-5.99 1.001l-.007-.003c-2.816-4.304 1.846-4.762 3.481-6.78a1.643 1.643 0 011.426-.259z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F3FBF7"
        d="M218.469 159.838c-.167-1.257-3.813-2.9.497-3.73.743-.144.61-1.802.191-2.698-.796-1.699-.327-2.818 1.31-3.567.467.119.859.36 1.177.718.084.213.168.432.257.646.107 2.411-.668 4.864.336 7.233.297 1.687 2.614 2.347 2.243 4.372-3.288 1.605-3.827-2.349-6.011-2.974z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F8FAF6"
        d="M383.467 202.835v-1.764c1.545-.526 1.914-1.739 1.869-3.195 2.199.926 2.742 2.896 3.131 4.965-1.668 1.189-3.338 4.12-5-.006z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EAF9F9"
        d="M269.26 157.919c.097 1.959.935 3.546 2.413 4.813-3.031.445-6.43 2.519-8.37-1.887.089-.724.181-1.447.272-2.172.997-.275 1.483 1.014 2.449.767.671-.965.588-2.434 1.988-2.862.816.079 1.178.574 1.248 1.341z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FCFCFC"
        d="M281.164 215.701c-.38-1.986-4.841-2.072-2.202-5.271.894-1.083 2.792-2.237 3.216-1.213.818 1.968.472 4.398-1.014 6.484z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5EB6D2"
        d="M224.479 162.811c-1.197-1.219-3.206-1.741-3.336-3.878.48-.897 1.294-1.287 2.239-1.479 1.809.209 3.304 1.35 5.067 1.71.853.371 1.642.823 2.071 1.708l-1.343 1.798-4.698.141z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2B2455"
        d="M343.573 196.094c-.342-2.181.861-5.147-2.986-5.572-.347-.038-.925-1.811-.687-2.549.613-1.899 2.492-.837 3.788-1.209 1.39 2.9.651 5.974.732 8.98-.137.467-.42.584-.847.35z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#282269"
        d="M323.245 202.986c3.264-3.086 6.601-2.493 9.97-.196-3.286 2.031-6.622 1.461-9.97.196z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FAF9F0"
        d="M352.419 231.017c1.152-.296 2.008.322 2.864.936 1.578 2.943 2.326 5.898.12 8.894-2.334-.426-2.509-1.901-2.143-3.919.294-1.623.918-3.664-1.793-4.088.319-.608.635-1.215.952-1.823z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FAFDFB"
        d="M335.466 222.84c-2.928.058-6.268.734-6-4.001 2.761.194 5.782-.003 6 4.001z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CAE9EE"
        d="M361.479 148.844l.037 2.012c1.674 2.814.498 6.254 2 9.1.309.273.615.553.924.831-.223 2.836-2.32 1.951-3.949 1.99.411-4.639-1.206-9.421.988-13.933z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F28B8D"
        d="M367.301 209.917c.805 1.53 3.15 1.831 3.178 3.982l-.055.03c-1.254.53-2.191.004-3.012-.907l-4.91-.284a1.299 1.299 0 01-.346-1.246c.541-.952.799-2.317 2.436-1.695l2.709.12z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#58B2DB"
        d="M384.586 149.835c-.709 2.583-2.666.923-4.057 1.195-.643.641-1.443.779-2.305.734-1.402-.405-2.813-.813-1.77-2.778l7.023-.449 1.109 1.298z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FBFBF6"
        d="M314.789 204.816c-1.315.101-1.666-.339-1.533-1.735.194-2.028 1.719-1.731 2.864-1.919 1.124-.184 1.972.44 1.663 1.741-.367 1.544-1.508 2.073-2.994 1.913z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FAFDFB"
        d="M331.466 232.84c.676-1.997-1.618-4.983 1.999-6 .069.979-.226 2.229.269 2.892 2.793 3.746-.315 2.964-2.268 3.108z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D5D5D6"
        d="M297.476 238.968c.247-3.993 4.588-4.916 6.014-8.023l1.921-.01c-2.241 3.078-5.028 5.614-7.935 8.033z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6A6589"
        d="M251.446 199.985c1.335-1.758 3.28-.878 4.959-1.146 1.552 2.787-1.792 1.662-2.265 2.833l-4.61.034c-.464-1.802 1.329-1.089 1.916-1.721z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7F8ED"
        d="M357.439 210.636c.275-1.376-1.934-3.459-.271-3.8 1.82-.374 4.557-1.066 6.182 1.288-.338.797-.998 1.213-1.768 1.497-.545.194-1.105.354-1.645.568-.828.157-1.464 1.451-2.498.447z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F4F7F4"
        d="M343.573 196.094c.286-.107.569-.224.848-.35.753 1.729 2.131 3.796.329 5.193-1.024.794-2.599-.689-3.287-2.11.844-.801 2.417-1.04 2.11-2.733z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D5E6EA"
        d="M353.482 158.842c1.457-1.056.84-2.608.957-3.985-1.539-2.006-1.561-4.006.029-5.997l1.088.037c2.153 4.604 2.137 9.208.016 13.815l-.115.363c-.326-.078-.653-.158-.979-.239-.982-.787-.312-2.123-1-3.008-.008-.328-.006-.658.004-.986z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FCFAF8"
        d="M383.415 222.972c-1.852-.83-3.305-2.072-4.117-3.978 1.117-.559 2.232-1.12 3.613-1.813.175 2.027.339 3.908.504 5.791z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FECA82"
        d="M357.439 210.636c.648-.596 1.299-1.191 1.949-1.787.721 1.021 1.762.872 2.797.761.836.652.939 1.407.324 2.264-.01.289-.014.577-.008.865-2.432-.218-5.096.559-7.064-1.648l2.002-.455z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FCFCFC"
        d="M272.821 213.38c.609.648 1.532 1.339 2.02 2.26.305.575-.458 1.063-1.172 1.108-1.375.09-2.164-.509-2.118-1.938.02-.624.088-1.313 1.27-1.43z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FAF9F0"
        d="M345.435 226.86c.051-1.222.635-1.955 1.895-2.067-1.039 2.73-.291 4.727 2.429 5.914-3.166.656-4.726-.493-4.324-3.847z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FAFEF6"
        d="M257.465 163.832c.672-1.096 1.334-.078 2.001.009.61 1.038 2.164 1.447 2 3.001-2.147.077-4.31.177-4.001-3.01z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2E2A69"
        d="M322.46 183.856c-.432 2.982.995 6.166-.969 8.984l-.98-.881c1.065-2.601.295-5.644 1.949-8.103z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F8FBFB"
        d="M260.938 193.557c.045 1.242-.902 1.393-1.581 1.751-.662.35-1.387.21-1.614-.51-.278-.882.088-1.629 1.104-1.815.811-.148 1.614-.164 2.091.574z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#8C87B2"
        d="M251.446 199.985l-1.916 1.721c-.725.008-1.45.016-2.174.022-.952-1.55-2.586-.602-3.84-1.047-.305-.582-.155-1.001.449-1.258 2.145.005 4.303-.356 6.426.235l1.055.327z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D6D9D7"
        d="M312.547 227.783c-1.057.269-2.343-.131-3.081 1.062-1.001.575-2.001.607-3-.005l.987-1.086c.971-1.374 2.082-2.5 3.978-2.229.877.501 1.458 1.152 1.116 2.258z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F3F3F3"
        d="M268.475 229.838c-1.25 1.859-2.47 3.757-5.009 4.002.889-2.309 2.418-3.821 5.009-4.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#88DBF7"
        d="M364.439 160.787a8.702 8.702 0 00-.74.052c-1.861-2.615-1.703-5.256-.098-7.914.998.839 1.52 1.934 1.715 3.203-1.523 1.322-.55 3.113-.877 4.659z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6FAFA"
        d="M327.467 168.839l-.001-1.997c1.16.247 2.639-.591 3.475.998-.835 1.59-2.314.751-3.474.999z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FAFCFB"
        d="M371.467 162.842c1.301.033 1.965.7 2 1.999-.203.676-.207 1.895-1.247 1.365-1.333-.68-.554-2.212-.753-3.364z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9E684"
        d="M228.463 230.85c-1.135 1.254-.394 4.094-3.276 3.872.217-2.031.789-3.763 3.276-3.872z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FAF9F0"
        d="M349.467 232.84l-.002 1.998c-1.237-.104-3.26.281-3.157-1.3.104-1.613 1.886-1.275 3.159-.698z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FCFAF8"
        d="M382.932 209.663c.076.944-.674 1.091-1.27 1.043-.551-.044-1.404-.341-1.539-.729-.309-.893.588-.963 1.201-1.048.655-.091 1.274.038 1.608.734z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F2F0F0"
        d="M263.469 233.836c-.529 2.148-1.299 4.055-4.02 4.004.978-1.698 2.301-3.049 4.02-4.004z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6CC2E3"
        d="M346.473 158.842c.145 1.444.454 2.931-1.007 3.968l-1.734-.121a2.881 2.881 0 01-.011-.922c1.12-.784.362-3.336 2.752-2.925z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F4F7F4"
        d="M350.571 200.8l-1.126.021c-.713-1.674-1.82-3.475 1.272-3.91-.048 1.297-.096 2.593-.146 3.889z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F3AD6D"
        d="M362.51 211.874c-.066-.8-.207-1.564-.988-2.013-.268-.204-.367-.42-.299-.647.07-.232.146-.35.229-.35l1.898-.74c.414.559.826 1.116 1.242 1.673-.694.692-1.389 1.384-2.082 2.077z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7FCFA"
        d="M353.477 159.829c1.171.724.931 1.918 1 3.008-1.497-.616-3.206-1.162-1-3.008z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#26225A"
        d="M259.485 126.679l12.045.003c1.172-.542 2.397-.299 3.61-.243 1.479 1.971-.872 1.587-1.421 2.311-3.212 3.854-7.63 5.164-12.341 5.485-8.78.599-17.562.889-25.229-4.675l-.643-1.642c.639-1.849 2.261-1.488 3.66-1.63 4.105.076 8.21.076 12.316.067 2.665.169 5.359-.364 8.003.324z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#41B3DE"
        d="M273.719 128.75l1.605-1.872c.508-.762 1.593-.313 2.129-1.016l1.132.019c1.648 1.73 3.768.896 5.66.92 8.799.11 17.6.075 26.4.092-.292.657-.585 1.315-.875 1.973-.138.316-.279.632-.42.947-1.426.798-2.6 1.933-3.894 2.907-11.155 3.284-21.918 3.432-31.737-3.97z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#48B6DB"
        d="M311.464 156.832c-2.471-.565-4.326-.37-4.062 2.942.109 1.367-.165 2.941-1.962 2.818-1.778-.121-1.673-1.796-1.696-3.097-.044-2.49-.024-4.982.028-7.473.03-1.441-.301-3.321 1.947-3.29 2.387.033 1.501 2.087 1.754 3.397.094.486.093.991.136 1.488.724 1.779 2.852.814 3.888 1.987.224.417.224.826-.033 1.228z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#54B7DB"
        d="M301.4 154.975l.061 1.899c-.66.533-1.652-.65-2.21.429a1.515 1.515 0 01-1.115-.281c-2.614-.595-5.354-1.217-6.028-4.296-.567-2.59 1.61-3.659 3.381-4.828.62-.646 1.289-.653 1.995-.15 1.413.878 3.97.258 3.946 3.016-3.662 1.377-1.423 2.797-.03 4.211z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#59B5D7"
        d="M326.767 161.048l-1.359 1.606c-3.055.197-6.256.805-7.924-2.851-2.339-2.049-3.161-4.251-.688-6.788.021-1.943.547-3.543 2.732-4.012.676.758 1.861.95 2.254 2.025.104.896-.279 1.669-.607 2.461-.503 1.49-.842 2.963.242 4.344 1.261 1.038 2.886.199 4.225.816.783.611.869 1.545 1.125 2.399z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#45B1D2"
        d="M251.681 158.824a2.02 2.02 0 00-.033.965c-.859 1.552-2.055 1.964-3.636 1.076-.103-3.317-.227-6.634-.296-9.952-.029-1.349.553-2.272 2.062-2.166 1.293.092 1.521 1.054 1.565 2.121.108 2.652.224 5.303.338 7.956z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#45B6E0"
        d="M237.323 160.808c.113 1.602-.836 1.862-2.093 1.573-1.644-.378-1.12-1.5-.78-2.53-.541-.679-.608-1.36-.012-2.046l.017-9.02c1.648-.456 3.307-1.065 4.833.318l.301 2.501c.536 1.317-.241 1.965-1.267 2.486l-.861.751c-1.683 1.952-1.1 3.955-.138 5.967z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3BB6DD"
        d="M261.472 161.84c-1.164.174-2.766.425-2.874-1.03a77.287 77.287 0 01-.047-10.931c.101-1.479 1.751-1.108 2.891-.994.01 4.319.019 8.637.03 12.955z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7FBF7"
        d="M284.824 154.779c5.599 1.477 1.299 6.431 3.693 9.153-1.81.412-2.248-1.141-3.337-1.318-.67-2.413-3.322-1.158-4.592-2.477-2.656-5.005 2.628-3.725 4.236-5.358z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#58ABCC"
        d="M266.498 161.81c-2.814.672-1.891-2.144-2.923-3.135 1.174-3.205-1.771-7.208 1.925-9.924 1.139 1.337 1.649 2.941 1.983 4.626.06 2.855-.552 5.633-.985 8.433z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#49B1D6"
        d="M230.521 160.872c-.94-.088-1.781-.346-2.219-1.293-1.047-2.377-.003-4.717.119-7.077.547-1.303 1.028-2.736 2.92-1.639l1.219 1.958c.493 1.983.897 3.962-.246 5.876l-1.793 2.175z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#45AFD5"
        d="M284.824 154.779c-.562 1.039-1.269 1.822-2.544 2.055-2.36.431-1.921 1.71-.825 3.113-.804 2.484-2.302 1.878-3.89.875l.031-1.985c1.163-1.193.877-2.64.71-4.064-.671-1.232-1.185-2.494-.73-3.935 1.064-.818 2.103-.887 3.103.109-.702 3.532 1.225 4.219 4.145 3.832z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#66B4D0"
        d="M298.136 157.022l1.34-.191c1.308 1.15.81 2.831 1.247 4.237l-1.381 1.535c-1.178 1.428-2.493 1.235-3.868.327a1.87 1.87 0 00-.977-.139c-1.542-.857-5.139-.672-1.987-3.912 1.891-.574 5.459 3.936 5.626-1.857z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5DB7D2"
        d="M231.34 150.863c-1.385.035-1.85.916-1.957 2.127-1.883-.249-3.771-.728-5.629.141-1.214-.313-1.583-1.429-2.198-2.312l-.46.02c2.554-4.344 4.136-4.68 9.36-1.988l.884 2.012z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#40B4DA"
        d="M243.513 148.756c2.037-.134 1.93 1.315 1.918 2.645-.027 3.133-.088 6.266-.135 9.398-.968.724-1.804 2.023-3.23.729-.592-1.366-.101-2.622.383-3.881 1.352-2.845-.318-6.051 1.064-8.891z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7FCF7"
        d="M230.457 148.85c-3.524-1.237-6.839-1.492-9.36 1.989l-.63-.997c1.178-2.156.721-5.946 5-5.002.2 3.158 4.541 1.161 4.99 4.01z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3FB4DF"
        d="M311.464 156.832l-.025-1.006c-.577-.708-.571-1.438-.079-2.184.865-1.543-1.581-4.49 2.06-4.855 1.567 2.835 1.534 5.939 1.271 8.997-.142 1.631-.172 3.926-3.059 3.055-.055-1.337-.111-2.672-.168-4.007z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7FBF7"
        d="M292.511 158.879c-1.719 2.514 1.019 2.764 1.987 3.912-1.484.761-3.16 1.795-4.364-.092-.949-1.486-1.766-3.715-.808-5.098 1.974-2.849 1.829 1.45 3.185 1.278z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3FB3E4"
        d="M326.767 161.048c-.949-.437-1.251-1.255-1.305-2.22-.334-.319-.479-.713-.469-1.169.188-1.459.444-2.924-.229-4.339-.447-.955-1.256-1.669-1.736-2.602-.176-.662-.109-1.265.439-1.744 1.26-.529 2.085.528 3.111.853l1.043 1.668c1.543 2.889.865 5.775-.008 8.661-.281.299-.564.595-.846.892z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FEFEFD"
        d="M244.987 167.611c-2.058.339-2.518 4.276-5.235 2.438a1.93 1.93 0 01-.468-2.661c1.828-2.723 3.7.289 5.703.223z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#61AAC5"
        d="M277.565 160.822c1.343-.084 2.821.429 3.89-.876 1.764.162 4.782-1.428 3.726 2.669-2.387-1.247-5.827 1.991-7.616-1.793z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#49B7DA"
        d="M266.471 152.871c-1.48-1.1-.881-2.69-.973-4.119 3.254-.64 3.798 1.5 4.045 3.943.708 1.072.472 1.901-.644 2.505-1.901.364-1.683-1.486-2.428-2.329z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#44B7DC"
        d="M243.458 158.824l-.973 2.828c-.244.543-.563.591-.957.144l-.019-.02c-1.054-1.104-1.033-2.736-1.928-3.918l-1.258-3.768 1.266-2.484 2.038 4.77c.567.848 1.256 1.606 1.831 2.448z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E7F5F9"
        d="M301.4 154.975c-2-.725-4.041-1.372-5.871-3.022 1.708-2.255 4.101-.416 5.901-1.189l-.03 4.211z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5CA9C3"
        d="M311.632 160.838c3.264-1.075 1.502-3.799 1.773-5.773.281-2.055.033-4.182.016-6.277l1.077.058c.347 4.269 2.344 8.546-.067 12.8-1.173.561-2.805 2.721-2.799-.808z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#40B5DE"
        d="M280.679 150.947l-3.103-.109c1.841-4.471 4.954-1.543 8.409-1.836-1.84 2.477-3.782 1.546-5.306 1.945z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FEFEFD"
        d="M316.693 164.845c.87.162 2.329-.208 2.061 1.244-.184.989-1.148 2.272-2.322 2.085-1.027-.165-2.713-1.169-2.718-1.812-.013-1.779 1.733-1.425 2.979-1.517z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#61A7C1"
        d="M248.012 160.865l3.635-1.076c1.529.122 3.249-.671 4.75 1.17-2.914 1.997-5.889 1.088-8.809.685.06-.305.202-.563.424-.779z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A1EEFE"
        d="M314.431 161.645c.021-4.267.045-8.533.067-12.8 1.511 1.008.745 2.635 1.077 3.963.312 2.687 1.232 5.378-.073 8.049l-1.071.788z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#65BBDC"
        d="M243.458 158.824c-1.081-.463-1.842-1.164-1.832-2.446 2.116-2.174-1.064-5.656 1.887-7.621l-.055 10.067z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#72D3F2"
        d="M272.38 148.822c-.823 2.944 2.076 6.663-1.866 8.957-1.702-2.007-.149-3.412.909-4.909.235-1.37-.597-2.991.957-4.048z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7FDF1"
        d="M297.483 147.748l-1.995.15c.22-1.517-.618-3.223.777-4.614 2.618.955 1.265 2.886 1.218 4.464z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3EB4DB"
        d="M237.323 160.808c-2.157-2.039-3.461-4.06.138-5.966l-.138 5.966z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E5F8F8"
        d="M315.502 160.857l.072-8.049 1.221.208c-.603 2.348.182 4.554.688 6.788-.415.812-1.157 1.008-1.981 1.053z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6CB1C7"
        d="M271.423 152.87l-.91 4.91-1.253.139-.837-1.076c-.576-.629-.575-1.27-.042-1.922.928-.46 1.042-1.344 1.163-2.225l1.879.174z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FEFEFD"
        d="M301.466 166.84c-1.3-.034-1.966-.703-2.001-2.002-.255-.223-.339-.444-.254-.666.085-.221.17-.331.256-.331 1.283-.518 3.259-3.121 2.999.997.09.879-.422 1.457-1 2.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7FCF7"
        d="M224.96 144.942c2.226-3.154 3.869-1.857 6.649-.346l-6.649.346z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#33B6DC"
        d="M300.723 161.068c-1.703-1.033-1.068-2.755-1.247-4.236.686-1.103 1.325-.064 1.985.043-.061 1.43.636 2.994-.738 4.193z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FEFEF3"
        d="M301.466 166.84c.02-.824.195-1.57 1-2.002.888.166 2.551-.263 2.346.972-.291 1.758-2.179.732-3.346 1.03z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FEFEFD"
        d="M235.46 166.768c-.642-.051-1.411-.051-1.402-.924.008-.872.783-.902 1.424-.901.642.002 1.411.051 1.404.92-.009.876-.783.858-1.426.905z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7FEF5"
        d="M299.467 163.841l-.002.997c-1.537-.204-3.608.71-3.991-1.908l3.868-.326.125 1.237z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3AB3E7"
        d="M278.306 154.772c1.542 1.665 2.061 3.152-.71 4.064-.085-1.411-.825-2.936.71-4.064z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#57AACF"
        d="M311.36 153.642l.08 2.184c-1.585-.202-3.848.772-3.831-2.207l3.751.023z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C0E8EC"
        d="M232.314 158.697l.245-5.876c1.853 1.2.059 3.773 1.879 4.984l.012 2.046-2.136-1.154z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#37B6DE"
        d="M323.468 148.975l-.003 1.65c-.601.724-1.267.813-2.007.211-1.191-.033-1.916-.559-1.93-1.832l3.94-.029z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FAFDF3"
        d="M276.616 141.392c.698.331.83.952.743 1.605-.082.613-.134 1.459-1.066 1.237-.73-.174-.822-.919-.74-1.573.079-.617.111-1.354 1.063-1.269z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FDFEF2"
        d="M315.431 134.924c.639.061 1.423.038 1.418.922-.005.873-.781.901-1.422.906-.646.005-1.423-.03-1.418-.908.006-.863.776-.871 1.422-.92z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#54B1D5"
        d="M305.457 132.719c.762-1.688 1.285-3.695 3.895-2.907-.625 1.872-2.021 2.71-3.895 2.907z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#65BBDC"
        d="M239.581 157.858c1.665.804 2.007 2.257 1.928 3.918-1.684-.793-1.915-2.302-1.928-3.918zM241.528 161.795a4.83 4.83 0 00.957-.143l2.812-.854c-.567 2.941-2.159 2.004-3.769.997z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F3FBF7"
        d="M216.39 149.412c1.35.864 1.19 1.846.528 2.906-1.727-.711.257-2.093-.528-2.906z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C0E8EC"
        d="M239.289 149.104l-4.833-.318c1.711-1.422 3.347-1.696 4.833.318z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5A7DAE"
        d="M251.486 126.689l-13.026.02c-.317-.224-.406-.417-.27-.581.123-.148.248-.223.375-.223.708-.313 1.417-.627 2.126-.939 3.444 2.078 7.23.245 10.793.948.315.172.42.344.316.517-.103.171-.207.258-.314.258z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8F2A7"
        d="M406.807 215.877l2.504 1.306.182 1.549c.582.771 1.373 1.329 2.033 2.02l.059.044c1.098 1.496.895 3.183.715 4.865-.621 2.041-2.293 2.136-3.996 2.166a9.822 9.822 0 01-1.572-.025 3.545 3.545 0 01-1.363-.612c-.852-.9-.943-2.144-1.434-3.204-1.238-1.564-3.76-1.788-4.285-4.088-.691-3.51.541-4.607 3.865-3.082 1.417.809 2.323-.174 3.292-.939z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FBA27D"
        d="M405.311 222.8c.059 1.251.115 2.503.174 3.754-.26.736-.891.898-1.553 1.019-1.621-.142-3.268 1.95-4.877-.035-.063-.918-.213-1.843.225-2.718l.41-1.966c1.863-1.088 3.742-.554 5.621-.054z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D4A979"
        d="M405.311 222.8c-1.873.019-3.748.036-5.621.054l-.041-2.958c1.414 1.894 4.019 1.46 5.662 2.904z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#472E44"
        d="M399.28 224.82l.559 2.968c.17.565.885.753.961 1.385-.107.875-.523 1.466-1.461 1.569a464.75 464.75 0 00-1.01-.935l.332-4.978c.207-.009.412-.012.619-.009z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FEFEFD"
        d="M397.452 188.838c-1.391-.177-1.975-.998-1.973-2.363.006-5.129-.115-10.26.025-15.385.076-2.821 1.268-.282 1.945-.258l.003 18.006z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5E89B9"
        d="M251.486 126.689a12.55 12.55 0 01-.001-.776l7.977-.108.023.876c-2.666.001-5.332.005-7.999.008z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#619FCE"
        d="M277.453 125.862c-.449.885-1.277.974-2.128 1.016l-3.795-.194c1.798-1.548 3.947-.562 5.923-.822z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9BE9E9"
        d="M464.385 185.713c.4.985 1.059 1.72 2.063 2.119 2.635 3.063-1.613 6.853 1.045 9.912-5.545-.914-7.082-6.863-3.108-12.031z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B3E9F3"
        d="M472.383 217.635c.9 1.587 1.285 3.276 1.014 5.095-1.281.033-2.563.068-3.844.103-.787-.198-1.658-.269-1.951-1.248.652-2.46 2.69-3.237 4.781-3.95z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#38B6E3"
        d="M467.467 206.838c.318-1.42-2.141-2.216-1.207-3.318 1.104-1.308 2.924-.787 4.814-.082-.876 1.622-1.574 3.135-3.607 3.4z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#39B5E1"
        d="M475.522 198.794c-1.145 3.476-3.42 1.593-5.355 1.327 1.477-1.852 3.529-.995 5.328-1.327h.027z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#98EEFE"
        d="M471.51 196.854c1.971.689 5.033-1.715 5.906 2.086l-1.895-.145h-.027c-1.072-1.378-2.686-.708-4.027-1.068a6.212 6.212 0 01.043-.873z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#55C2EE"
        d="M428.461 216.874c.939-7.317 1.201-14.665 1-22.033l.012-1.993c.332-.488.66-.461.982.009-.484 8.019 1.426 16.239-1.994 24.017z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#45B6E4"
        d="M430.456 192.856l-.49-.011-.492.002c-1.244-3.016-1.584-6.153-1.391-9.384 2.794 2.677 1.183 6.37 2.373 9.393z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4AB5DE"
        d="M434.469 204.844a65.74 65.74 0 00-.994.005c.227-1.688-.664-3.593.973-5.005.008 1.667.015 3.333.021 5z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#68E9CE"
        d="M431.463 164.842c.834-4.306 4.332-7.162 5.992-11.02.756 1.668.787 3.334-.018 4.996-3.321.687-3.194 4.799-5.974 6.024z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#74EEF1"
        d="M437.438 158.819l.018-4.995.023-6.986h.84l.201 14.931c-2.012-.378-.566-2.023-1.082-2.95z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#44B4D8"
        d="M439.594 246.718l.01 1.171-.17-.062c-3.346 1.596-7.01 2.242-10.459 3.54-5.063 1.128-10.021 3.32-15.367 1.48-.006-1.937-.01-3.873-.014-5.81 5.715-1.43 11.875-1.361 16.922-5.032 3.547 1.345 4.09-3.254 6.852-3.463 1.133-.379 1.508.527 2.023 1.193.068 2.329.137 4.656.203 6.983z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E3AC46"
        d="M440.469 232.839a13.48 13.48 0 00-.877.047l-.047-7.956c.307-.021.613-.013.918.029.793 2.626.78 5.253.006 7.88z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F87F8A"
        d="M426.469 234.84c-1.365-.013-2.824.129-3.002-1.831l3.994-.153c-.015.819-.193 1.558-.992 1.984z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A3EDE8"
        d="M439.391 239.737c-.676-.396-1.352-.794-2.025-1.191-.164-1.543.842-2.145 2.063-2.574l-.038 3.765z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E76E6C"
        d="M430.452 237.707c-.369-.56-.758-.891-.791-1.253-.059-.661.252-1.307 1.053-1.086.279.077.553.742.539 1.128-.012.343-.424.672-.801 1.211z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EFB852"
        d="M440.469 232.839l-.006-7.881 1.063.002c-.557 2.6.963 5.477-1.057 7.879z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECD33F"
        d="M367.412 213.022c1.207-.373 2.066.411 3.012.907.088 2.632 1.646 5.055 1.111 7.775.281.354.363.752.277 1.191-.549.905-1.332 1.663-1.686 2.691-1.086 2.727.24 5.412.115 8.115-.018.354-.164.614-.252.791.145-.073.287-.146.443-.236a5.477 5.477 0 011.205-.369c1.125-.152 2.227-.129 3.299.268.414.207.73.517.953.922.518 2.091-1.289 2.607-2.428 3.578l-2.885.256c-2.307.919-4.99.322-7.162 1.782-2.68-.432-5.307 1.921-8.011.152l-.12-8.895c.967.094 2.008-.013 2.889.315 2.859 1.065 4.146.497 4.389-2.868.314-4.363 1.496-8.663 1.813-13.026.167-2.288 1.981-2.298 3.038-3.349z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EBD04A"
        d="M371.453 222.852l.082-1.146c2.317 2.293 2.985 5.389 4.042 8.295.221.454.143.861-.189 1.229-1.654.823-2.792 2.213-3.92 3.609h-.97c-.635-2.462-1.781-4.823-1.488-7.469.871-1.472 1.453-3.105 2.443-4.518z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B991A2"
        d="M409.403 232.972l10.156.067c-2.932 2.647-7.273 2.618-10.156-.067z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EFA186"
        d="M399.338 230.742l1.16-1.873c.748-.703 1.635-.854 2.611-.668 1.738.785 2.791 2.293 3.908 3.733.115.29.221.583.32.879l-3.861.044c-2.316 1.443-2.768-.919-3.893-1.908l-.245-.207z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FCA174"
        d="M399.584 230.949l3.893 1.908c-.205 1.34-.387 2.837-2.318 2.214-2.11-.681-1.705-2.493-1.575-4.122z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7E6DA"
        d="M375.278 230.858c.121-.279.221-.565.299-.858 1.125.453 1.93 1.161 1.982 2.471-.07 1.151-.143 2.304-.215 3.457-1.086.343-1.387-.474-1.756-1.188l-.01.013c-1.183-1.216-1.238-2.517-.3-3.895z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F37673"
        d="M391.358 234.411c-.146.999-.531 1.861-1.645 1.985-.264.029-.889-.633-.836-.752.367-.829.703-1.826 1.379-2.317.524-.382 1.024.387 1.102 1.084z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E66A6D"
        d="M407.819 240.063l2.535 3.747c-2.426-.626-2.953-1.559-2.535-3.747z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#54BEEA"
        d="M413.608 252.848c5.422.393 10.656-.69 15.859-2.009.668-.578 1.334-.561 2 .002-5.535 3.225-11.893 2.776-17.875 4.007l.016-2z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4EBFE6"
        d="M431.467 250.841l-2-.002c3.197-1.419 6.488-2.524 9.967-3.012.037.326.072.653.104.98-2.772.357-5.178 2.153-8.071 2.034z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E5C238"
        d="M443.461 246.693c-.98-.016-1.961-.031-2.941-.048 1.404-2.024.771-4.414 1.098-7.293 2.529 2.412 1.611 5.027 1.843 7.341z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1570C9"
        d="M486.469 225.834c1.332.655 2.346 1.628 2.971 2.986-1.322.071-2.639.99-3.967.025-1.197-1.508 1.016-1.89.996-3.011z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7D668"
        d="M117.458 230.853c-1.327-.054-2.651-.981-3.981-.013l-.012-1.999c-.679-.673-.034-1.336.013-2.004l-.03-1.993c-.515-.404-1.164-.793-1.078-1.526.062-.53.577-.66 1.096-.482l1.873.027c-.486 3.046 3.003 4.211 3.267 6.903l-1.148 1.087z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F8E27A"
        d="M113.466 222.835c-1.102.66-.087 1.339-.018 2.009-4.933-2.063-5.27-3.08-1.985-6.006l2.003 3.997zM108.465 212.841l1.002 3.998c-1.062.509-1.563 2.654-3.029 1.637-1.543-1.069.596-1.708.825-2.638.257-1.046.056-2.3 1.202-2.997zM113.478 226.837c1.105.676.071 1.336-.013 2.004-.674.111-1.631.95-1.851-.355-.212-1.259.841-1.543 1.864-1.649z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#41A7CC"
        d="M412.172 226.224c-.963-1.727-.252-3.635-.588-5.429 3.428 3.597 2.635 7.041-1.951 8.031-1.371.296-2.041.906-2.279 2.182-2.436-.954-1.943-2.459-.771-4.093l1.045.217c1.609.172 3.33.897 4.544-.908z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5E3029"
        d="M406.583 226.916c.15 1.384-.484 2.917.771 4.093-.09.315-.201.623-.334.925-2.338.305-2.717-1.644-3.543-3.077-.141-.643-.389-1.286.035-1.919l1.973-.383 1.098.361z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#41A7CC"
        d="M411.526 220.751c-1.322-.022-2.166-.526-2.033-2.019 1.097.25 3.08-.39 2.033 2.019z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#24215D"
        d="M493.467 226.836c.047-.568.096-1.138.145-1.704l3.811-2.314c1.722 4.332-1.366 3.931-3.956 4.018z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1776D4"
        d="M496.655 214.851c.533.266 1.156.373 1.268.672.279.739-.268 1.176-.951 1.138-.355-.021-.869-.398-.973-.722-.079-.246.38-.662.656-1.088z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EAF0B6"
        d="M499.356 198.051c.398.898.799 1.796 1.199 2.693l-3.016.047c.057-1.048-.18-2.188.92-2.906.303.04.6.096.897.166z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EBD141"
        d="M503.469 198.833c-1.459.153-2.766-.281-3.982-1.047.605-.993 2.127-1.364 1.959-2.882l2.023-.052v3.981z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#43B3D8"
        d="M193.152 262.983c-2.856.276-4.3-2.53-6.769-3.099.812-1.813 2.12-3.321 3.08-5.044 1.107.139 1.908.646 1.942 1.855.057 2.021.084 3.547 2.724 4.5 2.05.741-.026 1.443-.977 1.788z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6FCAF7"
        d="M201.276 216.868l-.03 1.925c-4.283-1.28-8.062-3.56-11.787-5.944-.038-2.205 1.55-1.983 2.98-1.996 1.751 3.759 5.941 3.936 8.837 6.015z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#67CAF6"
        d="M192.439 210.852l-2.98 1.996-7.988-4.01c.806-.022 1.548-.173 1.975-.967 2.411.434 4.073 3.557 7.048 1.963l.995-1.029c.752.48.955 1.215.95 2.047z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#44B1E5"
        d="M213.414 273.802c-1.498 1.038-3.205 1.102-4.933 1.063-.972-2.66 1.115-3.458 2.812-3.853 2.009-.467 2.194 1.244 2.121 2.79z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3BB1E8"
        d="M189.462 254.84c.408 2.557-.597 4.252-3.08 5.044l-2.032-1.993a4307.85 4307.85 0 005.112-3.051z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C7C165"
        d="M177.449 268.902l10.086-.035-.143 1.958c-.418.33-.894.488-1.426.484-2.747-.472-5.667.388-8.296-1.046-.449-.392-.522-.846-.221-1.361z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#1D80BD"
        d="M196.487 272.834a29.228 29.228 0 01-.937-.018c-1.786-1.749-4.045-.674-6.067-1.018-.266-.205-.364-.421-.296-.649.069-.234.145-.352.227-.352 2.35.703 5.597-1.706 7.073 2.037z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4B93B9"
        d="M189.413 270.798l.07 1.002-.177.356c-.645.485-1.376.715-2.177.751-1.078-.017-2.096-.195-2.844-1.081.059-1.602.978-1.59 2.132-1.133.321.078.646.122.977.131l2.019-.026z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#47ACE7"
        d="M197.512 274.832l-.06-1.978c1.034-.982 1.513-.11 1.647.669.19 1.105-.768 1.212-1.587 1.309z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A8EDE4"
        d="M138.509 246.997l1.032-2.002c1.953.537 4.802-1.96 5.823 1.724-1.812 1.583-2.781 4.288-5.754 4.325-2.737-.706-1.623-2.458-1.101-4.047z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DAC03E"
        d="M154.127 248.635c-2.283 2.891-4.107 2.411-6.696 1.35 2.21-1.73 4.241-.848 6.696-1.35z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9ED6BD"
        d="M138.509 246.997c.082 1.426-.433 3.014 1.1 4.046-.046 1.289-.771 1.856-2.003 1.88l-.113-6.144c.339.072.677.144 1.016.218z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C2BF71"
        d="M177.449 268.902c.006.289.008.578.004.866-.52.703-1.258 1.021-2.082 1.197-1.914.197-3.827.363-5.606-.639-.5-.384-.601-.855-.302-1.412l-.008-.172c2.666.052 5.33.106 7.994.16z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A5EADF"
        d="M135.531 254.928c.023-1.302-.599-3.234 1.986-2.032.008 1.333-.694 1.971-1.986 2.032z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DCBF34"
        d="M155.333 249.387l.386-5.887 1.318.139c.572 1.855 1.144 3.71-1.704 5.748z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9F9F0"
        d="M248.273 255.858l-.083-3.915c-.151-.436-.062-.814.267-1.138l6.028.035c1.213 1.846-.305 4.133.967 5.969-.012 1.086.19 2.233-.853 3.029-1.5.236-2.995.173-4.492-.048a3.81 3.81 0 01-1.207-.498c-.134-.173-.266-.349-.397-.523l-.23-2.911z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F9FAF9"
        d="M311.452 225.845l-3.999 1.909c-.091-1.907-2.417-1.52-2.999-2.922-.266-.951.5-1.372.917-2.034.683-1.084 4.044.554 2.578-2.568 3.263-.974 6.496-1.432 9.59.531.312.469.444.989.403 1.552-1.461 2.46-3.431 3.995-6.49 3.532z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#98CCC2"
        d="M289.334 273.611l-7.772.044c.633-1.908-2.341-4.558.394-5.61 1.811-.697 4.773-2.388 6.563.789 1.029 1.233-.104 2.918.868 4.163a1.742 1.742 0 00-.053.614z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DFE0E0"
        d="M307.526 221.031c.659.385 1.848.736 1.875 1.162.077 1.212-1.132.483-1.746.721-1.189.461-2.392.845-3.201 1.919l-8.964-.003c-1.424-1.604-3.333-.742-5.025-.99-.345-.495-.356-.999-.038-1.511 1.828-2.165 4.369-1.67 6.737-1.816 2.185.007 4.377.11 6.556-.172 1.282.138 2.655-.187 3.806.69z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#2C2759"
        d="M249.435 259.042c1.752.065 3.673-.962 5.165.796l-.194 6.13a3.003 3.003 0 01-1.47.838c-1.489.207-2.895.118-3.958-1.146-.645-2.26-1.009-4.502.457-6.618z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7ECDB"
        d="M266.441 246.79c-1.708-2.689-4.397-1.953-6.871-1.972-.631-.799-2.562-.1-2.267-1.966-.015-.634-.031-1.268-.048-1.9 2.297 2.546 5.368 1.758 8.222 1.902 1.274 1.636 4.285-1.168 4.979 1.949-1.075 1.289 1.17 1.217.894 2.179-1.69 1.328-3.288.292-4.909-.192z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E2E1E1"
        d="M270.457 244.803c-1.193-1.843-3.802-.067-4.979-1.949h15.097c-3.101 2.984-6.736 1.566-10.118 1.949z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D6D7D8"
        d="M263.496 251.891h15.765l.017.894h-15.78c-.349-.198-.465-.396-.35-.596.114-.198.23-.298.348-.298z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EEB187"
        d="M266.441 246.79c1.7-1.556 3.261.439 4.91.191-.648 3.296-3.164 1.452-4.891 1.779l-.019-1.97z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CBCBCB"
        d="M286.494 225.927l6.975-.17c.487.07 1.124-.028 1.435.243 1.174 1.03-.149.792-.515.794-2.631.018-5.262-.026-7.894-.052-.348-.181-.463-.361-.348-.543.114-.181.229-.272.347-.272z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C6C7C6"
        d="M275.476 235.289c3.292-.603 5.655-.604 8.978-.043-3.321.846-5.683.777-8.978.043z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C8C8C8"
        d="M271.472 262.86h6.891l.027.961h-6.918c-.332-.213-.442-.427-.332-.641.11-.213.22-.32.332-.32z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6FBED4"
        d="M253.462 266.304l.945-.338c1.034 1.491 1.136 3.152.902 4.876l-1.854-2.076c-.732-.823-.797-1.643.007-2.462z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E4E4E4"
        d="M285.633 243.457c2.138-.83 3.301-.754 4.768.219-1.666 1.533-2.734-.018-4.768-.219z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DEDEDE"
        d="M266.474 263.821h-4.881l-.038-.963h4.918c.324.214.432.428.324.642-.107.213-.214.321-.323.321z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DFE0E0"
        d="M255.453 256.809c-1.799-1.75-.649-3.979-.968-5.969.33-.04.658-.025.982.045l-.014 5.924z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D4D5D3"
        d="M276.515 229.905l5.975.013c.313.194.417.388.312.579-.105.19-.21.286-.317.286l-5.973-.003c-.359-.196-.478-.391-.357-.585.118-.194.238-.29.36-.29z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DDD"
        d="M289.725 251.667c-2.364 1.544-3.366 1.079-4.66.939 1.256-1.202 2.32-.583 4.66-.939z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DDDCD1"
        d="M286.494 225.927a7.932 7.932 0 000 .816l-1.025.178c-1.025-.265-2.238.343-3.149-.684 1.371-.757 2.791-.302 4.174-.31z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D2D2D2"
        d="M266.474 263.821a20.655 20.655 0 01-.001-.964l4.999.002c-.007.322-.007.644 0 .963l-4.998-.001z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D7D7D7"
        d="M300.438 230.797h-5.004c2.477-1.175 3.775-1.371 4.977.02l.027-.02z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CBC8C7"
        d="M282.484 230.783a9.98 9.98 0 01.005-.865l4.976-.076c-1.391 1.736-3.293.773-4.981.941z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E5E9E7"
        d="M276.515 229.905a5.338 5.338 0 00-.004.876c-1.676.011-3.353.021-5.029.033 1.442-1.607 3.324-.782 5.033-.909z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E6E0E7"
        d="M263.496 251.891c-.014.298-.014.597.001.895-1.374-.082-2.813.449-4.168-.445 1.352-.899 2.794-.364 4.167-.45z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F4F6F7"
        d="M289.387 272.997c-1.227-1.191-.871-2.714-.869-4.163 2.959.831.156 2.864.869 4.163z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EBD04A"
        d="M375.588 234.739l1.756 1.189c.162 2.978-1.768 2.982-3.881 2.729.709-1.307 1.416-2.613 2.125-3.918z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E5D970"
        d="M363.416 240.694c1.709-3.323 4.729-1.368 7.16-1.782-2.228 1.225-4.51 2.242-7.16 1.782z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#70B4E4"
        d="M253.462 266.304l-.008 2.463c-1.292.73-2.583 1.463-3.874 2.194a2.288 2.288 0 01-.876-1.055 5.6 5.6 0 01.013-2.779c.193-.441.503-.774.927-1.003 1.273.061 2.545.121 3.818.18z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#89B07C"
        d="M249.373 270.053c.029.311.098.613.208.907l-.221 3.817-.481.016-.48-.022c-.001-1.64-1.89-3.67.974-4.718z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#25205A"
        d="M331.468 312.841c.155-1.587.705-2.979 1.988-4.005-.176 1.577.688 3.669-1.988 4.005z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#91DCEF"
        d="M187.446 271.929c.621.075 1.241.149 1.86.227.036.217.065.435.085.652-.089 1.099.145 2.285-.854 3.136-1.298-1.084-1.701-2.411-1.091-4.015z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A6EDE9"
        d="M187.446 271.929c.808 1.217 1.074 2.581 1.091 4.015l-.104 3.853.02.069c-1.965 1.604-4.142 1.459-6.386.784-1.35-.634-1.939-1.812-2.255-3.177a3.605 3.605 0 01.118-1.496c1.007-1.605 2.275-3.016 3.519-4.446.472-.181.896-.089 1.278.235l2.719.163z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#89B7B9"
        d="M147.523 307.826c-.036-.27-.1-.531-.194-.786l.255-.321c2.452-1.802 5.212-1.166 7.916-1.007a4.244 4.244 0 011.516.636c.17.216.337.436.505.655l-2.02.946c-2.66-.04-5.319-.082-7.978-.123z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#78824B"
        d="M158.472 298.873c-.038 2.634-.075 5.268-.114 7.901a6.212 6.212 0 00-.838.228l-.212-.309c-1.587-2.183-1.246-4.552-.675-6.946.222-.51.584-.889 1.081-1.14l.758.266z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9CE7EE"
        d="M179.408 290.005c-.007.302.011.603.056.901-.372.323-.72.316-1.042-.074-1.653 2.424-.737 5.471-1.94 8.003l-3.864.005-.363-.948c.059-2.832-1.029-5.617-.345-8.48 2.015-1.124 4.11-1.028 6.242-.434.488.257.906.601 1.256 1.027z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D8D769"
        d="M171.388 290.244c3.121 2.229 2.237 4.911.866 7.648l-2.667-.089-.339.055c-1.376-1.926-1.153-4.073-.873-6.23.283-1.051.724-1.972 1.931-2.218.576-.005.938.273 1.082.834z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EAD244"
        d="M159.591 304.862l-.016-1.065c1.42-1.617.161-4.356 2.364-5.653 1.952-.735 3.82-.83 5.471.719l-.063 2.932c-3.476-1.23-4.781 3.031-7.756 3.067z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#648267"
        d="M169.35 290.813l-.101 7.045-.652-.047-.241.055c-1.637-2.087-1.396-4.308-.476-6.58.358-.563.849-.72 1.47-.473z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6D896A"
        d="M167.41 298.862l-5.916.138c-.685.445-1.351.441-1.992-.089l-1.031-.038-.025-.024-.294-.723c.233-.49.598-.844 1.094-1.065 2.58-.642 5.148-.827 7.679.231.182.188.361.379.541.569l-.056 1.001z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A2BFA4"
        d="M168.587 290.866c-.077 2.333-.153 4.667-.231 7l-.445-.011-.444.006-.029-.013a6.146 6.146 0 01-.832-1.259c-.502-1.742-.447-3.495-.093-5.254.144-.491.395-.923.743-1.298.886-.438 1.381-.243 1.331.829z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DCC63A"
        d="M159.502 298.911l1.992.088c-.045 1.838.261 3.816-1.919 4.799l-.073-4.887z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#397BA0"
        d="M178.422 290.833l1.042.073-.056-.052c1.742 1.988 1.574 3.973-.014 5.954l-.453.021-.451-.046a5935.49 5935.49 0 01-.068-5.95z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9EE9EA"
        d="M179.393 296.808l.014-5.954c2.666-1.484 5.356-.335 8.038-.078-.263 6.11-.263 6.11-8.052 6.032z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A1ECEB"
        d="M188.448 288.774l-7.928-.071c-2.193-4.675-1.816-5.984 2.209-7.709 4.684-.087 5.477 3.056 5.592 6.759l.127 1.021z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#8DD5DE"
        d="M183.49 281.858c-5.408.365-2.087 4.518-2.97 6.846l-.465.048-.467-.036c-2.149-2.59-1.824-5.285-.349-8.031 3.085-.565 6.163-.61 9.225.171l-.11 1.046c-1.627.676-3.249.677-4.864-.044z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A4EDFC"
        d="M183.49 281.858l4.864.042-.032 5.854c-.785-2.643-1.487-5.353-4.832-5.896z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#418BAE"
        d="M188.464 280.855l-8.941.129c-.305-.431-.315-.877-.07-1.337.699-.396 1.382-.4 2.045.082l6.956.137c-.001.33.003.66.01.989z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#458BAE"
        d="M179.464 279.912l.058 1.07.065 7.733-.179 1.29a2.727 2.727 0 01-.904-.235 5.843 5.843 0 01-.948-1.381c-.533-2.783-.852-5.556.447-8.241.417-.502.905-.58 1.461-.236z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EAD440"
        d="M156.413 306.648l-8.83.07-.089-7.856-.01-.002c1.642-1.448 3.482-1.483 5.429-.77 1.775.911 1.81 3.089 3.146 4.326.589 1.37 1.518 2.715.354 4.232z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#80997A"
        d="M153.457 298.972l-5.973-.112.059-1.035c3.663-1.996 7.312-2.113 10.943.083-.009.313-.022.628-.039.94l-1.103.061c-.363.312-.77.549-1.215.726-1.006.243-1.877-.057-2.672-.663z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#8FA789"
        d="M158.485 297.908l-10.944-.083a8.852 8.852 0 00-.279-.858c.152-.19.303-.381.453-.574.629-.402 1.327-.592 2.06-.673 1.191-.114 2.388-.099 3.584-.107 1.193.007 2.387.018 3.565.259.468.128.896.342 1.287.629.329.385.433.819.281 1.309l-.007.098z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#82A084"
        d="M145.527 296.883l-.057-5.859a1.969 1.969 0 01-.613-1.14c.037-.222.076-.441.114-.663.126-.187.253-.371.381-.559a1.863 1.863 0 011.321-.061c.607.391 1.002.938 1.216 1.623.079.459.083.921.033 1.383-.387 1.759.015 3.736-1.405 5.218a4.905 4.905 0 01-.99.058z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#788F71"
        d="M146.516 296.826c.188-1.979-.646-4.081.716-5.918.499.267.851.663 1.062 1.188.503 1.654.463 3.231-.682 4.646l-.349.225a3.862 3.862 0 00-.747-.141z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CDD487"
        d="M169.464 268.915c-.006.275-.021.549-.043.822-1.033 1.335-2.538 1.354-4.018 1.451-2.335.036-4.671.022-7.01.028-1.765-.114-3.645.138-4.93-1.524a12.601 12.601 0 00-.032-.753l16.033-.024z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5C7658"
        d="M141.179 270.728c.138-.211.231-.44.279-.688l6.991-.056c.313.398.477.85.475 1.358-.372 2.434.054 4.937-.618 7.348a2.791 2.791 0 01-.875 1.191c-.48.199-.922.128-1.32-.207-1.685-2.079.007-5.05-1.879-7.066-.934-.552-1.971-.902-2.855-1.532l-.198-.348z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#7F8C41"
        d="M148.45 270.794c.001-.271 0-.54-.001-.811 1.671-.097 3.343-.193 5.014-.291l4.988.293c.276.438.221.845-.115 1.226a4.079 4.079 0 01-1.246.582c-1.994.358-4.045.092-6.036.546a4.081 4.081 0 01-1.359-.047c-.683-.276-1.125-.754-1.245-1.498z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E9CE44"
        d="M141.376 271.077l4.106-.047c.868 1.563.365 3.26.455 4.894.191 3.453-1.274 4.646-4.561 3.211-1.382-1.814-.765-3.644-.036-5.473l.036-2.585z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D3D261"
        d="M141.342 273.662l.176 5.05c-.636.639-1.303.731-2.011.117l-.038.054c.115-1.924-.122-3.973 1.873-5.221z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E6CE4C"
        d="M139.275 288.499l.378-6.705c1.325-2.59 3.469-2.043 5.625-1.472a2.82 2.82 0 011.032 1.272c.556 2.483 1.02 4.959-.923 7.12l-.089.107c-2.08 1.238-4.117 1.691-6.023-.322z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#788C72"
        d="M145.479 280.915c-1.997-.068-4.053-.527-5.827.879a15.906 15.906 0 01-.297-.912l.228-1.016c2.056-.159 4.429-2.103 5.896 1.049z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6C794F"
        d="M139.275 288.499l6.025.323c.031.267.057.533.078.8-1.703 1.445-3.716.387-5.561.69-.926-.069-1.636-.354-1.484-1.495.322-.082.636-.188.942-.318z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B2E5EC"
        d="M138.333 288.817l1.032 1.181c.392.147.528.311.414.49-.12.187-.24.28-.365.28-.756.624-.329 2.26-1.883 2.202l-.072-4.08c.291-.036.582-.06.874-.073z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#AEC8AA"
        d="M145.479 280.915c-1.655-2.099-3.911-.82-5.897-1.048-.024-.347-.05-.692-.075-1.038l2.011-.116c2.582.501 4.272-.025 3.976-3.194-.139-1.484-.015-2.993-.01-4.489 2.07 2.749.451 5.91.988 8.83.223.236.312.485.267.745-.046.267-.102.399-.168.399-.41.249-.783.202-1.119-.139l.027.05z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BDCFAC"
        d="M139.414 290.768a5.524 5.524 0 00-.048-.771l6.013-.375c.029.466.06.933.091 1.4-2.019-.083-4.037-.168-6.056-.254z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C9E6AE"
        d="M249.373 270.053c-1.494 1.331-.613 3.153-.975 4.719-.289.056-.579.106-.87.15l-.013-8.062c.23-.322.541-.513.933-.571.394.062.694.263.903.602l.022 3.162z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E0E5AA"
        d="M248.586 266.787l-1.072.074-.092-3.002c.392-1.689-.594-3.672 1.082-5.09l-.054.014c.862 2.653.665 5.326.136 8.004z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CAD06D"
        d="M248.457 250.805c-.088.378-.175.756-.265 1.136-7.495 1.81-14.915 4.32-22.784 1.935-1.932-.585-3.827-1.071-4.944-2.949.004-.87.16-1.68.911-2.249 3.813 1.96 7.9 2.355 12.098 2.121 2.373-.823 4.979-.358 7.253-2.208 2.223-1.807 4.616-.014 6.735 1.223l.996.991z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EFDD74"
        d="M247.462 249.813c-4.836-2.119-9.236 1.939-13.989.985.983-1.614 3.07-.418 4.675-1.733-3.33-2.218-6.857-3.765-8.682-7.225 1.68-.045 2.52 1.346 3.738 2.117 2.183 1.384 4.495 3.604 7.12 2.626 3.831-1.426 5.429.7 7.138 3.23z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F7DC74"
        d="M240.458 237.853c-1.536-1.029-3.627-1.305-5.398-4.255 2.859 1.493 5.578.096 6.412 3.241-.113.564-.45.903-1.014 1.014z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EDD979"
        d="M240.458 237.853l1.014-1.014c1.454.834 3.26 1.197 3.995 2.991.557.674.64 1.347-.008 2.017-1.122-2.014-4.047-1.769-5.001-3.994z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EDD96B"
        d="M245.459 241.847l.008-2.017c1.146.663 2.143.52 2.288.177-.412.013 1.744 4.516-2.296 1.84z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EBD973"
        d="M257.303 242.852l2.266 1.966c-1.809.03-3.65.19-5.2-1.26.742-1.315 1.985-.449 2.934-.706z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EFDD74"
        d="M229.49 241.852c-1.966-.213-2.758-1.171-3.845-2.86 2.25.374 3.589.84 3.845 2.86z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#58B8DA"
        d="M263.162 198.809c6.3.011 12.736-.771 18.86.274 5.23.894 10.455-1.557 15.469.76-.819 2.426-2.923 1.764-4.605 1.779-8.59.079-17.181.094-25.771.034-1.853-.012-4.596.804-3.953-2.847z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FEFEFD"
        d="M302.09 198.116c-.665.365-.828 1.569-1.853 1.209-.705-.248-.811-.973-.479-1.585.448-.827 1.214-.996 2.013-.531.222.128 1.108.317.319.907z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3BB5E0"
        d="M355.572 162.712l-.016-13.815c.908.009 1.815.018 2.723.025 1.055 4.265 1.174 8.523-.074 12.774-.781.588-1.508 1.321-2.633 1.016z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#48B6DA"
        d="M376.456 148.987c.102 1.373.988 1.844 2.213 1.927.293.904-.146 1.66-.477 2.438-.793 1.54-.477 3.22-.598 4.844a31.53 31.53 0 01-.094.616c-.342.971-.686 1.941-1.027 2.912-4.35-2.468-3.08-6.235-2.291-9.893.822-.897.883-2.402 2.274-2.844z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CAE9EE"
        d="M358.205 161.697l.074-12.774c1.84 4.268 2.03 8.528-.074 12.774z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E5FAFC"
        d="M354.468 148.86l-.029 5.997-1.146-.08c-1.106-1.811-2.908-3.4-1.863-5.892 0 0 .129-.191.129-.193l2.909.168z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D7FDFE"
        d="M368.578 154.873c-2.051-.188-1.191-2.248-2.055-3.2.662-.921 1.324-1.842 1.988-2.763.716 1.98.624 3.968.067 5.963z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#84CCE3"
        d="M368.578 154.873l-.066-5.963 1.002.024c-.34 1.976.689 4.166-.936 5.939z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5BB8D8"
        d="M385.375 190.736c-7.352 2.025-14.846.59-22.27.896-1.365.057-2.799-.561-2.582-2.302.182-1.448 1.547-1.527 2.736-1.53 6.309-.016 12.618-.033 18.926-.017 1.934.005 3.168.857 3.162 2.974a.292.292 0 01.028-.021z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D6BB31"
        d="M359.195 227.577c-1.439-2.69.422-4.062.289-7.037 1.612 3.278-.084 4.682-.289 7.037z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D8C74F"
        d="M347.636 224.906c-.037-1.656.606-3.017 1.803-4.137-.098 1.598.715 3.592-1.803 4.137z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#232057"
        d="M235.604 199.887l-5.13-.043c.187-2.269 1.424-4.517-.094-6.652 4.992-.637 8.267 3.729 12.888 3.788.075.001.134 1.213.2 1.859-1.137 1.252-2.834.828-4.198 1.403-1.234.011-2.505.397-3.666-.355z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#28234F"
        d="M239.465 199.71c1.116-1.292 2.634-.741 4.003-.871 2.301.335 4.774-.784 6.924.819l-6.875.327c-1.383.397-2.765.758-4.052-.275z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#47B2D7"
        d="M282.2 219.85l2.282-1.204c.73-.34 1.453-.328 2.171.041.5.64.625 1.363.477 2.147-.298.763-.743 1.306-1.676 1.109-1.447.534-3.103 1.721-4.396.602-.961-.832 1.257-1.533 1.142-2.695z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F6F6F6"
        d="M285.454 221.944l1.024-1.073c3.403-2.195 6.961-1.67 10.552-.605.592.396.732.917.423 1.56-2.363.103-4.81-.372-6.985 1.02-1.667.752-3.333.741-4.999-.005-.004-.3-.009-.598-.015-.897z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E4E9E9"
        d="M285.469 222.839l4.999.005-.002.995c-1.686-.233-3.6.672-4.997-1z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#48B4DB"
        d="M317.423 222.745c.023-.312.091-.613.203-.904.358-.5.795-.921 1.297-1.274.979-.75 1.672-1.894 2.988-2.181.863-.011 1.738-.139 2.558.261l1.006.037c3.307 2.091 3.286 4.874 1.66 7.99-3.085.791-6.167 1.657-9.358.519.124-.496.435-.846.891-1.045.601-.263 1.248-.283 1.893-.308-.596-.414-1.26.006-1.889-.163-.645-.174-1.195-.441-1.597-.985-.259-.718-.171-1.372.348-1.947z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#242352"
        d="M325.465 182.841c-.249 1.14.598 2.584-.885 3.347-.149.077-.823-.414-.907-.732-.395-1.499.155-2.456 1.792-2.615z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F2FCEF"
        d="M377.336 152.867l1.332-1.953 1.861.117.938 2.806c-1.65.374-2.535 1.267-1.102 2.677.969.954 1.682 1.853.666 2.875-1.227 1.235-2.418.085-3.531-.577l.004.015c-.884-1.964-.656-3.958-.168-5.96z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3FB3DC"
        d="M332.431 162.821c-2.219-4.207-.891-8.692-.816-13.03.03-1.808 1.758-.563 2.756-.333.338.269.535.617.596 1.044-.078 1.388-.43 2.819.646 4.029.68.898 1.595 1.993.326 2.846-1.6 1.075-1.287 2.781-1.883 4.179-.379.63-1.096.826-1.625 1.265z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EFF9F8"
        d="M332.431 162.821l1.01-1.048c.124-3.501 2.332-5.16 5.375-6.085l.599.395c-.001 1.117.117 2.482-1.365 2.614-2.844.253-2.593 2.227-2.584 4.143l-3.035-.019z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#58B9DB"
        d="M327.615 160.157l.008-8.66c3.199 2.889 1.978 5.775-.008 8.66z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#47B5E0"
        d="M334.451 150.634l-.08-1.175c1.522-1.645 3.379-.398 5.07-.588l.167 1.692c.417.991-.185 1.433-.96 1.784-1.699.168-3.203-.15-4.197-1.713z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4DB7DE"
        d="M363.602 152.924c.031 2.639.063 5.277.096 7.915-1.787 1.729-2.23.427-2.262-1.119-.063-2.953.043-5.909.08-8.864l2.086 2.068z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#34B9DC"
        d="M317.472 224.838c1.99.306 3.732-.409 5.506-2.181.625 5.457-3.443 3.386-5.203 4.535l-1.395-.001c-1.135-.204-1.627-.896-1.155-1.944.484-1.077 1.352-1.067 2.247-.409z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#50B3D1"
        d="M317.472 224.838c-1.729.153-2.289.849-1.092 2.355-1.277.195-2.556.393-3.834.59-.363-.646-.729-1.293-1.094-1.938l5.971-3.101c.017.698.034 1.396.049 2.094z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CEE0E9"
        d="M324.469 218.646l-3.034.335c-5.805 1.889-11.818.246-17.686 1.053-5.217.315-10.414-.399-15.627-.323a4.845 4.845 0 01-1.665-.753l-1.976-.312c1.937-1.475 4.181-.75 6.274-.769 9.646-.084 19.293-.062 28.939-.017 1.61.008 3.358-.512 4.775.786z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4AB7E0"
        d="M351.429 148.885c.723 1.933 2.94 3.391 1.864 5.892-1.715 2.293-4.974 1.993-6.82 4.065-1.292.623-.717 3.003-2.753 2.925-.116-1.809-.324-3.616-.335-5.426-.046-7.957-.024-7.957 8.044-7.456z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#49B6E1"
        d="M338.217 151.917l1.391-1.353c3.388 1.287 1.63 3.326.765 5.235l-.958.282.071-.346c-.925-.319-1.548-.916-1.754-1.901-.093-.702.002-1.359.485-1.917z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#706B9C"
        d="M239.465 199.71l4.052.275a3.363 3.363 0 000 .695c-2.654-.103-5.435 1.052-7.914-.794 1.288-.057 2.575-.116 3.862-.176z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#48B3DD"
        d="M221.557 150.819c1.323.068 1.876.856 1.951 2.09 1.368 1.61 1.362 3.222.002 4.834-.5.969-1.41 1.123-2.365 1.19-1.437-2.785-1.24-5.487.412-8.114z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#8CDFFB"
        d="M268.381 154.92l.042 1.922c-1.88 1.177-.04 3.795-1.926 4.968l-.026-8.939 1.91 2.049z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E6F6F7"
        d="M223.509 157.743l-.002-4.834c1.998-2.846 3.958-2.864 5.876.081.274 2.301-.308 4.461-1.082 6.589-2.175.896-3.617-.121-4.792-1.836z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E0C439"
        d="M361.451 208.864c.006.334.029.666.068.997-.125.557-.117 1.463-.873 1.275-1.043-.26-1.066-1.389-1.258-2.288l2.063.016z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E5F4F6"
        d="M321.458 150.836l2.007-.211c1.283.211 1.945 1.027 2.195 2.247a9.292 9.292 0 01-.005 4.947l-.193 1.009c-1.664.859-3.329 2.031-5.002.013-.809-1.959-.603-3.944-.154-5.937.385-.689.769-1.378 1.152-2.068z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#59B7D5"
        d="M320.306 152.905c.052 1.979.104 3.958.154 5.937-1.521-1.941-1.419-3.925-.154-5.937z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#58B9DB"
        d="M325.656 157.82l.005-4.947c1.227 1.65 1.207 3.299-.005 4.947z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#3FB3DE"
        d="M412.172 226.224c-.963 3.072-2.865 1.438-4.547.908 1.52-.286 3.167.069 4.547-.908z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F19771"
        d="M403.512 226.937c-.268.635 1.457 1.306-.035 1.919l-2.979.013c-.221-.36-.441-.721-.66-1.081 1.442.656 2.039-2.333 3.674-.851z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECD53B"
        d="M375.278 230.858c.102 1.298.201 2.597.301 3.894l-4.112.088c-.377-2.905.652-4.464 3.811-3.982z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DBC130"
        d="M369.492 226.851l1.004 7.988c-2.096-3.152-2.992-6.429-1.029-10 .535.664.601 1.333.025 2.012z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E3D93B"
        d="M369.492 226.851c-.008-.671-.018-1.341-.025-2.012.035-1.288.684-1.964 1.986-1.987-.168 1.571.684 3.643-1.961 3.999z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E2C839"
        d="M367.984 223.258c-.656-1.53-.74-2.544-.027-3.582.752 1.032.627 2.052.027 3.582z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9C9A4B"
        d="M184.727 271.766l-1.145.326a3.299 3.299 0 01-2.086.446c-1.413-.323-2.862-.434-4.291-.686-.926-.343-1.973-.584-1.724-1.958l1.973-.126c2.964.54 6.126-.843 8.963.926l-1.69 1.072z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#979649"
        d="M175.481 269.895c.466.784 1.234.934 2.052.977.28.496.213.941-.195 1.337-2.019 1.211-4.196.91-6.363.666-.813-.153-1.56-.604-2.422-.575a4.371 4.371 0 01-1.19-.112c-.781-.236-1.511-.567-2.083-1.176-.2-.396-.14-.753.176-1.065 1.322-.068 2.645-.138 3.967-.208l6.058.156z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#51501A"
        d="M248.586 266.787l-.136-8.004.985.26.209 7.082a3.061 3.061 0 01-.293.767 7.032 7.032 0 00-.765-.105z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4BB6DB"
        d="M286.458 218.958l1.068.004c5.397.878 10.833.158 16.249.395 4.324.001 8.646-.049 12.965.026 1.498.026 3.759-.503 2.729 2.457l-1.841.001c-3.23-1.978-6.725-.655-10.1-.81l-3.129-.059c-2.312.577-4.627.526-6.944.034l-10.976-.136c-.008-.637-.015-1.275-.021-1.912z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECE9EA"
        d="M297.454 221.006l6.944-.034c-2.145 1.673-4.634.534-6.945.853.005-.274.006-.546.001-.819z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#959B5C"
        d="M180.451 275.81c-.017.312-.039.624-.064.935-.536.702-1.236.721-2.001.486-1.469-.943-1.975-2.259-1.519-3.945.228-.492.6-.823 1.115-.996 1.078-.385 2.048-.267 2.86.604.523 1.059.327 2.023-.391 2.916z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BDC878"
        d="M180.451 275.81l-.136-3.044c-.028-.854.18-1.415 1.2-.965.689.097 1.378.192 2.066.29.206 2.292-1.479 2.992-3.13 3.719z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#91DCEF"
        d="M178.554 277.1l1.833-.355 1.111 2.984-2.033.183-.492-.075-.497.01a1.98 1.98 0 01-.655-1.074c-.034-.68.135-1.271.733-1.673z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#CDBC3F"
        d="M156.417 299.004c.304-.079.614-.111.927-.096l-.036 7.784-.451.041-.444-.085c.219-1.394-.318-2.603-.925-3.794-.27-1.423-.163-2.755.929-3.85z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4B8FBC"
        d="M178.412 288.713l.091 1.058-7.115.471-.029-.351c-.151-.548-.02-1.015.394-1.405 1.14-.798 2.44-.872 3.766-.853a4.625 4.625 0 012.893 1.08z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#517B9A"
        d="M171.674 288.983a6.89 6.89 0 01-.313.907l-2.011.923c-.256.007-.51.024-.764.053l-1.166-.839-.249-.495c.043-.379.199-.705.464-.98a3.23 3.23 0 011.021-.463 5.409 5.409 0 011.129-.101 4.26 4.26 0 011.118.207c.358.164.614.428.771.788z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9BB58F"
        d="M158.492 297.808l-.179-1.104c.154-.131.309-.261.462-.396.37-.174.758-.29 1.162-.361.406-.07.814-.104 1.226-.123.625-.048 1.25-.065 1.878-.077.866-.028 1.73-.032 2.591.09.676.12 1.238.465 1.765.882l.041 1.129-8.946-.04z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E7C83B"
        d="M167.397 296.719l-1.932.015c-1.505-1.838-1.536-3.771-.379-5.784.781-.646 1.56-.77 2.33.021l-.019 5.748z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A2C4A6"
        d="M167.417 290.97l-1.962-.032c-.883.703-1.883 1.023-3.014.934a4.164 4.164 0 01-1.57-.492c-.531-.355-.684-.833-.464-1.434 2.277-1.931 4.63-1.86 7.039-.266l-.025.346c.019.315.018.63-.004.944z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#9FEBF9"
        d="M178.412 288.713l-2.933-.01c.22-2.969-.612-5.987.42-8.924.651-.762 1.383-1.319 2.469-.973l.108 1.039-.064 8.868z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E7D24A"
        d="M156.417 299.004c-.045 1.347.48 2.832-.929 3.851-2.605-.286-1.868-2.32-2.032-3.883l2.961.032z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E9D343"
        d="M147.613 296.741l-.026-4.894c2.982-3.706 6.535-2.644 10.136-1.217 1.345 2.123 1.334 4.173-.333 6.133l-3.941-.061c-1.318-1.115-2.638-1.117-3.958-.005l-1.878.044z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E9D834"
        d="M149.49 296.698c1.323-2.653 2.643-2.657 3.958.005l-3.958-.005z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#63754E"
        d="M157.39 296.763l.013-5.827c.563-.373 1.065-.304 1.508.207 1.115 2.001 1.023 3.899-.486 5.676l-.11-.113a4.417 4.417 0 01-.925.057z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BECFAC"
        d="M158.431 290.928l-1.028.008c-3.283.194-6.692-.975-9.816.911-.117-.313-.234-.627-.353-.939.094-.339.19-.678.286-1.016.174-.189.348-.378.52-.57 2.696-1.237 5.528-.673 8.323-.641.511.059.999.201 1.467.411.207.146.413.296.618.444.316.467.31.931-.017 1.392z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#6A8261"
        d="M146.209 280.748c.043-.31.131-.605.262-.889l1.03-.047c.174.182.348.364.526.543.25.443.415.917.508 1.417.196 2.248.383 4.498-.207 6.725a4.618 4.618 0 01-.875 1.218l.066.177-1.091-1.077c-.8-2.67-.49-5.369-.219-8.067z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#96B597"
        d="M146.209 280.748l.219 8.066a183.07 183.07 0 01-1.041-.099l.064-7.851.758-.116z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#8C9445"
        d="M165.455 269.946c.007.296.011.592.012.887-1.641 1.623-3.608 1.354-5.599.973a2.984 2.984 0 01-1.372-.972c-.014-.283-.028-.566-.044-.849l7.003-.039z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECD33E"
        d="M148.45 270.794l.955 1.251c.674 1.778 1.863.218 2.796.43.503.179.896.479 1.207.905 1.114 2.046 1.757 4.073-.194 6.017-2.024.942-3.94.988-5.644-.688.165-2.652-.844-5.436.88-7.915z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ADB780"
        d="M147.569 278.709l5.928-.065c.622-.161 1.036.063 1.242.673-.099.583-.413 1.003-.942 1.266-2.227.745-4.379.903-6.297-.794l.001.024.068-1.104z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C2B84E"
        d="M152.473 272.881c-.33-.02-.66-.035-.991-.047a1.733 1.733 0 01-.983-.966c2.16-1.826 4.615-.896 6.986-.748.206.435.149.832-.166 1.196a5.282 5.282 0 01-3.038 1.31c-.706.006-1.306-.252-1.808-.745z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ADC5A5"
        d="M157.331 271.938c.079-.27.13-.543.155-.82.335-.093.672-.188 1.009-.284.285.082.576.134.872.154.378.302.671.672.897 1.1.164.454.266.923.324 1.402.087 1.687.16 3.374-.16 5.05a3.802 3.802 0 01-.658 1.294l-.653.326a1.52 1.52 0 01-1.2-.651c-.927-1.986-.495-4.179-.947-6.241-.017-.48.106-.924.361-1.33z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EBD250"
        d="M150.499 271.869l.983.967c-.432.823-.982 1.985-1.927 1.624-1.106-.424.132-1.594-.15-2.415l1.094-.176z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5BBDDC"
        d="M377.336 152.867c.057 1.986.111 3.973.168 5.959-1.617-1.943-1.464-3.935-.168-5.959z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4AAFD4"
        d="M319.467 221.839c-.335-2.404-2.2-1.975-3.769-1.987-4.077-.031-8.154-.012-12.231-.013-.326-.19-.435-.382-.327-.573.107-.192.216-.288.326-.288l17.969.003-1.968 2.858z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C2E8ED"
        d="M338.217 151.917l.12 1.773c-.637 2.146-2.252 1.734-3.815 1.462-1.584-1.481-1.543-2.988-.071-4.518 1.357.128 2.779.067 3.766 1.283z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#58B9DD"
        d="M334.522 155.153c1.427-.085 2.823-.247 3.815-1.462l1.148 2.046c-2.458 1.568-5.08 2.974-6.045 6.037.234-1.91-.858-4.352 2.074-5.181l-.992-1.44z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#47B2D7"
        d="M303.466 218.978l.001.861c-5.303-.502-10.718 1.038-15.942-.878l15.941.017z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B8E6F2"
        d="M349.873 153.051c-.074 1.364-.863 2.504-2.254 2.588-1.404.084-1.648-1.532-1.894-2.49-.331-1.295.728-2.079 1.959-2.292 1.571-.273 1.844.959 2.189 2.194z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#71896F"
        d="M181.515 271.801c-.399.322-.798.644-1.199.965l-2.743.036c-.281-.158-.4-.348-.359-.567.044-.234.105-.353.184-.353l.134-1.012c1.379.097 2.906-.447 3.983.931z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C4C070"
        d="M177.398 271.882c.06.307.118.613.175.921l-.283.035c-2.466 2.25-5.064 1.69-7.7.365-.413-.43-.414-.863-.005-1.298l7.813-.023z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B2AA45"
        d="M159.547 271.864a12.75 12.75 0 01-.181-.877l6.1-.153 1.958.796c-.179.226-.357.452-.534.681-2.526 1.161-4.992 1.302-7.343-.447z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BDD5B1"
        d="M167.425 271.629c.308.034.616.062.926.082 1.339 1.74 1.466 3.807 1.59 5.879a2.094 2.094 0 01-.638 1.409c-.786.406-1.524.359-2.207-.231-1.076-1.733-.995-3.586-.567-5.476.209-.499.494-.954.846-1.366l.05-.297z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#597351"
        d="M169.313 277.801c-1.69-1.813-.371-4.101-.961-6.089.531-.703.916-.471 1.234.193-.079.32-.064.637.042.948 1.144 1.73 1.343 3.398-.315 4.948z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D9C239"
        d="M169.313 277.801l.314-4.946 7.665-.017 1.263 4.261-.186 1.707-1.884 1.199c-.41.194-.843.28-1.295.28-1.74-.332-3.585-.107-5.229-.97a36.874 36.874 0 01-.437-.514l-.211-1z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#A7ECDD"
        d="M175.606 279.876c.307-.052.599-.009.878.129-.329 2.9 2.023 6.111-1.005 8.699l-3.806.278c.002 0-.12-.24-.12-.24-2.259-2.769-1.236-5.199.766-7.534.695-.744 1.519-1.243 2.563-1.306l.724-.026z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DCC944"
        d="M173.726 281.196c-1.836 2.195-2.804 4.642-2.174 7.547l-2.001.129c-2.005-2.71-1.903-5.48-.242-8.298 1.613-.796 3.152-1.058 4.417.622z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5C7855"
        d="M167.446 289.68c-2.281.682-4.872-.774-6.993 1.011-.207.333-.506.482-.896.45-.498-.255-.644-.873-1.152-1.118l.114-.336c-.285-.457-.237-.876.142-1.26.411-.27.856-.462 1.332-.587 1.689-.281 3.389-.234 5.093-.137.746.073 1.447.281 2.075.705.143.2.283.403.424.606-.063.22-.108.442-.139.666z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5B7352"
        d="M169.508 280.947l.042 7.925-1.197-.091c-1.692-2.182-1.179-4.682-1.039-7.131a4.486 4.486 0 01.596-1.522c.2-.183.405-.364.608-.546l.813-.024c.488.406.547.87.177 1.389z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B5CDAD"
        d="M168.413 280.974l-.059 7.808a2.83 2.83 0 00-.771.233l-.177-.327c-1.001-1.057-1.191-2.373-1.21-3.747.001-1.359.055-2.71.854-3.895.427-.477.883-.502 1.363-.072z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECD344"
        d="M162.469 290.975l2.985-.038.011 5.798-3.008-.063c-1.565-1.902-1.529-3.8.012-5.697z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DCC735"
        d="M162.469 290.975l-.011 5.698-2.014.062c-1.642-2.266-.886-4.111 1.007-5.758l1.018-.002z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EDD140"
        d="M161.451 290.977l-1.006 5.758-.431.064-.436-.024c-.931-2-.978-3.994.033-5.982.288.026.568-.007.842-.101l.998.285z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BAD0AF"
        d="M159.61 290.792l-.033 5.982c-.384.015-.769.029-1.153.045l.007-5.892a6.213 6.213 0 00-.027-.905l1.206.77z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5E6E4B"
        d="M147.453 289.714c.022-.324.042-.648.059-.974 1.921-1.571 4.203-1.221 6.422-1.216 1.124.036 2.223.181 3.205.791.516.379.623.854.321 1.42-3.337-.006-6.672-.014-10.007-.021z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#597052"
        d="M157.458 289.736l-.048-1.038c-.479-.525-.829-1.117-.966-1.824-.186-1.137-.143-2.283-.125-3.429 0-.679.053-1.355.157-2.027.077-.449.222-.876.421-1.285.144-.173.292-.345.438-.517.44-.216.84-.145 1.204.175l-.032-.014c.354.458.654.948.907 1.47.467 2.578.915 5.156-.884 7.467a9.302 9.302 0 00-.012.974l-1.06.048z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E8D23F"
        d="M154.426 288.66l-6.915.081-.007-7.795c2.058-1.191 4.294-.335 6.434-.559 1.523.597 1.494 1.912 1.494 3.213-.103.896-.411 1.756-.569 2.642-.088.812.058 1.675-.437 2.418z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#657C5E"
        d="M154.473 280.989l-6.969-.043-.005-1.156 7.037-.107c.97-.695 1.921-.704 2.852.076l.019 1.193c-.969.723-1.948.723-2.934.037z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D8C12F"
        d="M152.473 272.881l1.995-.04c1.345 2.019 2.569 4.036-.018 6.043a4.97 4.97 0 01-.954-.238l-1.023-5.765z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ECD240"
        d="M154.45 278.884c1.089-2.012-.432-4.03.018-6.043l2.864-.904c.089.328.18.654.27.981.409 2.305.815 4.61-.212 6.871v-.031l-2.853-.075a21.2 21.2 0 00-.087-.799z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#EBD341"
        d="M167.331 272.92l.125 5.915c-.93.867-1.938.885-3.003.284-.908-1.137-.1-2.704-1.175-5.013.094.501-.302 1.612.231 1.213.744 1.34.627 2.643-.173 3.919-1.399.798-2.679.6-3.856-.454l.083-5.879c2.592-.88 5.181-.908 7.768.015z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#B5CEAC"
        d="M159.48 278.785l4-.122c.331-.336.658-.351.98.011l2.996.162 2.067-.032a.34.34 0 01.019-.019c.253.203.332.399.237.589-.092.187-.183.279-.272.279l-1.043.317c-3.036 1.243-6.064 2.254-8.984-.277a19.633 19.633 0 010-.908z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#597251"
        d="M159.479 279.693c2.995.092 5.989.185 8.984.276l-.051 1.005-.463-.077-.462.078c-2.335 1.666-4.906 1.317-7.489.88a5.766 5.766 0 01-1.479-.885l-.012-1.193c.332.063.656.035.972-.084z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#DBD26E"
        d="M167.331 272.92l-7.767-.016-.017-1.041c2.61.02 5.22.04 7.829.062.042.335.028.667-.045.995z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5E7852"
        d="M157.389 279.79l.212-6.871c1.776 2.091.375 4.616.938 6.872l-1.15-.001z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#AFBFA0"
        d="M169.507 279.653c-.018-.29-.006-.58.034-.868 2.011.418 4.316-.795 6.063 1.092l-.103.015c-2.018.71-4.047.597-6.083.088l.089-.327z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#5E6F4F"
        d="M169.419 279.979l6.082-.088c-.221.941-1.006 1.113-1.777 1.304l-4.216-.248a52.72 52.72 0 00-.089-.968z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E9D140"
        d="M159.43 280.99l8.057-.015-.178 3.819c-.172.647-1.208-.806-1.062.396.157 1.288.313 2.511-.801 3.479l-5.985.014c-.766-2.562-.719-5.127-.031-7.693z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E2C336"
        d="M165.447 288.668c.007-1.247-.114-2.51.047-3.736.343-2.616 1.193-.216 1.816-.138l.095 3.894-1.958-.02z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#BBD2B4"
        d="M159.43 280.99l.032 7.692-.464.083-.468-.052-.011-7.743c.306-.09.609-.084.911.02z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E3D645"
        d="M154.426 288.66l-.955-1.821c1.268-1.014 2.536-1.125 3.807-.006l.132 1.865-2.984-.038z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#F1D03B"
        d="M157.278 286.833l-3.807.006c.016-.824.193-1.567.996-1.999.886-.746.396-3.444 2.83-1.995l-.019 3.988z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E9D744"
        d="M157.297 282.844c-1.489-.109-1.799 1.454-2.83 1.995l.006-3.851 2.933-.037-.109 1.893z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#E2C531"
        d="M164.46 278.673l-.491.068-.49-.078v-3.732l.79-.052.191 3.794z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#D8C22E"
        d="M162.878 283.92c.581 1.076.941 2.072.049 2.978-.84-1.043-.271-2.058-.049-2.978z"
      />
    </Svg>
  )
}

export default SvgComponent
